
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("cXmqe", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkAnalyticsContext", () => $b567041aa6876b54$export$ac28ada90c4970b7);

var $fc4bM = parcelRequire("fc4bM");

var $fnEFU = parcelRequire("fnEFU");

var $6Ki2B = parcelRequire("6Ki2B");

var $16FEv = parcelRequire("16FEv");
const $b567041aa6876b54$export$ac28ada90c4970b7 = ({ display: display, id: id, source: source, url: url })=>{
    const { store: store } = (0, $fnEFU.useSmartLinkContext)();
    const state = store ? (0, $6Ki2B.getUrl)(store, url) : undefined;
    return (0, $fc4bM.useMemo)(()=>{
        return (0, $16FEv.getSmartLinkAnalyticsContext)({
            display: display,
            id: id,
            response: state === null || state === void 0 ? void 0 : state.details,
            source: source,
            status: state === null || state === void 0 ? void 0 : state.status,
            url: url,
            error: state === null || state === void 0 ? void 0 : state.error
        });
    }, [
        display,
        id,
        source,
        state === null || state === void 0 ? void 0 : state.details,
        state === null || state === void 0 ? void 0 : state.status,
        url,
        state === null || state === void 0 ? void 0 : state.error
    ]);
};

});

parcelRegister("c2F9z", function(module, exports) {
$parcel$export(module.exports, "isFlexibleUiCard", () => $73030cde69bef4fe$export$3c94e0f4719f5c2a);

var $fc4bM = parcelRequire("fc4bM");

var $4btJq = parcelRequire("4btJq");
const $73030cde69bef4fe$export$3c94e0f4719f5c2a = (children, ui)=>{
    if (ui !== null && ui !== void 0 && ui.removeBlockRestriction) {
        var _React$Children$toArr;
        return children && ((_React$Children$toArr = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.toArray(children)) === null || _React$Children$toArr === void 0 ? void 0 : _React$Children$toArr.length) > 0 ? true : false;
    }
    if (children && (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.toArray(children).some((child)=>(0, $4btJq.isFlexibleUiTitleBlock)(child))) return true;
    return false;
};

});
parcelRegister("4btJq", function(module, exports) {
$parcel$export(module.exports, "isFlexibleUiTitleBlock", () => $62efdd15d6c6124f$export$df0092b19156b140);

var $fc4bM = parcelRequire("fc4bM");

var $htqFW = parcelRequire("htqFW");

var $8AeTQ = parcelRequire("8AeTQ");
const $62efdd15d6c6124f$export$df0092b19156b140 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).isValidElement(node)) return false;
    if (node.type === (0, $htqFW.default)) return true;
    if ((0, $8AeTQ.isStyleCacheProvider)(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.map(node.props.children, (child)=>{
            var _child$type;
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && ((_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.name) !== 'Style') isChildrenValid = $62efdd15d6c6124f$export$df0092b19156b140(child);
        });
        return isChildrenValid;
    }
    return false;
};

});
parcelRegister("htqFW", function(module, exports) {
$parcel$export(module.exports, "default", () => $412db630217e3273$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $7xK5Q = parcelRequire("7xK5Q");
var $412db630217e3273$export$2e2bcd8739ae039 = (0, $7xK5Q.TitleBlock);

});
parcelRegister("7xK5Q", function(module, exports) {
$parcel$export(module.exports, "TitleBlock", () => $cbe04a12140bec0b$export$ccf187e9bb6e68c);
/* TitleBlock.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $dRkX9 = parcelRequire("dRkX9");

var $j9rqA = parcelRequire("j9rqA");

var $f1474 = parcelRequire("f1474");

var $bxLV6 = parcelRequire("bxLV6");

var $1fHg5 = parcelRequire("1fHg5");

var $kJrsj = parcelRequire("kJrsj");

var $kx9O1 = parcelRequire("kx9O1");

var $c3SUr = parcelRequire("c3SUr");

var $h1UmO = parcelRequire("h1UmO");
const $cbe04a12140bec0b$var$actionStyles = null;
const $cbe04a12140bec0b$var$getTitleBlockViewComponent = (status)=>{
    switch(status){
        case (0, $j9rqA.SmartLinkStatus).Pending:
        case (0, $j9rqA.SmartLinkStatus).Resolving:
            return 0, $h1UmO.default;
        case (0, $j9rqA.SmartLinkStatus).Resolved:
            return 0, $c3SUr.default;
        case (0, $j9rqA.SmartLinkStatus).Unauthorized:
        case (0, $j9rqA.SmartLinkStatus).Forbidden:
        case (0, $j9rqA.SmartLinkStatus).NotFound:
        case (0, $j9rqA.SmartLinkStatus).Errored:
        case (0, $j9rqA.SmartLinkStatus).Fallback:
        default:
            return 0, $kx9O1.default;
    }
};
const $cbe04a12140bec0b$export$ccf187e9bb6e68c = ({ actions: actions = [], anchorTarget: anchorTarget, hideTitleTooltip: hideTitleTooltip, maxLines: maxLines, onActionMenuOpenChange: onActionMenuOpenChange, showActionOnHover: showActionOnHover, testId: testId = 'smart-block-title', text: text, icon: icon, hideRetry: hideRetry, metadataPosition: metadataPosition, hideIcon: hideIcon = false, className: className, anchorRef: anchorRef, CompetitorPrompt: CompetitorPrompt, url: url, hideIconLoadingSkeleton: hideIconLoadingSkeleton, ...props })=>{
    var _cardContext$navigati;
    const cardContext = (0, $bxLV6.useFlexibleCardContext)();
    const { status: status = (0, $j9rqA.SmartLinkStatus).Fallback, ui: ui } = cardContext || {};
    const [actionDropdownOpen, setActionDropdownOpen] = (0, $fc4bM.useState)(false);
    const onDropdownOpenChange = (0, $fc4bM.useCallback)((isOpen)=>{
        setActionDropdownOpen(isOpen);
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    const actionGroup = actions.length > 0 && /*#__PURE__*/ $fc4bM.createElement((0, $kJrsj.default), {
        items: actions,
        visibleButtonsNum: showActionOnHover ? 1 : 2,
        onDropdownOpenChange: onDropdownOpenChange
    });
    const overrideText = !!text ? {
        text: text
    } : {};
    const onMouseDown = (0, $f1474.useMouseDownEvent)();
    const title = /*#__PURE__*/ $fc4bM.createElement((0, $1fHg5.default), {
        hideTooltip: hideTitleTooltip,
        maxLines: maxLines,
        onMouseDown: onMouseDown,
        target: (0, $dRkX9.fg)('confluence_ep_shim_macro_links_v2') ? anchorTarget ?? (cardContext === null || cardContext === void 0 || (_cardContext$navigati = cardContext.navigation) === null || _cardContext$navigati === void 0 ? void 0 : _cardContext$navigati.target) : anchorTarget,
        theme: ui === null || ui === void 0 ? void 0 : ui.theme,
        anchorRef: anchorRef,
        ...overrideText
    });
    const Component = $cbe04a12140bec0b$var$getTitleBlockViewComponent(status);
    return /*#__PURE__*/ $fc4bM.createElement(Component, {
        ...props,
        actionGroup: actionGroup,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $2R2iS.default)([
            showActionOnHover && !actionDropdownOpen && "_1bfhidpf _wn5xkb7n _h157kb7n",
            className
        ]),
        testId: testId,
        title: title,
        metadataPosition: metadataPosition,
        hideIcon: hideIcon,
        hideRetry: hideRetry,
        icon: icon,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton,
        size: props.size ?? (ui === null || ui === void 0 ? void 0 : ui.size),
        CompetitorPrompt: CompetitorPrompt,
        url: url
    });
};

});
parcelRegister("bxLV6", function(module, exports) {
$parcel$export(module.exports, "useFlexibleCardContext", () => $1b2250f401480da2$export$a8c4167e4e9f26ab);

var $fc4bM = parcelRequire("fc4bM");

var $1CO4o = parcelRequire("1CO4o");
const $1b2250f401480da2$export$a8c4167e4e9f26ab = ()=>(0, $fc4bM.useContext)((0, $1CO4o.FlexibleCardContext));

});
parcelRegister("1CO4o", function(module, exports) {
$parcel$export(module.exports, "FlexibleCardContext", () => $0fa453d57148ed11$export$13dde4423ab71d62);

var $fc4bM = parcelRequire("fc4bM");
const $0fa453d57148ed11$export$13dde4423ab71d62 = (0, $fc4bM.createContext)(undefined);

});


parcelRegister("1fHg5", function(module, exports) {
$parcel$export(module.exports, "default", () => $42123dbce5e8adda$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $dRkX9 = parcelRequire("dRkX9");

var $j9rqA = parcelRequire("j9rqA");

var $bxLV6 = parcelRequire("bxLV6");

var $eEPJn = parcelRequire("eEPJn");
const $42123dbce5e8adda$var$TitleElement = (props)=>{
    var _context$data, _context$navigation;
    const context = (0, $bxLV6.useFlexibleCardContext)();
    const data = context === null || context === void 0 || (_context$data = context.data) === null || _context$data === void 0 ? void 0 : _context$data.linkTitle;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eEPJn.default), {
        ...data,
        url: (0, $dRkX9.fg)('confluence_ep_shim_macro_links_v2') ? (context === null || context === void 0 || (_context$navigation = context.navigation) === null || _context$navigation === void 0 ? void 0 : _context$navigation.url) ?? data.url : data.url,
        ...props,
        name: (0, $j9rqA.ElementName).Title
    }) : null;
};
var $42123dbce5e8adda$export$2e2bcd8739ae039 = $42123dbce5e8adda$var$TitleElement;

});
parcelRegister("eEPJn", function(module, exports) {
$parcel$export(module.exports, "default", () => $14fc51d25e3e719c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $bcTS3 = parcelRequire("bcTS3");

var $j9rqA = parcelRequire("j9rqA");

var $f1474 = parcelRequire("f1474");

var $lGjOC = parcelRequire("lGjOC");
const $14fc51d25e3e719c$var$DEFAULT_MAX_LINES = 2;
const $14fc51d25e3e719c$var$MAXIMUM_MAX_LINES = 2;
const $14fc51d25e3e719c$var$MINIMUM_MAX_LINES = 1;
const $14fc51d25e3e719c$var$containerStyles = null;
const $14fc51d25e3e719c$var$getMaxLines = (maxLines)=>{
    if (maxLines > $14fc51d25e3e719c$var$MAXIMUM_MAX_LINES) return $14fc51d25e3e719c$var$DEFAULT_MAX_LINES;
    if (maxLines < $14fc51d25e3e719c$var$MINIMUM_MAX_LINES) return $14fc51d25e3e719c$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $14fc51d25e3e719c$var$withTooltip = (trigger, content, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bcTS3.default), {
        content: content,
        testId: `${testId}-tooltip`,
        tag: "span"
    }, trigger);
const $14fc51d25e3e719c$var$linkStyleSizeMap = {
    xlarge: "_11c81af2 _k48pi7a9 _vwz41k8s",
    large: "_11c8fhey _k48pi7a9 _vwz41j6v",
    medium: "_11c8fhey _k48pi7a9 _vwz41j6v",
    small: "_11c8wadc _k48pi7a9 _vwz41j6v"
};
const $14fc51d25e3e719c$var$baseAnchorStyle = null;
const $14fc51d25e3e719c$var$workBreakStyleMap = {
    true: "_1nmz1hna",
    false: "_1nmz9jpi"
};
const $14fc51d25e3e719c$var$anchorConstantsStyles = null;
const $14fc51d25e3e719c$var$anchorLineClampMap = {
    1: "_1yyjkb7n",
    2: "_1yyjcs5v"
};
const $14fc51d25e3e719c$var$anchorLinkLineHeight1Map = {
    xlarge: "_102k1k8s",
    large: "_102k1j6v",
    medium: "_102k1j6v",
    small: "_102k1j6v"
};
const $14fc51d25e3e719c$var$anchorLinkLineHeight2Map = {
    xlarge: "_102k1wto",
    large: "_102kviql",
    medium: "_102kviql",
    small: "_102kviql"
};
const $14fc51d25e3e719c$var$themeStyleMap = {
    grey: "_fjv61r31 _93u91r31 _g2lk1r31 _pnzf1r31 _hlwq8stv _1e2m8stv _1l4b8stv _ue8d8stv _yni7nqa1 _1bianqa1 _93jhnqa1 _64n6nqa1 _1ray1rpy _dlb71rpy _rnxt1rpy _1h4d1rpy _10uewadc _ye101rpy",
    black: "_syazazsu _1nrm1r31 _1a3b1r31 _9oik1r31 _1ydc1r31 _c2wa8stv _4fpr8stv _1bnx8stv _1x288stv _1iohnqa1 _5goinqa1 _jf4cnqa1 _1726nqa1 _9h8hazsu _f8pjazsu _30l3azsu _1053azsu",
    link: "_syaz13af _9oik1r31 _1bnx8stv _jf4cnqa1 _30l313af _9h8h12zz"
};
/**
 * A base element that represent an anchor.
 * @internal
 * @param {BaseLinkElementProps} BaseLinkElementProps - The props necessary for the Link element.
 * @see LinkIcon
 */ const $14fc51d25e3e719c$var$BaseLinkElement = ({ hideTooltip: hideTooltip, maxLines: maxLines = $14fc51d25e3e719c$var$DEFAULT_MAX_LINES, name: name, className: className, size: size = (0, $j9rqA.SmartLinkSize).Medium, testId: testId = 'smart-element-link', text: text, theme: theme = (0, $j9rqA.SmartLinkTheme).Link, url: url, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, target: target = '_blank', anchorRef: anchorRef })=>{
    const onMouseDown = (0, $f1474.useMouseDownEvent)();
    const hasSpace = (0, $fc4bM.useMemo)(()=>text ? (0, $lGjOC.hasWhiteSpace)(text) : false, [
        text
    ]);
    const anchor = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("a", {
        "data-smart-element": name,
        "data-smart-element-link": true,
        "data-testid": testId,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        onMouseDown: onMouseDown,
        href: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $2R2iS.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug",
            $14fc51d25e3e719c$var$linkStyleSizeMap[size],
            $14fc51d25e3e719c$var$anchorLineClampMap[$14fc51d25e3e719c$var$getMaxLines(maxLines)],
            "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _sudp1e54",
            $14fc51d25e3e719c$var$workBreakStyleMap[hasSpace ? 'true' : 'false'],
            $14fc51d25e3e719c$var$getMaxLines(maxLines) === 1 && $14fc51d25e3e719c$var$anchorLinkLineHeight1Map[size],
            $14fc51d25e3e719c$var$getMaxLines(maxLines) === 2 && $14fc51d25e3e719c$var$anchorLinkLineHeight2Map[size],
            $14fc51d25e3e719c$var$themeStyleMap[theme],
            className
        ]),
        ...target !== '_self' && {
            target: target
        },
        ref: anchorRef
    }, text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("span", {
        className: (0, $2R2iS.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug"
        ])
    }, hideTooltip || text === undefined ? anchor : $14fc51d25e3e719c$var$withTooltip(anchor, url !== null && url !== void 0 && url.includes(text) ? url : text, testId));
};
var $14fc51d25e3e719c$export$2e2bcd8739ae039 = $14fc51d25e3e719c$var$BaseLinkElement;

});
parcelRegister("lGjOC", function(module, exports) {
$parcel$export(module.exports, "hasWhiteSpace", () => $d6c8c3aabf43f5a2$export$619e376a425cb759);
const $d6c8c3aabf43f5a2$export$619e376a425cb759 = (str)=>{
    return str.search(/\s/) >= 0;
};

});



parcelRegister("kJrsj", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f8179d169398b0c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $fd880 = parcelRequire("fd880");

var $lHYHS = parcelRequire("lHYHS");

var $fRCnG = parcelRequire("fRCnG");

var $2Vha5 = parcelRequire("2Vha5");

var $gcxcG = parcelRequire("gcxcG");

var $bcTS3 = parcelRequire("bcTS3");

var $j9rqA = parcelRequire("j9rqA");

var $ewFKq = parcelRequire("ewFKq");

var $dweer = parcelRequire("dweer");

var $5QRjl = parcelRequire("5QRjl");

var $gysdQ = parcelRequire("gysdQ");

var $hcvQy = parcelRequire("hcvQy");

var $8NM7g = parcelRequire("8NM7g");

var $ltqsP = parcelRequire("ltqsP");
const $2f8179d169398b0c$var$styles = null;
const $2f8179d169398b0c$var$FULL_ACTIONS_SIZE = 450;
const $2f8179d169398b0c$var$REDUCED_ACTIONS_SIZE = 360;
const $2f8179d169398b0c$var$ICON_ONLY_ACTIONS_SIZE = 200;
const $2f8179d169398b0c$var$OVERFLOW_ONLY_ACTIONS_SIZE = 100;
const $2f8179d169398b0c$var$renderActionItems = (items = [], size = (0, $j9rqA.SmartLinkSize).Medium, appearance, asDropDownItems, onActionItemClick)=>items.map((item, idx)=>/*#__PURE__*/ $fc4bM.createElement((0, $ltqsP.default), {
            item: item,
            key: idx,
            size: size,
            appearance: appearance,
            asDropDownItems: asDropDownItems,
            onActionItemClick: onActionItemClick
        }));
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $2f8179d169398b0c$var$ActionGroup = ({ items: items = [], size: size = (0, $j9rqA.SmartLinkSize).Medium, appearance: appearance, visibleButtonsNum: visibleButtonsNum = 2, onDropdownOpenChange: onDropdownOpenChange, containerWidth: containerWidth = Infinity })=>{
    var _context$actions;
    const context = (0, $dweer.useFlexibleUiContext)();
    const ui = (0, $5QRjl.useFlexibleUiOptionContext)();
    const { product: product } = (0, $gysdQ.default)();
    const [isOpen, setIsOpen] = (0, $fc4bM.useState)(false);
    const renderableActionItems = (0, $fc4bM.useMemo)(()=>(0, $8NM7g.filterActionItems)(items, context, product), [
        context,
        items,
        product
    ]);
    const isMoreThenTwoItems = renderableActionItems.length > visibleButtonsNum;
    const rovoChatAction = context === null || context === void 0 || (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[(0, $j9rqA.ActionName).RovoChatAction];
    const isRovoActionsEnabled = (0, $fc4bM.useMemo)(()=>{
        return !!rovoChatAction && rovoChatAction.product === 'CONFLUENCE' && items.some((action)=>action.name === 'RovoChatAction');
    }, [
        rovoChatAction,
        items
    ]);
    const onOpenChange = (0, $fc4bM.useCallback)((attrs)=>{
        setIsOpen(attrs.isOpen);
        if (onDropdownOpenChange) onDropdownOpenChange(attrs.isOpen);
    }, [
        onDropdownOpenChange
    ]);
    const onActionItemClick = (0, $fc4bM.useCallback)(()=>{
        if (isOpen) onOpenChange({
            isOpen: false
        });
    }, [
        isOpen,
        onOpenChange
    ]);
    const actionButtons = (0, $fc4bM.useMemo)(()=>{
        if (isRovoActionsEnabled) {
            const rovoActions = [
                ...containerWidth >= $2f8179d169398b0c$var$REDUCED_ACTIONS_SIZE ? renderableActionItems.slice(0, visibleButtonsNum - 1) : [],
                ...containerWidth >= $2f8179d169398b0c$var$OVERFLOW_ONLY_ACTIONS_SIZE ? [
                    {
                        name: (0, $j9rqA.ActionName).RovoChatAction,
                        prompts: [
                            (0, $hcvQy.RovoChatPromptKey).ASK_ROVO_ANYTHING
                        ],
                        iconSize: 'small',
                        cardAppearance: (0, $j9rqA.CardDisplay).Block,
                        hideContent: containerWidth < $2f8179d169398b0c$var$FULL_ACTIONS_SIZE && containerWidth >= $2f8179d169398b0c$var$REDUCED_ACTIONS_SIZE || containerWidth < $2f8179d169398b0c$var$ICON_ONLY_ACTIONS_SIZE && containerWidth >= $2f8179d169398b0c$var$OVERFLOW_ONLY_ACTIONS_SIZE
                    },
                    {
                        name: (0, $j9rqA.ActionName).CopyLinkAction,
                        hideContent: true,
                        iconSize: 'small'
                    },
                    {
                        name: (0, $j9rqA.ActionName).PreviewAction,
                        hideContent: true,
                        iconSize: 'small'
                    }
                ] : []
            ];
            return $2f8179d169398b0c$var$renderActionItems(rovoActions, size, appearance, false, onActionItemClick);
        }
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(0, visibleButtonsNum - 1) : renderableActionItems;
        return $2f8179d169398b0c$var$renderActionItems(actionItems, size, appearance, false, onActionItemClick);
    }, [
        appearance,
        isMoreThenTwoItems,
        onActionItemClick,
        renderableActionItems,
        size,
        visibleButtonsNum,
        isRovoActionsEnabled,
        containerWidth
    ]);
    const moreActionDropdown = (0, $fc4bM.useMemo)(()=>{
        let actionItems;
        if (isRovoActionsEnabled && containerWidth < $2f8179d169398b0c$var$OVERFLOW_ONLY_ACTIONS_SIZE) actionItems = [
            ...renderableActionItems,
            {
                name: (0, $j9rqA.ActionName).RovoChatAction,
                prompts: [
                    (0, $hcvQy.RovoChatPromptKey).ASK_ROVO_ANYTHING
                ],
                iconSize: 'small',
                cardAppearance: (0, $j9rqA.CardDisplay).Block
            },
            {
                name: (0, $j9rqA.ActionName).CopyLinkAction,
                iconSize: 'small'
            },
            {
                name: (0, $j9rqA.ActionName).PreviewAction,
                iconSize: 'small'
            }
        ];
        else if (isRovoActionsEnabled && containerWidth < $2f8179d169398b0c$var$REDUCED_ACTIONS_SIZE) actionItems = renderableActionItems;
        else actionItems = isMoreThenTwoItems ? renderableActionItems.slice(visibleButtonsNum - 1) : [];
        if (actionItems.length > 0) {
            const formatMessage = /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $ewFKq.messages).more_actions);
            const moreIconAppearance = appearance !== 'subtle' ? 'default' : appearance;
            return /*#__PURE__*/ $fc4bM.createElement((0, $2Vha5.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $fc4bM.createElement((0, $bcTS3.default), {
                        content: formatMessage,
                        hideTooltipOnClick: true,
                        testId: "action-group-more-button-tooltip",
                        tag: "span"
                    }, /*#__PURE__*/ $fc4bM.createElement((0, $fRCnG.default), {
                        ...props,
                        spacing: size === (0, $j9rqA.SmartLinkSize).XLarge ? 'default' : 'compact',
                        testId: "action-group-more-button",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gcxcG))),
                        ref: triggerRef,
                        label: "more",
                        color: "currentColor",
                        ...isRovoActionsEnabled ? {
                            appearance: moreIconAppearance
                        } : {}
                    })),
                testId: "action-group-dropdown",
                zIndex: ui === null || ui === void 0 ? void 0 : ui.zIndex
            }, $2f8179d169398b0c$var$renderActionItems(actionItems, size, appearance, true, onActionItemClick));
        }
        return null;
    }, [
        appearance,
        isMoreThenTwoItems,
        isOpen,
        onActionItemClick,
        onOpenChange,
        renderableActionItems,
        size,
        ui === null || ui === void 0 ? void 0 : ui.zIndex,
        visibleButtonsNum,
        isRovoActionsEnabled,
        containerWidth
    ]);
    return renderableActionItems.length > 0 ? /*#__PURE__*/ $fc4bM.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $2R2iS.default)([
            "_1e0c116y _dzc21h6o _1ilq1i6y",
            "actions-button-group"
        ]),
        "data-action-open": isOpen
    }, /*#__PURE__*/ $fc4bM.createElement((0, $lHYHS.default), null, actionButtons, moreActionDropdown)) : null;
};
var $2f8179d169398b0c$export$2e2bcd8739ae039 = $2f8179d169398b0c$var$ActionGroup;

});
parcelRegister("dweer", function(module, exports) {
$parcel$export(module.exports, "useFlexibleUiContext", () => $39df1a67b55b497a$export$61d7957a243df7aa);

var $bxLV6 = parcelRequire("bxLV6");
const $39df1a67b55b497a$export$61d7957a243df7aa = ()=>{
    var _useFlexibleCardConte;
    return (_useFlexibleCardConte = (0, $bxLV6.useFlexibleCardContext)()) === null || _useFlexibleCardConte === void 0 ? void 0 : _useFlexibleCardConte.data;
};

});

parcelRegister("5QRjl", function(module, exports) {
$parcel$export(module.exports, "useFlexibleUiOptionContext", () => $592f1d35d33846e7$export$e6b5ad18b56e8f51);

var $bxLV6 = parcelRequire("bxLV6");
const $592f1d35d33846e7$export$e6b5ad18b56e8f51 = ()=>{
    var _useFlexibleCardConte;
    return (_useFlexibleCardConte = (0, $bxLV6.useFlexibleCardContext)()) === null || _useFlexibleCardConte === void 0 ? void 0 : _useFlexibleCardConte.ui;
};

});

parcelRegister("gysdQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $25f70e9b9f9fd987$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $fnEFU = parcelRequire("fnEFU");
const $25f70e9b9f9fd987$var$useRovoConfig = ()=>{
    const { rovoOptions: rovoOptions, product: product } = (0, $fnEFU.useSmartLinkContext)();
    return (0, $fc4bM.useMemo)(()=>({
            rovoOptions: rovoOptions,
            product: product
        }), [
        rovoOptions,
        product
    ]);
};
var $25f70e9b9f9fd987$export$2e2bcd8739ae039 = $25f70e9b9f9fd987$var$useRovoConfig;

});

parcelRegister("hcvQy", function(module, exports) {
$parcel$export(module.exports, "RovoChatPromptKey", () => $708c15351a694b04$export$a9f8723a23072cb8);
$parcel$export(module.exports, "getPromptAction", () => $708c15351a694b04$export$35d7b8e732470f9f);

var $fc4bM = parcelRequire("fc4bM");

var $6vADS = parcelRequire("6vADS");

var $lSZGi = parcelRequire("lSZGi");

var $7cjzH = parcelRequire("7cjzH");

var $j3PNU = parcelRequire("j3PNU");

var $k678R = parcelRequire("k678R");

var $j9rqA = parcelRequire("j9rqA");

var $ewFKq = parcelRequire("ewFKq");

var $1ZH5K = parcelRequire("1ZH5K");

var $hIaRZ = parcelRequire("hIaRZ");

var $8MDTq = parcelRequire("8MDTq");
var $708c15351a694b04$export$a9f8723a23072cb8 = /*#__PURE__*/ function(RovoChatPromptKey) {
    RovoChatPromptKey["SUMMARIZE_LINK"] = "summarize-link";
    RovoChatPromptKey["KEY_HIGHLIGHTS"] = "key-highlights";
    RovoChatPromptKey["ASK_ROVO_ANYTHING"] = "ask-rovo-anything";
    RovoChatPromptKey["IDENTIFY_KEY_POINTS"] = "identify-key-points";
    RovoChatPromptKey["IDENTIFY_KEY_TRENDS"] = "identify-key-trends";
    RovoChatPromptKey["FIND_OPEN_QUESTIONS"] = "find-open-questions";
    RovoChatPromptKey["HIGHLIGHT_RELEVANT_CONTENT"] = "highlight-relevant-content";
    RovoChatPromptKey["SUMMARIZE_THIS_FOR_ME"] = "summarize-this-for-me";
    RovoChatPromptKey["ASK_A_SPECIFIC_QUESTION"] = "ask-a-specific-question";
    RovoChatPromptKey["SHOW_ME_WHATS_RELEVANT"] = "show-me-whats-relevant";
    RovoChatPromptKey["SUMMARIZE_DOCUMENT"] = "summarize-document";
    RovoChatPromptKey["SUMMARIZE_PRESENTATION"] = "summarize-presentation";
    RovoChatPromptKey["EXPLAIN_CODE"] = "explain-code";
    RovoChatPromptKey["CATCH_UP"] = "catch-up";
    RovoChatPromptKey["SALESFORCE_PREP"] = "salesforce-prep";
    return RovoChatPromptKey;
}({});
const $708c15351a694b04$var$getContext = (intl, product)=>{
    switch(product){
        case 'CONFLUENCE':
            return {
                contextLong: intl.formatMessage((0, $ewFKq.messages).rovo_prompt_context_confluence_page)
            };
        case 'JSW':
        case 'JWM':
        case 'JSM':
        case 'JPD':
            return {
                contextLong: intl.formatMessage((0, $ewFKq.messages).rovo_prompt_context_jira_work_item)
            };
    }
};
const $708c15351a694b04$export$35d7b8e732470f9f = ({ promptKey: promptKey, intl: intl, url: url = '', product: product, iconSize: iconSize, cardAppearance: cardAppearance, provider: provider })=>{
    const { contextLong: contextLong } = $708c15351a694b04$var$getContext(intl, product) ?? {
        contextLong: intl.formatMessage((0, $ewFKq.messages).rovo_prompt_context_generic)
    };
    switch(promptKey){
        case "summarize-link":
            const label_summarize = intl.formatMessage((0, $ewFKq.messages).ai_summarize);
            const html_summarize = intl.formatMessage((0, $ewFKq.messages).rovo_prompt_message_summarize, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lSZGi))), {
                    label: label_summarize,
                    size: iconSize
                }),
                content: label_summarize,
                tooltipMessage: label_summarize,
                data: {
                    name: label_summarize,
                    dialogues: [],
                    prompt: (0, $8MDTq.default)(html_summarize),
                    mode: {
                        fastModeEnabled: true
                    }
                }
            };
        case "summarize-this-for-me":
            const label_summarize_this_for_me = intl.formatMessage((0, $ewFKq.messages).rovo_prompt_button_summarize_this);
            const html_summarize_this_for_me = intl.formatMessage((0, $ewFKq.messages).rovo_prompt_message_summarize, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7cjzH))), {
                    label: label_summarize_this_for_me
                }),
                content: label_summarize_this_for_me,
                tooltipMessage: label_summarize_this_for_me,
                data: {
                    name: label_summarize_this_for_me,
                    dialogues: [],
                    prompt: (0, $8MDTq.default)(html_summarize_this_for_me),
                    mode: {
                        fastModeEnabled: true
                    }
                }
            };
        case "highlight-relevant-content":
            const label_highlight_relevant_content = intl.formatMessage((0, $ewFKq.messages).rovo_prompt_button_highlight_relevant_content);
            const html_highlight_relevant_content = intl.formatMessage((0, $ewFKq.messages).rovo_prompt_message_highlight_relevant_content, {
                context: contextLong,
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1ZH5K.default), null),
                content: label_highlight_relevant_content,
                tooltipMessage: label_highlight_relevant_content,
                data: {
                    name: label_highlight_relevant_content,
                    dialogues: [],
                    prompt: (0, $8MDTq.default)(html_highlight_relevant_content),
                    mode: {
                        fastModeEnabled: true
                    }
                }
            };
        case "ask-rovo-anything":
            const label_ask_rovo_anything = intl.formatMessage((0, $ewFKq.messages).rovo_prompt_button_ask_rovo_anything);
            const prompt_ask_rovo_anything = intl.formatMessage((0, $ewFKq.messages).rovo_prompt_message_ask_rovo_anything, {
                url: url
            });
            return {
                icon: cardAppearance === (0, $j9rqA.CardDisplay).Block && !!product && product === 'CONFLUENCE' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $k678R.RovoIcon), {
                    label: label_ask_rovo_anything,
                    size: 'xxsmall'
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $hIaRZ.default), null),
                content: label_ask_rovo_anything,
                tooltipMessage: label_ask_rovo_anything,
                data: {
                    name: label_ask_rovo_anything,
                    dialogues: [],
                    prompt: prompt_ask_rovo_anything,
                    isPromptPlaceholder: true,
                    placeholderType: 'generic'
                }
            };
        case "ask-a-specific-question":
            const label_ask_a_specific_question = intl.formatMessage((0, $ewFKq.messages).rovo_prompt_button_ask_a_specific_question);
            const prompt_ask_a_specific_question = intl.formatMessage((0, $ewFKq.messages).rovo_prompt_message_ask_rovo_anything, {
                url: url
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j3PNU))), {
                    label: label_ask_a_specific_question
                }),
                content: label_ask_a_specific_question,
                tooltipMessage: label_ask_a_specific_question,
                data: {
                    name: label_ask_a_specific_question,
                    dialogues: [],
                    prompt: prompt_ask_a_specific_question,
                    isPromptPlaceholder: true,
                    placeholderType: 'generic'
                }
            };
        case "key-highlights":
            const label_key_highlights = intl.formatMessage((0, $ewFKq.messages).rovo_prompt_button_key_highlights);
            const html_key_highlights = intl.formatMessage((0, $ewFKq.messages).rovo_prompt_message_key_highlights, {
                context: contextLong,
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lSZGi))), {
                    label: label_key_highlights,
                    size: iconSize
                }),
                content: label_key_highlights,
                tooltipMessage: label_key_highlights,
                data: {
                    name: label_key_highlights,
                    dialogues: [],
                    prompt: (0, $8MDTq.default)(html_key_highlights)
                }
            };
        case "show-me-whats-relevant":
            const label_show_me_whats_relevant = intl.formatMessage((0, $ewFKq.messages).rovo_prompt_button_show_me_whats_relevant);
            const html_show_me_whats_relevant = intl.formatMessage((0, $ewFKq.messages).rovo_prompt_message_highlight_relevant_content, {
                context: contextLong,
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6vADS))), {
                    label: label_show_me_whats_relevant
                }),
                content: label_show_me_whats_relevant,
                tooltipMessage: label_show_me_whats_relevant,
                data: {
                    name: label_show_me_whats_relevant,
                    dialogues: [],
                    prompt: (0, $8MDTq.default)(html_show_me_whats_relevant)
                }
            };
        case "identify-key-trends":
            const label_identify_key_trends = intl.formatMessage((0, $ewFKq.messages).rovo_prompt_button_identify_key_trends);
            const html_identify_key_trends = intl.formatMessage((0, $ewFKq.messages).rovo_prompt_message_identify_key_trends, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lSZGi))), {
                    label: label_identify_key_trends,
                    size: iconSize
                }),
                content: label_identify_key_trends,
                tooltipMessage: label_identify_key_trends,
                data: {
                    name: label_identify_key_trends,
                    dialogues: [],
                    prompt: (0, $8MDTq.default)(html_identify_key_trends)
                }
            };
        case "identify-key-points":
            const label_identify_key_points = intl.formatMessage((0, $ewFKq.messages).rovo_prompt_button_identify_key_points);
            const html_identify_key_points = intl.formatMessage((0, $ewFKq.messages).rovo_prompt_message_identify_key_points, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lSZGi))), {
                    label: label_identify_key_points,
                    size: iconSize
                }),
                content: label_identify_key_points,
                tooltipMessage: label_identify_key_points,
                data: {
                    name: label_identify_key_points,
                    dialogues: [],
                    prompt: (0, $8MDTq.default)(html_identify_key_points)
                }
            };
        case "find-open-questions":
            const label_find_open_questions = intl.formatMessage((0, $ewFKq.messages).rovo_prompt_button_find_open_questions);
            const html_find_open_questions = intl.formatMessage((0, $ewFKq.messages).rovo_prompt_message_find_open_questions, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lSZGi))), {
                    label: label_find_open_questions,
                    size: iconSize
                }),
                content: label_find_open_questions,
                tooltipMessage: label_find_open_questions,
                data: {
                    name: label_find_open_questions,
                    dialogues: [],
                    prompt: (0, $8MDTq.default)(html_find_open_questions)
                }
            };
        case "summarize-document":
            const label_summarize_document = intl.formatMessage((0, $ewFKq.messages).ai_summarize);
            const html_summarize_document = intl.formatMessage((0, $ewFKq.messages).rovo_prompt_message_summarize_document, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                content: label_summarize_document,
                tooltipMessage: label_summarize_document,
                data: {
                    name: label_summarize_document,
                    dialogues: [],
                    prompt: (0, $8MDTq.default)(html_summarize_document)
                },
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7cjzH))), {
                    label: label_summarize_document,
                    size: iconSize
                })
            };
        case "summarize-presentation":
            const label_summarize_presentation = intl.formatMessage((0, $ewFKq.messages).ai_summarize);
            const html_summarize_presentation = intl.formatMessage((0, $ewFKq.messages).rovo_prompt_message_summarize_presentation, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                content: label_summarize_presentation,
                tooltipMessage: label_summarize_presentation,
                data: {
                    name: label_summarize_presentation,
                    dialogues: [],
                    prompt: (0, $8MDTq.default)(html_summarize_presentation)
                },
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7cjzH))), {
                    label: label_summarize_presentation,
                    size: iconSize
                })
            };
        case "explain-code":
            const label_explain_code = intl.formatMessage((0, $ewFKq.messages).rovo_prompt_button_explain_code);
            const html_explain_code = intl.formatMessage((0, $ewFKq.messages).rovo_prompt_message_explain_code, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                content: label_explain_code,
                tooltipMessage: label_explain_code,
                data: {
                    name: label_explain_code,
                    dialogues: [],
                    prompt: (0, $8MDTq.default)(html_explain_code)
                },
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7cjzH))), {
                    label: label_explain_code,
                    size: iconSize
                })
            };
        case "catch-up":
            const label_catch_up = intl.formatMessage((0, $ewFKq.messages).rovo_prompt_button_catch_up);
            const html_catch_up = intl.formatMessage((0, $ewFKq.messages).rovo_prompt_message_catch_up, {
                url: url,
                provider: provider
            }, {
                ignoreTag: true
            });
            return {
                content: label_catch_up,
                tooltipMessage: label_catch_up,
                data: {
                    name: label_catch_up,
                    dialogues: [],
                    prompt: (0, $8MDTq.default)(html_catch_up)
                },
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7cjzH))), {
                    label: label_catch_up,
                    size: iconSize
                })
            };
        case "salesforce-prep":
            const label_overview = intl.formatMessage((0, $ewFKq.messages).rovo_prompt_button_salesforce_prep);
            const html_overview = intl.formatMessage((0, $ewFKq.messages).rovo_prompt_message_salesforce_prep, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                content: label_overview,
                tooltipMessage: label_overview,
                data: {
                    name: label_overview,
                    dialogues: [],
                    prompt: (0, $8MDTq.default)(html_overview)
                },
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7cjzH))), {
                    label: label_overview,
                    size: iconSize
                })
            };
    }
};

});
parcelRegister("6vADS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::28569a1ba0e49d9b1ede9e97db5921f7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4bd20fb50b628f7f$var$_react = $4bd20fb50b628f7f$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $4bd20fb50b628f7f$var$_iconNew = $4bd20fb50b628f7f$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $4bd20fb50b628f7f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiSearch".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/ai-search
 * Usage guidance:
 * Reserved for search interactions powered by Rovo/AI.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4bd20fb50b628f7f$var$AiSearchIcon = (props)=>/*#__PURE__*/ $4bd20fb50b628f7f$var$_react.default.createElement($4bd20fb50b628f7f$var$_iconNew.default, Object.assign({
        name: "AiSearchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6 2.612A4.501 4.501 0 0 0 7 11.5a4.48 4.48 0 0 0 3.182-1.318A4.5 4.5 0 0 0 11.387 8h1.53a6 6 0 0 1-1.179 2.678l3.292 3.292-1.06 1.06-3.292-3.292A6 6 0 1 1 6 1.084z"/><path fill="currentcolor" d="M14 3.25a.75.75 0 0 1-.493.705l-1.285.469a.5.5 0 0 0-.298.298l-.469 1.285a.75.75 0 0 1-1.41 0l-.469-1.285a.5.5 0 0 0-.298-.298l-1.285-.469a.75.75 0 0 1-.484-.589L7.5 3.25l.009-.116a.75.75 0 0 1 .484-.59l1.285-.468a.5.5 0 0 0 .298-.298l.469-1.285.049-.106A.75.75 0 0 1 10.749 0l.116.009a.75.75 0 0 1 .541.378l.05.106.468 1.285a.5.5 0 0 0 .298.298l1.285.469A.75.75 0 0 1 14 3.25"/>`
    }, props));
$4bd20fb50b628f7f$var$AiSearchIcon.displayName = 'AiSearchIcon';
var $4bd20fb50b628f7f$var$_default = module.exports.default = $4bd20fb50b628f7f$var$AiSearchIcon;

});

parcelRegister("1ZH5K", function(module, exports) {
$parcel$export(module.exports, "default", () => $c54c3648faf833ed$export$2e2bcd8739ae039);
/* ai-chapter-icon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $c54c3648faf833ed$var$style = {
    foreignObject: "_11q7hndj _4t3i1osq _1bsb1osq _tzy4kb7n"
};
const $c54c3648faf833ed$var$AiChapterIcon = (props)=>/*#__PURE__*/ $fc4bM.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ $fc4bM.createElement("g", {
        clipPath: "url(#paint0_angular_1804_15128_clip_path)",
        "data-figma-skip-parse": "true"
    }, /*#__PURE__*/ $fc4bM.createElement("g", {
        transform: "matrix(0.008 -0.00939228 0.0100184 0.0075 12 12.5)"
    }, /*#__PURE__*/ $fc4bM.createElement("foreignObject", {
        x: "-1047.5",
        y: "-1047.5",
        width: "2095.01",
        height: "2095.01"
    }, /*#__PURE__*/ $fc4bM.createElement("div", {
        className: (0, $2R2iS.default)([
            $c54c3648faf833ed$var$style.foreignObject
        ])
    })))), /*#__PURE__*/ $fc4bM.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.5 6.5V16.5H11.2495V18H5.375C4.61561 18 4 17.3844 4 16.625V6.375C4 5.6175 4.61251 5 5.37379 5L8.8749 5.00001C10.1576 5.00001 11.2947 5.6232 11.9999 6.58333C12.7053 5.62319 13.8425 5.00001 15.1251 5.00001L18.6253 5C19.3874 5 20 5.61967 20 6.37637V12.25H18.5V6.50082L15.1251 6.50001C13.8134 6.50001 12.7499 7.56337 12.7499 8.87496V14H11.2499V8.87498C11.2499 7.56332 10.1866 6.50001 8.8749 6.50001L5.5 6.5ZM17.2495 10H14.4995V8.5H17.2495V10ZM6.75049 8.50001H9.50049V10H6.75049V8.50001ZM6.75049 11H9.50049V12.5H6.75049V11ZM15.7945 13.4943C15.9025 13.1982 16.184 13.0013 16.4991 13.0013C16.8142 13.0013 17.0962 13.1982 17.2042 13.4943L17.8193 15.1807L19.5057 15.7958C19.8017 15.9038 19.9987 16.1853 19.9987 16.5004C19.9987 16.8155 19.8017 17.0975 19.5057 17.2055L17.8193 17.8206L17.2042 19.507C17.0962 19.803 16.8147 20 16.4996 20C16.1845 20 15.9025 19.803 15.7945 19.507L15.1794 17.8206L13.493 17.2055C13.197 17.0975 13 16.816 13 16.5009C13 16.1858 13.197 15.9038 13.493 15.7958L15.1794 15.1807L15.7945 13.4943Z",
        "data-figma-gradient-fill": '{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"transform":{"m00":16.000001907348633,"m01":20.036861419677734,"m02":-6.0184345245361328,"m10":-18.784559249877930,"m11":15.000002861022949,"m12":14.392276763916016},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
    }), /*#__PURE__*/ $fc4bM.createElement("defs", null, /*#__PURE__*/ $fc4bM.createElement("clipPath", {
        id: "paint0_angular_1804_15128_clip_path"
    }, /*#__PURE__*/ $fc4bM.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.5 6.5V16.5H11.2495V18H5.375C4.61561 18 4 17.3844 4 16.625V6.375C4 5.6175 4.61251 5 5.37379 5L8.8749 5.00001C10.1576 5.00001 11.2947 5.6232 11.9999 6.58333C12.7053 5.62319 13.8425 5.00001 15.1251 5.00001L18.6253 5C19.3874 5 20 5.61967 20 6.37637V12.25H18.5V6.50082L15.1251 6.50001C13.8134 6.50001 12.7499 7.56337 12.7499 8.87496V14H11.2499V8.87498C11.2499 7.56332 10.1866 6.50001 8.8749 6.50001L5.5 6.5ZM17.2495 10H14.4995V8.5H17.2495V10ZM6.75049 8.50001H9.50049V10H6.75049V8.50001ZM6.75049 11H9.50049V12.5H6.75049V11ZM15.7945 13.4943C15.9025 13.1982 16.184 13.0013 16.4991 13.0013C16.8142 13.0013 17.0962 13.1982 17.2042 13.4943L17.8193 15.1807L19.5057 15.7958C19.8017 15.9038 19.9987 16.1853 19.9987 16.5004C19.9987 16.8155 19.8017 17.0975 19.5057 17.2055L17.8193 17.8206L17.2042 19.507C17.0962 19.803 16.8147 20 16.4996 20C16.1845 20 15.9025 19.803 15.7945 19.507L15.1794 17.8206L13.493 17.2055C13.197 17.0975 13 16.816 13 16.5009C13 16.1858 13.197 15.9038 13.493 15.7958L15.1794 15.1807L15.7945 13.4943Z"
    }))));
$c54c3648faf833ed$var$AiChapterIcon.displayName = 'AiChapterIcon';
var $c54c3648faf833ed$export$2e2bcd8739ae039 = $c54c3648faf833ed$var$AiChapterIcon;

});

parcelRegister("hIaRZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ed5d2f9d001192c$export$2e2bcd8739ae039);
/* ai-search-icon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $8ed5d2f9d001192c$var$style = {
    foreignObject: "_11q7hndj _4t3i1osq _1bsb1osq _tzy4kb7n"
};
const $8ed5d2f9d001192c$var$AiSearchIcon = (props)=>/*#__PURE__*/ $fc4bM.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ $fc4bM.createElement("g", {
        clipPath: "url(#paint0_angular_1804_8080_clip_path)",
        "data-figma-skip-parse": "true"
    }, /*#__PURE__*/ $fc4bM.createElement("g", {
        transform: "matrix(0.00701514 -0.00941124 0.00878508 0.00751514 12.0151 11.5151)"
    }, /*#__PURE__*/ $fc4bM.createElement("foreignObject", {
        x: "-1058.95",
        y: "-1058.95",
        width: "2117.91",
        height: "2117.91"
    }, /*#__PURE__*/ $fc4bM.createElement("div", {
        className: (0, $2R2iS.default)([
            $8ed5d2f9d001192c$var$style.foreignObject
        ])
    })))), /*#__PURE__*/ $fc4bM.createElement("path", {
        d: "M10 6.6123C7.9961 7.0671 6.5 8.85847 6.5 11C6.5 13.4853 8.51472 15.5 11 15.5C12.2428 15.5 13.3665 14.9968 14.1816 14.1816C14.7712 13.5921 15.1959 12.8407 15.3867 12H16.917C16.7489 12.9977 16.3336 13.9117 15.7383 14.6777L19.0303 17.9697L17.9697 19.0303L14.6777 15.7383C13.662 16.5276 12.3862 17 11 17C7.68629 17 5 14.3137 5 11C5 8.02706 7.16237 5.56013 10 5.08398V6.6123Z",
        "data-figma-gradient-fill": '{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"transform":{"m00":14.030276298522949,"m01":17.570167541503906,"m02":-3.7850868701934814,"m10":-18.822471618652344,"m11":15.030277252197266,"m12":13.411232948303223},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
    }), /*#__PURE__*/ $fc4bM.createElement("g", {
        clipPath: "url(#paint1_angular_1804_8080_clip_path)",
        "data-figma-skip-parse": "true"
    }, /*#__PURE__*/ $fc4bM.createElement("g", {
        transform: "matrix(0.00701514 -0.00941124 0.00878508 0.00751514 12.0151 11.5151)"
    }, /*#__PURE__*/ $fc4bM.createElement("foreignObject", {
        x: "-1058.95",
        y: "-1058.95",
        width: "2117.91",
        height: "2117.91"
    }, /*#__PURE__*/ $fc4bM.createElement("div", {
        className: (0, $2R2iS.default)([
            $8ed5d2f9d001192c$var$style.foreignObject
        ])
    })))), /*#__PURE__*/ $fc4bM.createElement("path", {
        d: "M18 7.25C18 7.56523 17.803 7.84705 17.5068 7.95508L16.2217 8.42383C16.0833 8.4744 15.9744 8.58332 15.9238 8.72168L15.4551 10.0068C15.3471 10.3029 15.0653 10.5 14.75 10.5C14.4348 10.5 14.1529 10.303 14.0449 10.0068L13.5762 8.72168C13.5256 8.58332 13.4167 8.4744 13.2783 8.42383L11.9932 7.95508C11.7338 7.86049 11.5505 7.63274 11.5088 7.36621L11.5 7.25L11.5088 7.13379C11.5505 6.86715 11.734 6.63947 11.9932 6.54492L13.2783 6.07617C13.4167 6.0256 13.5256 5.91668 13.5762 5.77832L14.0449 4.49316L14.0938 4.38672C14.2242 4.15114 14.4736 4.00036 14.749 4L14.8652 4.00879C15.0941 4.04428 15.2941 4.18415 15.4062 4.38672L15.4551 4.49316L15.9238 5.77832C15.9744 5.91668 16.0833 6.0256 16.2217 6.07617L17.5068 6.54492C17.8031 6.65301 18 6.93494 18 7.25Z",
        "data-figma-gradient-fill": '{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"transform":{"m00":14.030276298522949,"m01":17.570167541503906,"m02":-3.7850868701934814,"m10":-18.822471618652344,"m11":15.030277252197266,"m12":13.411232948303223},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
    }), /*#__PURE__*/ $fc4bM.createElement("defs", null, /*#__PURE__*/ $fc4bM.createElement("clipPath", {
        id: "paint0_angular_1804_8080_clip_path"
    }, /*#__PURE__*/ $fc4bM.createElement("path", {
        d: "M10 6.6123C7.9961 7.0671 6.5 8.85847 6.5 11C6.5 13.4853 8.51472 15.5 11 15.5C12.2428 15.5 13.3665 14.9968 14.1816 14.1816C14.7712 13.5921 15.1959 12.8407 15.3867 12H16.917C16.7489 12.9977 16.3336 13.9117 15.7383 14.6777L19.0303 17.9697L17.9697 19.0303L14.6777 15.7383C13.662 16.5276 12.3862 17 11 17C7.68629 17 5 14.3137 5 11C5 8.02706 7.16237 5.56013 10 5.08398V6.6123Z"
    })), /*#__PURE__*/ $fc4bM.createElement("clipPath", {
        id: "paint1_angular_1804_8080_clip_path"
    }, /*#__PURE__*/ $fc4bM.createElement("path", {
        d: "M18 7.25C18 7.56523 17.803 7.84705 17.5068 7.95508L16.2217 8.42383C16.0833 8.4744 15.9744 8.58332 15.9238 8.72168L15.4551 10.0068C15.3471 10.3029 15.0653 10.5 14.75 10.5C14.4348 10.5 14.1529 10.303 14.0449 10.0068L13.5762 8.72168C13.5256 8.58332 13.4167 8.4744 13.2783 8.42383L11.9932 7.95508C11.7338 7.86049 11.5505 7.63274 11.5088 7.36621L11.5 7.25L11.5088 7.13379C11.5505 6.86715 11.734 6.63947 11.9932 6.54492L13.2783 6.07617C13.4167 6.0256 13.5256 5.91668 13.5762 5.77832L14.0449 4.49316L14.0938 4.38672C14.2242 4.15114 14.4736 4.00036 14.749 4L14.8652 4.00879C15.0941 4.04428 15.2941 4.18415 15.4062 4.38672L15.4551 4.49316L15.9238 5.77832C15.9744 5.91668 16.0833 6.0256 16.2217 6.07617L17.5068 6.54492C17.8031 6.65301 18 6.93494 18 7.25Z"
    }))));
$8ed5d2f9d001192c$var$AiSearchIcon.displayName = 'AiSearchIcon';
var $8ed5d2f9d001192c$export$2e2bcd8739ae039 = $8ed5d2f9d001192c$var$AiSearchIcon;

});

parcelRegister("8MDTq", function(module, exports) {
$parcel$export(module.exports, "default", () => $73438783f189048d$export$2e2bcd8739ae039);
/**
 * This is a simplified version of html to adf conversion,
 * used specifically for SL RovoChatAction prompt message,
 * and does not support all ADF offered via @atlaskit/adf-utils
 *
 * Support: p, ul, li, text, b, strong, code, inlineCard (replace a hyperlink)
 */ 
var $cArhM = parcelRequire("cArhM");

var $gYlrZ = parcelRequire("gYlrZ");

var $j2vls = parcelRequire("j2vls");

var $iXSgY = parcelRequire("iXSgY");

var $hLA7A = parcelRequire("hLA7A");

var $f5LPR = parcelRequire("f5LPR");

var $eIlG3 = parcelRequire("eIlG3");

var $2VxTd = parcelRequire("2VxTd");
const $73438783f189048d$var$INLINE_TAG_NAMES = [
    'b',
    'strong',
    'code',
    'a',
    'inlineCard'
];
const $73438783f189048d$var$BLOCK_TAG_NAMES = [
    'p',
    'ul',
    'ol',
    'li'
];
/**
 *   Group      Captures                Example
 *  ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 *   match[1]   Self-closing tag name   br from <br/> or <img src="x"/>
 *   match[2]   Opening tag name        div from <div> or <div class="x">
 *   match[3]   Closing tag name        div from </div>
 *   match[4]   Text content            Hello world
 */ const $73438783f189048d$var$htmlRegex = /<\s*(\w+)[^>]*?\s*\/\s*>|<\s*(\w+)[^>]*>|<\s*\/\s*(\w+)\s*>|([^<]+)/g;
const $73438783f189048d$var$decodeHtmlEntities = (text = '')=>{
    return text.replace(/&nbsp;/g, ' ').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&#39;/g, "'");
};
const $73438783f189048d$var$tokenizeHtml = (html)=>{
    const tokens = [];
    let match;
    while((match = $73438783f189048d$var$htmlRegex.exec(html)) !== null){
        const selfClosingTag = match[1];
        const openingTag = match[2];
        const closingTag = match[3];
        const textContent = match[4];
        if (selfClosingTag) tokens.push({
            type: 'selfClosing',
            tagName: selfClosingTag.toLowerCase()
        });
        else if (openingTag) tokens.push({
            type: 'open',
            tagName: openingTag.toLowerCase()
        });
        else if (closingTag) tokens.push({
            type: 'close',
            tagName: closingTag.toLowerCase()
        });
        else if (textContent) {
            if (textContent !== null && textContent !== void 0 && textContent.trim()) tokens.push({
                type: 'text',
                content: $73438783f189048d$var$decodeHtmlEntities(textContent)
            });
        }
    }
    return tokens;
};
const $73438783f189048d$var$buildListItem = (content = [])=>{
    // Check if content has only text/inline elements
    const hasOnlyInlineContent = content.every((node)=>node.type === 'text' || node.type === 'hardBreak' || !node.type);
    if (hasOnlyInlineContent) // Wrap text content in a paragraph
    return (0, $hLA7A.listItem)([
        (0, $f5LPR.paragraph)(...content)
    ]);
    // Content has block elements (like nested lists), use as-is
    return (0, $hLA7A.listItem)(content);
};
const $73438783f189048d$var$blockToAdf = (tagName, content = [])=>{
    switch(tagName){
        case 'p':
            return (0, $f5LPR.paragraph)(...content);
        case 'ul':
            return (0, $cArhM.bulletList)(...content);
        case 'li':
            return $73438783f189048d$var$buildListItem(content);
    }
};
const $73438783f189048d$var$inlineToAdf = (tagName, content)=>{
    switch(tagName){
        case 'b':
        case 'strong':
            return (0, $eIlG3.strong)(content);
        case 'code':
            return (0, $gYlrZ.code)(content);
        case 'a':
        case 'inlineCard':
            return (0, $iXSgY.inlineCard)({
                url: content
            });
        default:
            return (0, $2VxTd.text)(content);
    }
};
const $73438783f189048d$var$parseTokensToAdf = (tokens)=>{
    const stack = [
        {
            type: 'root',
            content: []
        }
    ];
    let currentMarks = [];
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        const current = stack[stack.length - 1];
        switch(token.type){
            case 'text':
                if (token.content) {
                    var _currentMarks;
                    const inlineAdfNode = $73438783f189048d$var$inlineToAdf((_currentMarks = currentMarks) === null || _currentMarks === void 0 || (_currentMarks = _currentMarks[0]) === null || _currentMarks === void 0 ? void 0 : _currentMarks.type, token.content);
                    current.content.push(inlineAdfNode);
                }
                break;
            case 'open':
                if ($73438783f189048d$var$INLINE_TAG_NAMES.includes(token.tagName)) currentMarks.push({
                    type: token.tagName
                });
                else if ($73438783f189048d$var$BLOCK_TAG_NAMES.includes(token.tagName)) stack.push({
                    type: token.tagName,
                    content: []
                });
                break;
            case 'close':
                // Inline formatting
                if (token.tagName && $73438783f189048d$var$INLINE_TAG_NAMES.includes(token.tagName)) currentMarks = currentMarks.filter((m)=>m.type !== token.tagName);
                else if (stack.length > 1) {
                    const closed = stack.pop();
                    const parent = stack[stack.length - 1];
                    const adfNode = $73438783f189048d$var$blockToAdf(closed === null || closed === void 0 ? void 0 : closed.type, closed === null || closed === void 0 ? void 0 : closed.content);
                    if (adfNode) parent.content.push(adfNode);
                }
                break;
        }
    }
    // Return root content
    return stack[0].content;
};
/**
 * Convert HTML string to ADF format
 *
 * This is a simplified version specific for RovoChatAction prompt message
 * and does not support all ADF offered via @atlaskit/adf-utils
 */ const $73438783f189048d$var$htmlToAdf = (html)=>{
    try {
        const tokens = $73438783f189048d$var$tokenizeHtml(html);
        const adfContent = $73438783f189048d$var$parseTokensToAdf(tokens);
        return (0, $j2vls.doc)(...adfContent);
    } catch  {
        return html;
    }
};
var $73438783f189048d$export$2e2bcd8739ae039 = $73438783f189048d$var$htmlToAdf;

});
parcelRegister("cArhM", function(module, exports) {
$parcel$export(module.exports, "bulletList", () => $9ae19daeb3c911ef$export$a140c94e5ea26bee);
const $9ae19daeb3c911ef$export$a140c94e5ea26bee = (...content)=>({
        type: 'bulletList',
        content: content
    });

});

parcelRegister("gYlrZ", function(module, exports) {
$parcel$export(module.exports, "code", () => $e589bdb6c34c05a6$export$6565f9f03506010b);

var $6uC41 = parcelRequire("6uC41");
const $e589bdb6c34c05a6$export$6565f9f03506010b = (maybeNode)=>(0, $6uC41.applyMark)({
        type: 'code'
    }, maybeNode);

});
parcelRegister("6uC41", function(module, exports) {
$parcel$export(module.exports, "applyMark", () => $f2208b6afc5de322$export$50d34f59d07755a2);

var $2VxTd = parcelRequire("2VxTd");

var $lqoJq = parcelRequire("lqoJq");

var $ggix2 = parcelRequire("ggix2");
function $f2208b6afc5de322$export$50d34f59d07755a2(mark, maybeNode) {
    const node = typeof maybeNode === 'string' ? (0, $2VxTd.text)(maybeNode) : maybeNode;
    if ((0, $ggix2.isDuplicateMark)(node, mark.type)) {
        // eslint-disable-next-line no-console
        console.error((0, $lqoJq.duplicateMarkError)(node, mark.type));
        return node;
    }
    node.marks = node.marks || [];
    node.marks.push(mark);
    return node;
}

});
parcelRegister("lqoJq", function(module, exports) {
$parcel$export(module.exports, "duplicateMarkError", () => $5543f17adb70de83$export$db1000b9ac08ce57);
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5543f17adb70de83$export$db1000b9ac08ce57(node, type) {
    return `Mark with the same name '${type}' already exists on a node: ${JSON.stringify(node)}`;
}

});

parcelRegister("ggix2", function(module, exports) {
$parcel$export(module.exports, "isDuplicateMark", () => $ec95017db0524314$export$5ec47a80d7cc0dfa);
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ec95017db0524314$export$5ec47a80d7cc0dfa(node, type) {
    if (node.marks && node.marks.some((mark)=>mark.type === type)) return true;
    return false;
}

});



parcelRegister("iXSgY", function(module, exports) {
$parcel$export(module.exports, "inlineCard", () => $b67653c52659f372$export$cbf8224b64e0d942);
const $b67653c52659f372$export$cbf8224b64e0d942 = (attrs)=>({
        type: 'inlineCard',
        attrs: attrs
    });

});

parcelRegister("hLA7A", function(module, exports) {
$parcel$export(module.exports, "listItem", () => $259d407444c24579$export$76c7e83ecc9cdf05);
const $259d407444c24579$export$76c7e83ecc9cdf05 = (content)=>({
        type: 'listItem',
        content: content
    });

});

parcelRegister("eIlG3", function(module, exports) {
$parcel$export(module.exports, "strong", () => $71d8aebb2628e19d$export$59ae2c325a998f89);

var $6uC41 = parcelRequire("6uC41");
const $71d8aebb2628e19d$export$59ae2c325a998f89 = (maybeNode)=>(0, $6uC41.applyMark)({
        type: 'strong'
    }, maybeNode);

});



parcelRegister("8NM7g", function(module, exports) {
$parcel$export(module.exports, "filterActionItems", () => $51721bf2b7cb38a6$export$adbd04236f07a7d8);

var $j9rqA = parcelRequire("j9rqA");
const $51721bf2b7cb38a6$export$adbd04236f07a7d8 = (items = [], context, product)=>{
    return items.filter((item)=>{
        switch(item.name){
            case (0, $j9rqA.ActionName).DeleteAction:
            case (0, $j9rqA.ActionName).EditAction:
            case (0, $j9rqA.ActionName).CustomAction:
                // Named and custom actions that user defines.
                return Boolean((0, $j9rqA.ActionName)[item.name]);
            case (0, $j9rqA.ActionName).RovoChatAction:
                if (!!product && product === 'CONFLUENCE') return Boolean((0, $j9rqA.ActionName)[item.name]);
                // same as default case below
                if ((context === null || context === void 0 ? void 0 : context.actions) === undefined) return false;
                return Boolean(item.name in context.actions ? context.actions[item.name] : undefined);
            default:
                // Action that require data from the data context to render.
                if ((context === null || context === void 0 ? void 0 : context.actions) === undefined) return false;
                return Boolean(item.name in context.actions ? context.actions[item.name] : undefined);
        }
    });
};

});

parcelRegister("ltqsP", function(module, exports) {
$parcel$export(module.exports, "default", () => $bdab5469d6ec671a$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $5JwWG = parcelRequire("5JwWG");

var $1YSgn = parcelRequire("1YSgn");

var $abdiM = parcelRequire("abdiM");

var $5fYbv = parcelRequire("5fYbv");

var $5uGAu = parcelRequire("5uGAu");

var $gjk4e = parcelRequire("gjk4e");

var $iWoHD = parcelRequire("iWoHD");

var $6MfmW = parcelRequire("6MfmW");

var $8H2BQ = parcelRequire("8H2BQ");

var $8gSVN = parcelRequire("8gSVN");

var $8Up1A = parcelRequire("8Up1A");

var $aV7nQ = parcelRequire("aV7nQ");
const $bdab5469d6ec671a$var$Actions = {
    [(0, $j9rqA.ActionName).AutomationAction]: (0, $abdiM.default),
    [(0, $j9rqA.ActionName).CopyLinkAction]: (0, $5fYbv.default),
    [(0, $j9rqA.ActionName).CustomAction]: (0, $5JwWG.default),
    [(0, $j9rqA.ActionName).DeleteAction]: (0, $gjk4e.default),
    [(0, $j9rqA.ActionName).DownloadAction]: (0, $iWoHD.default),
    [(0, $j9rqA.ActionName).EditAction]: (0, $6MfmW.default),
    [(0, $j9rqA.ActionName).FollowAction]: (0, $8H2BQ.default),
    [(0, $j9rqA.ActionName).PreviewAction]: (0, $8gSVN.default),
    [(0, $j9rqA.ActionName).RovoChatAction]: (0, $8Up1A.default),
    [(0, $j9rqA.InternalActionName).AISummaryAction]: (0, $1YSgn.default),
    [(0, $j9rqA.InternalActionName).UnresolvedAction]: (0, $5uGAu.default),
    [(0, $j9rqA.InternalActionName).ViewRelatedLinksAction]: (0, $aV7nQ.default)
};
const $bdab5469d6ec671a$var$ActionGroupItem = ({ item: item, size: size, appearance: appearance, asDropDownItems: asDropDownItems, onActionItemClick: onActionItemClick })=>{
    const { name: name, hideContent: hideContent, hideIcon: hideIcon, onClick: onClick, isDisabled: isDisabled, ...props } = item;
    const handleOnClick = (0, $fc4bM.useCallback)(()=>{
        if (onActionItemClick) onActionItemClick();
        if (onClick) onClick();
    }, [
        onActionItemClick,
        onClick
    ]);
    const Action = name in $bdab5469d6ec671a$var$Actions ? $bdab5469d6ec671a$var$Actions[name] : undefined;
    if (!Action) return null;
    const actionProps = {
        ...props
    };
    if (hideContent && !asDropDownItems) actionProps.content = '';
    if (hideIcon) actionProps.icon = undefined;
    if (item !== null && item !== void 0 && item.entryPointWrapper) actionProps.wrapper = item.entryPointWrapper;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Action, {
        asDropDownItem: asDropDownItems,
        size: size,
        appearance: appearance,
        onClick: handleOnClick,
        isDisabled: isDisabled,
        ...actionProps
    });
};
var $bdab5469d6ec671a$export$2e2bcd8739ae039 = $bdab5469d6ec671a$var$ActionGroupItem;

});
parcelRegister("5JwWG", function(module, exports) {
$parcel$export(module.exports, "default", () => $d88c79bf55744b15$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $9Y7kh = parcelRequire("9Y7kh");

var $iibWH = parcelRequire("iibWH");

var $l9rJq = parcelRequire("l9rJq");

var $h40wl = parcelRequire("h40wl");
/**
 * A base action that can be triggered with an on click.
 * @internal
 * @param {ActionProps} ActionProps - The props necessary for the Action.
 */ const $d88c79bf55744b15$var$Action = ({ as: as, appearance: appearance = 'subtle', content: content, isLoading: isLoading = false, onClick: onClick, size: size = (0, $j9rqA.SmartLinkSize).Medium, testId: testId = 'smart-action', icon: icon, iconPosition: iconPosition = 'before', spaceInline: spaceInline, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltip: hideTooltip, hideTooltipOnMouseDown: hideTooltipOnMouseDown, hasNewContentOnTriggerClick: hasNewContentOnTriggerClick, style: style, asDropDownItem: asDropDownItem, className: className, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, wrapper: Wrapper })=>{
    if (!onClick) return null;
    const isStackItem = as === 'stack-item';
    const isDropdownItem = as === 'dropdown-item' || asDropDownItem;
    const actionIcon = icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $l9rJq.default), {
        icon: icon,
        testId: testId
    }) : undefined;
    const iconBefore = icon && iconPosition === 'before' ? actionIcon : undefined;
    const iconAfter = icon && iconPosition === 'after' ? actionIcon : undefined;
    if (isStackItem) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $h40wl.default), {
        content: content,
        icon: actionIcon,
        space: spaceInline,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onClick,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        tooltipOnHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        hasNewContentOnTriggerClick: hasNewContentOnTriggerClick,
        hideTooltip: hideTooltip,
        ariaLabel: ariaLabel
    });
    if (isDropdownItem) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iibWH.default), {
        ariaLabel: ariaLabel,
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        testId: testId
    });
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9Y7kh.default), {
        appearance: appearance,
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        isDisabled: isDisabled,
        href: href,
        ariaLabel: ariaLabel
    });
    return Wrapper !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Wrapper, null, button) : button;
};
var $d88c79bf55744b15$export$2e2bcd8739ae039 = $d88c79bf55744b15$var$Action;

});
parcelRegister("9Y7kh", function(module, exports) {
$parcel$export(module.exports, "default", () => $b91ae25a806de1db$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $jdt4T = parcelRequire("jdt4T");

var $5dzEI = parcelRequire("5dzEI");

var $fRCnG = parcelRequire("fRCnG");

var $jOinY = parcelRequire("jOinY");

var $2VysO = parcelRequire("2VysO");

var $jtb5V = parcelRequire("jtb5V");

var $dRkX9 = parcelRequire("dRkX9");

var $dBtOK = parcelRequire("dBtOK");

var $bcTS3 = parcelRequire("bcTS3");

var $j9rqA = parcelRequire("j9rqA");

var $dweer = parcelRequire("dweer");

var $5QRjl = parcelRequire("5QRjl");

var $gysdQ = parcelRequire("gysdQ");

var $knLZA = parcelRequire("knLZA");

var $aAm1y = parcelRequire("aAm1y");
const $b91ae25a806de1db$var$IconOnlyLarge = null;
const $b91ae25a806de1db$var$SizeSmall = null;
const $b91ae25a806de1db$var$styles = {
    textSmall: "_13bowadc _1q9t1wq8 _1rlg1g80 _bdn61h6o"
};
const $b91ae25a806de1db$var$SizeSmallIconOnly = null;
const $b91ae25a806de1db$var$SizeSmallNotIconOnly = null;
const $b91ae25a806de1db$var$IconButtonAppearanceMap = {
    default: 'default',
    danger: undefined,
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: undefined
};
const $b91ae25a806de1db$var$ButtonAppearanceMap = {
    default: 'default',
    danger: 'danger',
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: 'warning'
};
const $b91ae25a806de1db$var$tooltipOptions = {
    hideTooltipOnClick: true
};
const $b91ae25a806de1db$var$ActionButtonRefresh = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel }, ref)=>{
    var _context$actions;
    const iconOnly = !content;
    const isPreviewA11yLabelEnabled = (0, $dRkX9.fg)('platform_smart_link_preview_a11y_label');
    const context = (0, $dweer.useFlexibleUiContext)();
    const { product: product } = (0, $gysdQ.default)();
    const isRovoSupported = !!(context !== null && context !== void 0 && (_context$actions = context.actions) !== null && _context$actions !== void 0 && _context$actions[(0, $j9rqA.ActionName).RovoChatAction]) && !!product && product === 'CONFLUENCE';
    const onButtonClick = (0, $fc4bM.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    const button = (0, $fc4bM.useMemo)(()=>{
        const isLinkButton = !!href;
        const spacing = size === (0, $j9rqA.SmartLinkSize).Large || size === (0, $j9rqA.SmartLinkSize).XLarge ? 'default' : 'compact';
        const icon = iconBefore || iconAfter;
        const iconFn = icon ? ()=>icon : undefined;
        if (iconOnly && iconFn) {
            const label = isPreviewA11yLabelEnabled ? ariaLabel ?? tooltipMessage : tooltipMessage;
            const tooltip = isPreviewA11yLabelEnabled ? {
                ...$b91ae25a806de1db$var$tooltipOptions,
                content: tooltipMessage
            } : $b91ae25a806de1db$var$tooltipOptions;
            if (isLinkButton && iconFn) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jOinY.default), {
                appearance: $b91ae25a806de1db$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                href: href,
                isDisabled: isDisabled,
                isTooltipDisabled: false,
                label: label,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: tooltip
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fRCnG.default), {
                appearance: $b91ae25a806de1db$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isTooltipDisabled: false,
                label: label,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: tooltip
            });
        }
        const iconBeforeFn = iconBefore ? ()=>iconBefore : undefined;
        const iconAfterFn = iconAfter ? ()=>iconAfter : undefined;
        if (isLinkButton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bcTS3.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2VysO.default), {
            appearance: $b91ae25a806de1db$var$ButtonAppearanceMap[appearance],
            "aria-label": ariaLabel,
            iconAfter: iconAfterFn,
            iconBefore: iconBeforeFn,
            isDisabled: isDisabled,
            href: href,
            onClick: onButtonClick(onClick),
            spacing: spacing,
            testId: testId
        }, content));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bcTS3.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5dzEI.default), {
            appearance: $b91ae25a806de1db$var$ButtonAppearanceMap[appearance],
            "aria-label": ariaLabel,
            iconAfter: iconAfterFn,
            iconBefore: iconBeforeFn,
            isDisabled: isDisabled,
            isLoading: isLoading,
            onClick: onButtonClick(onClick),
            spacing: spacing,
            testId: testId
        }, content));
    }, [
        appearance,
        ariaLabel,
        content,
        href,
        iconAfter,
        iconBefore,
        iconOnly,
        isDisabled,
        isLoading,
        isPreviewA11yLabelEnabled,
        onButtonClick,
        onClick,
        size,
        testId,
        tooltipMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        testId: `${testId}-button-wrapper`,
        ref: ref,
        xcss: (0, $jdt4T.cx)(isRovoSupported && size === (0, $j9rqA.SmartLinkSize).Small && $b91ae25a806de1db$var$styles.textSmall)
    }, button);
});
const $b91ae25a806de1db$var$ActionButtonRefreshWithOverrideCss = (0, $knLZA.withOverrideCss)($b91ae25a806de1db$var$ActionButtonRefresh);
const $b91ae25a806de1db$var$ActionButtonNew = ({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, className: className })=>{
    const iconOnly = !content;
    const onButtonClick = (0, $fc4bM.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $2R2iS.default)([
            size === (0, $j9rqA.SmartLinkSize).Large && iconOnly && "_1gflidpf _or3fidpf _1ddvidpf _1hhaidpf _yhjmidpf _1trnidpf _1fstidpf _1xceidpf _1gqnidpf _1qdmidpf _df2ridpf _j1twidpf _11lvidpf _192bidpf _vbn7idpf _wfu3idpf _1i3bidpf _13gwidpf _4wlcidpf _rehaidpf _mp2fidpf _ro8midpf _1l0qidpf _1bnaidpf _3kh9idpf _i2vxidpf _8pvjidpf _1e1oidpf _1vtwidpf _ijvwidpf _tpwpidpf _1ad8idpf",
            size === (0, $j9rqA.SmartLinkSize).Small && "_11c8wadc _k48p1wq8",
            size === (0, $j9rqA.SmartLinkSize).Small && iconOnly && "_1gflv77o _or3fv77o _1ddvv77o _1hhav77o _yhjmv77o _1trnv77o _1fstv77o _1xcev77o _1gqnv77o _1qdmv77o _df2rv77o _j1twv77o _11lvv77o _192bv77o _vbn7v77o _wfu3v77o",
            size === (0, $j9rqA.SmartLinkSize).Small && !iconOnly && "_11lv1b66 _192b1b66 _vbn71b66 _wfu31b66 _yhjm1b66 _1trn1b66 _1fst1b66 _1xce1b66",
            className
        ]),
        "data-testid": `${testId}-button-wrapper`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bcTS3.default), {
        content: tooltipMessage,
        hideTooltipOnClick: true,
        testId: `${testId}-tooltip`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jtb5V.default), {
        appearance: appearance,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onButtonClick(onClick),
        spacing: (0, $aAm1y.sizeToButtonSpacing)[size],
        testId: testId,
        href: href,
        "aria-label": ariaLabel
    }, content)));
};
const $b91ae25a806de1db$var$ActionButton = (props)=>{
    const ui = (0, $5QRjl.useFlexibleUiOptionContext)();
    if (ui !== null && ui !== void 0 && ui.hideLegacyButton || ui !== null && ui !== void 0 && ui.removeBlockRestriction) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($b91ae25a806de1db$var$ActionButtonRefreshWithOverrideCss, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($b91ae25a806de1db$var$ActionButtonNew, props);
};
var $b91ae25a806de1db$export$2e2bcd8739ae039 = $b91ae25a806de1db$var$ActionButton;

});
parcelRegister("knLZA", function(module, exports) {
$parcel$export(module.exports, "withOverrideCss", () => $a8de560ad61ebf3f$export$e0bdcacb944f1da6);

var $fc4bM = parcelRequire("fc4bM");
function $a8de560ad61ebf3f$export$e0bdcacb944f1da6(Component) {
    return (props)=>{
        const ref = (0, $fc4bM.useRef)(null);
        (0, $fc4bM.useEffect)(()=>{
            if (props !== null && props !== void 0 && props.className && ref.current) ref.current.className = `${ref.current.className} ${props.className}`;
        }, [
            props === null || props === void 0 ? void 0 : props.className
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Component, {
            ...props,
            ref: ref
        });
    };
}

});

parcelRegister("aAm1y", function(module, exports) {
$parcel$export(module.exports, "sizeToButtonSpacing", () => $119cd6ea5fcc20ab$export$9d642f65a919fb93);

var $j9rqA = parcelRequire("j9rqA");
const $119cd6ea5fcc20ab$export$9d642f65a919fb93 = {
    [(0, $j9rqA.SmartLinkSize).Small]: 'none',
    [(0, $j9rqA.SmartLinkSize).Medium]: 'compact',
    [(0, $j9rqA.SmartLinkSize).Large]: 'compact',
    [(0, $j9rqA.SmartLinkSize).XLarge]: 'default'
};

});


parcelRegister("iibWH", function(module, exports) {
$parcel$export(module.exports, "default", () => $3821e571e1a25d53$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $7A0bt = parcelRequire("7A0bt");

var $dRkX9 = parcelRequire("dRkX9");

var $7tDET = parcelRequire("7tDET");
const $3821e571e1a25d53$var$ActionDropdownItem = ({ ariaLabel: ariaLabel, content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7A0bt.default), {
        "aria-label": (0, $dRkX9.fg)('platform_smart_link_preview_a11y_label') ? ariaLabel : undefined,
        elemAfter: iconAfter,
        elemBefore: iconBefore,
        isDisabled: isLoading,
        onClick: (0, $7tDET.handleOnClick)(onClick),
        testId: testId
    }, content);
var $3821e571e1a25d53$export$2e2bcd8739ae039 = $3821e571e1a25d53$var$ActionDropdownItem;

});
parcelRegister("7tDET", function(module, exports) {
$parcel$export(module.exports, "handleOnClick", () => $b9ba107b9e9d0729$export$ffccab2ae3d093ef);
parcelRequire("fc4bM");
const $b9ba107b9e9d0729$export$ffccab2ae3d093ef = (handler)=>(e)=>{
        e.preventDefault();
        e.stopPropagation();
        handler();
    };

});


parcelRegister("l9rJq", function(module, exports) {
$parcel$export(module.exports, "default", () => $37be486a6e613118$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $37be486a6e613118$var$stackItemIconStylesCompiled = null;
const $37be486a6e613118$var$ActionIcon = ({ testId: testId, icon: icon })=>{
    return /*#__PURE__*/ $fc4bM.createElement("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $2R2iS.default)([
            "_1e0c116y"
        ])
    }, icon);
};
var $37be486a6e613118$export$2e2bcd8739ae039 = $37be486a6e613118$var$ActionIcon;

});

parcelRegister("h40wl", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7bab4ea1d162438$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $bcTS3 = parcelRequire("bcTS3");

var $iTzeT = parcelRequire("iTzeT");
const $b7bab4ea1d162438$var$ActionStackItem = ({ content: content, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltipOnMouseDown: hideTooltipOnMouseDown, hasNewContentOnTriggerClick: hasNewContentOnTriggerClick, hideTooltip: hideTooltip, ...props })=>{
    return hideTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iTzeT.default), {
        ...props,
        content: content
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bcTS3.default), {
        content: tooltipMessage || content,
        onHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        hasNewContentOnTriggerClick: hasNewContentOnTriggerClick
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iTzeT.default), {
            ...props,
            content: content,
            tooltipProps: tooltipProps
        }));
};
var $b7bab4ea1d162438$export$2e2bcd8739ae039 = $b7bab4ea1d162438$var$ActionStackItem;

});
parcelRegister("iTzeT", function(module, exports) {
$parcel$export(module.exports, "default", () => $31c7bc971ea14f77$export$2e2bcd8739ae039);
/* action-button.tsx generated by @compiled/babel-plugin v3.0.2 */ /* action-button.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $4Cnkn = parcelRequire("4Cnkn");

var $dBtOK = parcelRequire("dBtOK");

var $i3riz = parcelRequire("i3riz");

var $EawnW = parcelRequire("EawnW");

var $hculA = parcelRequire("hculA");

var $1yoLa = parcelRequire("1yoLa");

var $l9rJq = parcelRequire("l9rJq");
const $31c7bc971ea14f77$var$styles = {
    button: "_bfhksm61 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1bsb1osq _1ah31i6y _irr31dpa _1di6fcek",
    content: "_11c8wadc _syazi7uo",
    spinner: "_1bsb1tcg _4t3i1tcg _1e0c116y _4cvr1h6o _1bah1h6o"
};
const $31c7bc971ea14f77$var$ActionButton = ({ content: content, icon: iconOption, isDisabled: isDisabled, isLoading: isLoading, onClick: onClickCallback, size: size, space: spaceOption, testId: testId, tooltipProps: tooltipProps, style: style, ariaLabel: ariaLabel })=>{
    const space = spaceOption ?? (0, $1yoLa.getPrimitivesInlineSpaceBySize)(size);
    const onClick = (0, $fc4bM.useCallback)(()=>{
        if (!isDisabled && !isLoading && onClickCallback) onClickCallback();
    }, [
        isDisabled,
        isLoading,
        onClickCallback
    ]);
    // FIX-ME: This is required for ResolvedHoverCardFooterBlock action to show proper size
    // ResolvedHoverCardFooterBlock is currently not used but keeping inside the code base for
    // upcoming experiment to refresh HoverCard design
    // If ResolvedHoverCardFooterBlock is cleaned up, this code can be removed.
    const showSpinnerSize24 = false;
    const icon = iconOption && isLoading ? /*#__PURE__*/ $fc4bM.createElement((0, $l9rJq.default), {
        icon: showSpinnerSize24 ? /*#__PURE__*/ $fc4bM.createElement((0, $dBtOK.Box), {
            xcss: $31c7bc971ea14f77$var$styles.spinner
        }, /*#__PURE__*/ $fc4bM.createElement((0, $hculA.default), {
            size: 16,
            testId: `${testId}-loading`
        })) : /*#__PURE__*/ $fc4bM.createElement((0, $hculA.default), {
            testId: `${testId}-loading`
        })
    }) : iconOption;
    return /*#__PURE__*/ $fc4bM.createElement((0, $EawnW.Pressable), {
        xcss: (0, $4Cnkn.cx)($31c7bc971ea14f77$var$styles.button),
        ...tooltipProps,
        onClick: onClick,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        "aria-label": ariaLabel
    }, /*#__PURE__*/ $fc4bM.createElement((0, $i3riz.Inline), {
        alignBlock: "center",
        grow: "fill",
        space: space
    }, icon, /*#__PURE__*/ $fc4bM.createElement((0, $dBtOK.Box), {
        xcss: (0, $4Cnkn.cx)($31c7bc971ea14f77$var$styles.content)
    }, content)));
};
var $31c7bc971ea14f77$export$2e2bcd8739ae039 = $31c7bc971ea14f77$var$ActionButton;

});
parcelRegister("1yoLa", function(module, exports) {
$parcel$export(module.exports, "getPrimitivesInlineSpaceBySize", () => $7760a6a164c65e23$export$475c391af8171fec);

var $j9rqA = parcelRequire("j9rqA");
const $7760a6a164c65e23$export$475c391af8171fec = (size)=>{
    switch(size){
        case (0, $j9rqA.SmartLinkSize).XLarge:
            return 'space.250';
        case (0, $j9rqA.SmartLinkSize).Large:
            return 'space.200';
        case (0, $j9rqA.SmartLinkSize).Medium:
            return 'space.100';
        case (0, $j9rqA.SmartLinkSize).Small:
        default:
            return 'space.050';
    }
};

});




parcelRegister("1YSgn", function(module, exports) {
$parcel$export(module.exports, "default", () => $b944b28696c14362$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $dweer = parcelRequire("dweer");

var $7WPBI = parcelRequire("7WPBI");
const $b944b28696c14362$var$AISummaryAction = (props)=>{
    var _context$actions;
    const context = (0, $dweer.useFlexibleUiContext)();
    const actionData = context === null || context === void 0 || (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[(0, $j9rqA.InternalActionName).AISummaryAction];
    return actionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7WPBI.AISummaryActionComponent), {
        ...actionData,
        ...props
    }) : null;
};
var $b944b28696c14362$export$2e2bcd8739ae039 = $b944b28696c14362$var$AISummaryAction;

});
parcelRegister("7WPBI", function(module, exports) {
$parcel$export(module.exports, "AISummaryActionComponent", () => $5fc48884e3679be0$export$8eed96bc6d982595);

var $fc4bM = parcelRequire("fc4bM");

var $khHoI = parcelRequire("khHoI");

var $bfU3V = parcelRequire("bfU3V");

var $4m8Uh = parcelRequire("4m8Uh");
const $5fc48884e3679be0$export$8eed96bc6d982595 = (props)=>{
    const { url: url, onLoadingChange: onLoadingChange, testId: testId = 'smart-action-ai-summary-action' } = props;
    const { state: { status: status, content: content }, summariseUrl: summariseUrl } = (0, $khHoI.default)(url);
    (0, $fc4bM.useEffect)(()=>{
        onLoadingChange === null || onLoadingChange === void 0 || onLoadingChange(status === 'loading');
    }, [
        onLoadingChange,
        status
    ]);
    return status === 'done' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4m8Uh.CopySummaryAction), {
        ...props,
        summary: content,
        testId: testId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bfU3V.AISummariseAction), {
        ...props,
        testId: testId,
        summariseUrl: summariseUrl,
        status: status
    });
};

});
parcelRegister("khHoI", function(module, exports) {
$parcel$export(module.exports, "default", () => $f9047cff42534c2d$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $exyMZ = parcelRequire("exyMZ");

var $2r9K5 = parcelRequire("2r9K5");

var $fVrlX = parcelRequire("fVrlX");

var $gvrpl = parcelRequire("gvrpl");

var $k7o0P = parcelRequire("k7o0P");

var $eCeLl = parcelRequire("eCeLl");

var $fzYCU = parcelRequire("fzYCU");

var $8l2KC = parcelRequire("8l2KC");

var $gkKen = parcelRequire("gkKen");
const $f9047cff42534c2d$var$EXPERIENCE_NAME = 'smart-link-ai-summary';
const $f9047cff42534c2d$var$useAISummaryAction = (url)=>{
    var _cardState$details;
    const { baseUrl: baseUrl, envKey: envKey, product: product } = (0, $gkKen.useAISummaryConfig)();
    const cardState = (0, $fzYCU.useSmartCardState)(url);
    const { fireEvent: fireEvent } = (0, $fVrlX.useAnalyticsEvents)();
    const data = (_cardState$details = cardState.details) === null || _cardState$details === void 0 ? void 0 : _cardState$details.data;
    const ari = data && (0, $exyMZ.extractAri)(data);
    const dataUrl = data && (0, $2r9K5.extractLink)(data) || '';
    const onStart = (0, $fc4bM.useCallback)((id)=>{
        (0, $k7o0P.startUfoExperience)($f9047cff42534c2d$var$EXPERIENCE_NAME, id);
    }, []);
    const onSuccess = (0, $fc4bM.useCallback)((id)=>{
        fireEvent('operational.summary.success', {});
        (0, $eCeLl.succeedUfoExperience)($f9047cff42534c2d$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    const onError = (0, $fc4bM.useCallback)((id, reason)=>{
        /**
     * Errors should only be counted to the SLO if they are not due to acceptable use violations
     * HIPAA content detected or exceeding context length.
     */ const isSloError = reason === undefined ? true : ![
            'ACCEPTABLE_USE_VIOLATIONS',
            'HIPAA_CONTENT_DETECTED',
            'EXCEEDING_CONTEXT_LENGTH_ERROR'
        ].includes(reason);
        fireEvent('operational.summary.failed', {
            reason: reason || null,
            isSloError: isSloError
        });
        (0, $gvrpl.failUfoExperience)($f9047cff42534c2d$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    return (0, $8l2KC.useAISummary)({
        url: dataUrl,
        ari: ari,
        product: product,
        envKey: envKey,
        baseUrl: baseUrl,
        onStart: onStart,
        onSuccess: onSuccess,
        onError: onError
    });
};
var $f9047cff42534c2d$export$2e2bcd8739ae039 = $f9047cff42534c2d$var$useAISummaryAction;

});
parcelRegister("exyMZ", function(module, exports) {
$parcel$export(module.exports, "extractAri", () => $eacb4598e73963a3$export$be18a6294fd426ec);
const $eacb4598e73963a3$export$be18a6294fd426ec = (jsonLd)=>{
    if (jsonLd !== null && jsonLd !== void 0 && jsonLd['atlassian:ari']) return jsonLd['atlassian:ari'];
    return undefined;
};

});

parcelRegister("2r9K5", function(module, exports) {
$parcel$export(module.exports, "extractLink", () => $0e239af15874f368$export$63f54cf4c5883620);

var $8BY94 = parcelRequire("8BY94");
const $0e239af15874f368$export$63f54cf4c5883620 = (jsonLd)=>{
    const url = jsonLd === null || jsonLd === void 0 ? void 0 : jsonLd.url;
    if (url) {
        if (typeof url === 'string') return url;
        else return (0, $8BY94.extractUrlFromLinkJsonLd)(url);
    }
    return undefined;
};

});

parcelRegister("8l2KC", function(module, exports) {
$parcel$export(module.exports, "useAISummary", () => $3602912c0145f91a$export$becd8f2eba1bbd96);

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $jDrKb = parcelRequire("jDrKb");

var $kMKOv = parcelRequire("kMKOv");
const $3602912c0145f91a$export$becd8f2eba1bbd96 = (props)=>{
    var _AISummariesStore$get;
    const { url: url, baseUrl: baseUrl, product: product, ari: ari, envKey: envKey, onError: onError, onStart: onStart, onSuccess: onSuccess } = props;
    const [state, setState] = (0, $fc4bM.useState)(((_AISummariesStore$get = (0, $kMKOv.AISummariesStore).get(url)) === null || _AISummariesStore$get === void 0 ? void 0 : _AISummariesStore$get.state) || {
        status: 'ready',
        content: ''
    });
    const { locale: locale } = (0, $gpjDl.default)();
    (0, $fc4bM.useEffect)(()=>{
        var _AISummariesStore$get2;
        //do not create a service for the empty URL string when the link data is not yet available,
        //or the service has already been created and cached.
        if (url && !(0, $kMKOv.AISummariesStore).get(url)) (0, $kMKOv.AISummariesStore).set(url, new (0, $jDrKb.AISummaryService)({
            url: url,
            ari: ari,
            baseUrl: baseUrl,
            product: product,
            envKey: envKey,
            locale: locale,
            onError: onError,
            onStart: onStart,
            onSuccess: onSuccess
        }));
        //returns function that calls unsubscribe method
        return (_AISummariesStore$get2 = (0, $kMKOv.AISummariesStore).get(url)) === null || _AISummariesStore$get2 === void 0 ? void 0 : _AISummariesStore$get2.subscribe(setState);
    }, [
        url,
        baseUrl,
        onError,
        onStart,
        onSuccess,
        product,
        ari,
        envKey,
        locale
    ]);
    const summariseUrl = ()=>{
        var _AISummariesStore$get3;
        return (_AISummariesStore$get3 = (0, $kMKOv.AISummariesStore).get(url)) === null || _AISummariesStore$get3 === void 0 ? void 0 : _AISummariesStore$get3.summariseUrl();
    };
    return {
        summariseUrl: summariseUrl,
        state: state
    };
};

});
parcelRegister("jDrKb", function(module, exports) {
$parcel$export(module.exports, "AISummaryService", () => $e19305de78838b91$export$73e4b807d5bd74b6);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $eUgRu = parcelRequire("eUgRu");

var $hzN2E = parcelRequire("hzN2E");

var $el7w2 = parcelRequire("el7w2");

var $hWBAr = parcelRequire("hWBAr");

var $dKYA7 = parcelRequire("dKYA7");

var $a28Nr = parcelRequire("a28Nr");
const $e19305de78838b91$var$CONVO_AI_ENDPOINT = 'assist/api/ai/v2/ai-feature/smartlinksummary/stream';
class $e19305de78838b91$export$73e4b807d5bd74b6 {
    constructor(props){
        this.state = {
            content: '',
            status: 'ready'
        };
        this.subscribedStateSetters = new Set();
        this.getRequestUrl = (envKey, baseUrlOverride)=>{
            if (baseUrlOverride || envKey) {
                const baseUrl = baseUrlOverride || (0, $hzN2E.getBaseUrl)(envKey);
                return (0, $el7w2.addPath)(baseUrl, $e19305de78838b91$var$CONVO_AI_ENDPOINT);
            }
            return (0, $el7w2.addPath)('/gateway/api/', $e19305de78838b91$var$CONVO_AI_ENDPOINT);
        };
        this.fetchStream = async ()=>{
            const payload = {
                recipient_agent_named_id: 'smartlink_summary_agent',
                agent_input_context: {
                    content_url: this.url,
                    content_ari: this.ari,
                    prompt_id: 'smart_links',
                    summary_output_mimetype: 'text/markdown',
                    locale: this.locale
                },
                ai_feature_input: {
                    content_url: this.url,
                    content_ari: this.ari,
                    locale: this.locale
                }
            };
            const options = {
                method: 'POST',
                headers: this.config.headers,
                body: JSON.stringify(payload),
                credentials: 'include'
            };
            const response = await fetch(this.config.requestUrl, options);
            if (!response.ok || response.status >= 400) throw new Error(`Status: ${response.status}\n URL: ${this.url}\n StatusText ${response.statusText}`);
            else return (0, $dKYA7.readStream)(response);
        };
        var _getXProductHeaderVal;
        this.config = {
            requestUrl: this.getRequestUrl(props.envKey, props.baseUrl),
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'x-experience-id': 'smart-link',
                'x-product': ((_getXProductHeaderVal = (0, $hWBAr.getXProductHeaderValue)(props.product)) === null || _getXProductHeaderVal === void 0 ? void 0 : _getXProductHeaderVal.toLowerCase()) || 'confluence'
            }
        };
        this.url = props.url;
        this.ari = props.ari;
        this.locale = props.locale;
        this.onStart = props.onStart;
        this.onSuccess = props.onSuccess;
        this.onError = props.onError;
    }
    async summariseUrl() {
        this.state = {
            status: 'loading',
            content: ''
        };
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const id = (0, $eUgRu.default)();
        try {
            var _this$onStart, _this$onSuccess;
            (_this$onStart = this.onStart) === null || _this$onStart === void 0 || _this$onStart.call(this, id);
            const stream = await this.fetchStream();
            let bufferContent = '';
            for await (const chunk of stream){
                if (chunk.type === 'ANSWER_PART') {
                    bufferContent += chunk.message.content;
                    for (const subscriber of this.subscribedStateSetters)subscriber({
                        ...this.state,
                        content: bufferContent
                    });
                }
                //if AI Mate service returns cached summary we get the summary text in one piece as the last message
                if (chunk.type === 'FINAL_RESPONSE') bufferContent = chunk.message.content;
                if (chunk.type === 'ERROR') {
                    var _chunk$message;
                    throw new (0, $a28Nr.ChunkProcessingError)(chunk === null || chunk === void 0 || (_chunk$message = chunk.message) === null || _chunk$message === void 0 ? void 0 : _chunk$message.message_template);
                }
            }
            (_this$onSuccess = this.onSuccess) === null || _this$onSuccess === void 0 || _this$onSuccess.call(this, id);
            this.state = {
                status: 'done',
                content: bufferContent
            };
        } catch (err) {
            var _this$onError;
            let message = err instanceof (0, $a28Nr.ChunkProcessingError) ? err.message : 'UNEXPECTED';
            (_this$onError = this.onError) === null || _this$onError === void 0 || _this$onError.call(this, id, message);
            this.state = {
                status: 'error',
                content: '',
                error: message
            };
        }
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        return this.state;
    }
    subscribe(stateSetter) {
        this.subscribedStateSetters.add(stateSetter);
        return ()=>{
            this.subscribedStateSetters.delete(stateSetter);
        };
    }
}

});
parcelRegister("el7w2", function(module, exports) {
$parcel$export(module.exports, "addPath", () => $0e359d5c510ead51$export$4c25481b843feb0b);
const $0e359d5c510ead51$export$4c25481b843feb0b = (baseUrl, path)=>{
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};

});

parcelRegister("hWBAr", function(module, exports) {
$parcel$export(module.exports, "getXProductHeaderValue", () => $9871b35820872296$export$ff2962de2b2c930f);
/**
 * Subset of a map of Jira `ProductTypes` to AI Mate expected values
 * See for more info: https://atlassian.slack.com/archives/C066UP0G0G3/p1716341647677829?thread_ts=1716338063.255939&cid=C066UP0G0G3
 */ const $9871b35820872296$var$AiMateJiraXProduct = {
    JSM: 'JSM',
    JSW: 'JIRA-SOFTWARE',
    JWM: 'JIRA-CORE',
    JPD: 'JPD'
};
/**
 * Checks if `product` is a Jira related product.
 */ const $9871b35820872296$var$isJiraProduct = (product)=>{
    const JIRA_PRODUCTS = [
        'JPD',
        'JSM',
        'JSW',
        'JWM'
    ];
    return product !== undefined && JIRA_PRODUCTS.includes(product);
};
const $9871b35820872296$export$ff2962de2b2c930f = (product)=>{
    if ($9871b35820872296$var$isJiraProduct(product)) return $9871b35820872296$var$AiMateJiraXProduct[product];
    return product;
};

});

parcelRegister("dKYA7", function(module, exports) {
$parcel$export(module.exports, "readStream", () => $f1e83365c8fc0bbd$export$e45226161c660403);

var $2culL = parcelRequire("2culL");
async function* $f1e83365c8fc0bbd$export$e45226161c660403(response) {
    const reader = (0, $2culL.getBufferReader)(response);
    let doneStreaming = false;
    let chunkBuffer = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) {
            const processedChunks = `${chunkBuffer}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            chunkBuffer = '';
            for (let chunk of processedChunks)try {
                const jsonChunk = JSON.parse(chunk);
                if (jsonChunk.type === 'ERROR') reader.cancel();
                yield jsonChunk;
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                chunkBuffer = chunk;
            }
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else {
            reader.cancel();
            throw e;
        }
    }
    while (!doneStreaming);
    if (chunkBuffer) {
        const error = new Error(`Not all the data was processed: ${chunkBuffer}`);
        throw error;
    }
}

});
parcelRegister("2culL", function(module, exports) {
$parcel$export(module.exports, "getBufferReader", () => $50cd08703b1fceb6$export$f6383c3ea1307da9);
const $50cd08703b1fceb6$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};

});


parcelRegister("a28Nr", function(module, exports) {
$parcel$export(module.exports, "ChunkProcessingError", () => $30aeb38ba7abd667$export$fcec967a4b7ebd84);
class $30aeb38ba7abd667$export$fcec967a4b7ebd84 extends Error {
    constructor(error){
        super(error);
    }
}
const $30aeb38ba7abd667$export$d8bd0967cb58683 = [
    'NETWORK_ERROR',
    'NO_ANSWER',
    'RATE_LIMIT',
    'NO_AGENT',
    'PLUGIN_ERRORED',
    'OPENAI_RATE_LIMIT_USER_ABUSE',
    'ACCEPTABLE_USE_VIOLATIONS',
    'AI_DISABLED',
    'UNEXPECTED',
    'HIPAA_CONTENT_DETECTED',
    'EXCEEDING_CONTEXT_LENGTH_ERROR'
];

});


parcelRegister("kMKOv", function(module, exports) {
$parcel$export(module.exports, "AISummariesStore", () => $2d137f7b3b484540$export$6979339b6d41707e);

var $11Qwb = parcelRequire("11Qwb");
const $2d137f7b3b484540$var$AI_SUMMARY_CACHE_SIZE = 100;
const $2d137f7b3b484540$export$6979339b6d41707e = new (0, $11Qwb.LRUMap)($2d137f7b3b484540$var$AI_SUMMARY_CACHE_SIZE);

});


parcelRegister("gkKen", function(module, exports) {
$parcel$export(module.exports, "useAISummaryConfig", () => $d1af5c3714c6beaf$export$4480af2c00aa7ebe);

var $fc4bM = parcelRequire("fc4bM");

var $fnEFU = parcelRequire("fnEFU");
const $d1af5c3714c6beaf$export$4480af2c00aa7ebe = ()=>{
    const { connections: connections, product: product, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $fnEFU.useSmartLinkContext)();
    return (0, $fc4bM.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            isAdminHubAIEnabled: isAdminHubAIEnabled
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        isAdminHubAIEnabled
    ]);
};

});


parcelRegister("bfU3V", function(module, exports) {
$parcel$export(module.exports, "AISummariseAction", () => $0123acafaaca1275$export$75a19de44af58722);

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");

var $dFt22 = parcelRequire("dFt22");

var $fVrlX = parcelRequire("fVrlX");

var $ewFKq = parcelRequire("ewFKq");

var $5JwWG = parcelRequire("5JwWG");

var $4Zpsl = parcelRequire("4Zpsl");
function $0123acafaaca1275$export$75a19de44af58722({ onClick: onClickCallback, onError: onErrorCallback, testId: testId, status: status, summariseUrl: summariseUrl, ...props }) {
    const { fireEvent: fireEvent } = (0, $fVrlX.useAnalyticsEvents)();
    const onCompleted = (0, $fc4bM.useCallback)((state)=>{
        if ((state === null || state === void 0 ? void 0 : state.status) === 'error') onErrorCallback === null || onErrorCallback === void 0 || onErrorCallback((0, $4Zpsl.getErrorMessage)(state.error));
    }, [
        onErrorCallback
    ]);
    const handleActionClick = (0, $fc4bM.useCallback)(()=>{
        var _summariseUrl;
        fireEvent('ui.button.clicked.aiSummary', {});
        fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 0,
            userGeneratedAI: 1
        });
        (_summariseUrl = summariseUrl()) === null || _summariseUrl === void 0 || _summariseUrl.then(onCompleted, onCompleted);
        onClickCallback === null || onClickCallback === void 0 || onClickCallback();
    }, [
        fireEvent,
        onClickCallback,
        onCompleted,
        summariseUrl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5JwWG.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $ewFKq.messages).ai_summary_action_rebrand),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dFt22))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Summarise with AI",
            size: props.iconSize
        }),
        onClick: handleActionClick,
        testId: `${testId}-summarise-action`,
        isLoading: status === 'loading',
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $ewFKq.messages).ai_summary_action_description_rebrand),
        ...props
    });
}

});
parcelRegister("4Zpsl", function(module, exports) {
$parcel$export(module.exports, "getErrorMessage", () => $9ab079b464a804b0$export$82f46aa4e6535a45);

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");

var $ThhDz = parcelRequire("ThhDz");

var $cHuUo = parcelRequire("cHuUo");

var $d39RH = parcelRequire("d39RH");
const $9ab079b464a804b0$export$82f46aa4e6535a45 = (error)=>{
    const { message: message, url: url } = (0, $ThhDz.getAISummaryErrorMessage)(error);
    return {
        appearance: 'error',
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cHuUo.default), {
            reason: error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), {
            ...message,
            values: {
                a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $d39RH.default), {
                        href: url
                    }, chunks)
            }
        }))
    };
};

});
parcelRegister("ThhDz", function(module, exports) {
$parcel$export(module.exports, "getAISummaryErrorMessage", () => $a25307ad437ca8cb$export$cd2e891d7f87074d);

var $j9rqA = parcelRequire("j9rqA");

var $ewFKq = parcelRequire("ewFKq");
const $a25307ad437ca8cb$export$cd2e891d7f87074d = (error)=>{
    switch(error){
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return {
                message: (0, $ewFKq.messages).ai_summary_error_acceptable_use_violation,
                url: (0, $j9rqA.CONTENT_URL_ACCEPTABLE_USE_POLICY)
            };
        case 'HIPAA_CONTENT_DETECTED':
            return {
                message: (0, $ewFKq.messages).ai_summary_error_hipaa_content_detected
            };
        case 'EXCEEDING_CONTEXT_LENGTH_ERROR':
            return {
                message: (0, $ewFKq.messages).ai_summary_error_exceeding_context_length_error
            };
        default:
            return {
                message: (0, $ewFKq.messages).ai_summary_error_generic_rebrand,
                url: (0, $j9rqA.CONTENT_URL_AI_TROUBLESHOOTING)
            };
    }
};

});

parcelRegister("cHuUo", function(module, exports) {
$parcel$export(module.exports, "default", () => $f4b08f41037eb608$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $fVrlX = parcelRequire("fVrlX");
const $f4b08f41037eb608$var$AIEventErrorViewed = ({ reason: reason })=>{
    const { fireEvent: fireEvent } = (0, $fVrlX.useAnalyticsEvents)();
    (0, $fc4bM.useEffect)(()=>{
        fireEvent('ui.error.viewed.aiSummary', {
            reason: reason
        });
    }, [
        fireEvent,
        reason
    ]);
    return null;
};
var $f4b08f41037eb608$export$2e2bcd8739ae039 = $f4b08f41037eb608$var$AIEventErrorViewed;

});

parcelRegister("d39RH", function(module, exports) {
$parcel$export(module.exports, "default", () => $ac9d87c3c1592970$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $dM0Q8 = parcelRequire("dM0Q8");

var $j9rqA = parcelRequire("j9rqA");
const $ac9d87c3c1592970$var$AILearnMoreAnchor = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dM0Q8.default), {
        href: (0, $j9rqA.CONTENT_URL_ROVO),
        target: "_blank",
        rel: "noopener noreferrer",
        ...props
    }, children);
var $ac9d87c3c1592970$export$2e2bcd8739ae039 = $ac9d87c3c1592970$var$AILearnMoreAnchor;

});



parcelRegister("4m8Uh", function(module, exports) {
$parcel$export(module.exports, "CopySummaryAction", () => $ec1d14d9f4798907$export$cfa1d3eed9a61059);

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");

var $eGgZF = parcelRequire("eGgZF");

var $fVrlX = parcelRequire("fVrlX");

var $ewFKq = parcelRequire("ewFKq");

var $5JwWG = parcelRequire("5JwWG");
function $ec1d14d9f4798907$export$cfa1d3eed9a61059({ url: url, onClick: onClickCallback, summary: summary = '', testId: testId, ...props }) {
    const { fireEvent: fireEvent } = (0, $fVrlX.useAnalyticsEvents)();
    const [tooltipMessage, setTooltipMessage] = (0, $fc4bM.useState)((0, $ewFKq.messages).copy_summary_action_description);
    const handleCopySummaryClick = (0, $fc4bM.useCallback)(async ()=>{
        fireEvent('ui.button.clicked.copySummary', {});
        await navigator.clipboard.writeText(summary);
        setTooltipMessage((0, $ewFKq.messages).copied_summary_action_description);
        onClickCallback === null || onClickCallback === void 0 || onClickCallback();
    }, [
        fireEvent,
        onClickCallback,
        summary
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5JwWG.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $ewFKq.messages).copy_summary_action),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eGgZF))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Copy Summary",
            size: props.iconSize
        }),
        onClick: handleCopySummaryClick,
        testId: `${testId}-copy-summary-action`,
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), tooltipMessage),
        tooltipOnHide: ()=>setTooltipMessage((0, $ewFKq.messages).copy_summary_action_description),
        hasNewContentOnTriggerClick: true,
        ...props
    });
}

});



parcelRegister("abdiM", function(module, exports) {
$parcel$export(module.exports, "default", () => $02ba3c597961b3e2$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");
var $gpjDl = parcelRequire("gpjDl");

var $knCQo = parcelRequire("knCQo");

var $k8Adr = parcelRequire("k8Adr");

var $fVrlX = parcelRequire("fVrlX");

var $j9rqA = parcelRequire("j9rqA");

var $ewFKq = parcelRequire("ewFKq");

var $dweer = parcelRequire("dweer");

var $hjl3F = parcelRequire("hjl3F");

var $5JwWG = parcelRequire("5JwWG");

var $f5FzO = parcelRequire("f5FzO");

const $02ba3c597961b3e2$var$AutomationModal = /*#__PURE__*/ (0, $fc4bM.lazy)(()=>(parcelRequire("lDVOi")));
const $02ba3c597961b3e2$var$AutomationAction = (props)=>{
    var _context$actions;
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const modal = (0, $hjl3F.useSmartLinkModal)();
    const { onClick: onClickCallback } = props;
    const context = (0, $dweer.useFlexibleUiContext)();
    const { fireEvent: fireEvent } = (0, $fVrlX.useAnalyticsEvents)();
    const automationActionData = context === null || context === void 0 || (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[(0, $j9rqA.ActionName).AutomationAction];
    const automationActionOnClick = (0, $fc4bM.useCallback)((automationActionData)=>{
        const { product: product, resourceType: resourceType, baseAutomationUrl: baseAutomationUrl, objectAri: objectAri, siteAri: siteAri, canManageAutomation: canManageAutomation, analyticsSource: analyticsSource, objectName: objectName } = automationActionData;
        fireEvent('ui.button.clicked.automationAction', {});
        const { modalTitle: modalTitle, modalDescription: modalDescription } = (0, $f5FzO.getModalContent)(product, resourceType) || {};
        const automationModalTitle = modalTitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), modalTitle) : undefined;
        const automationModalDescription = modalDescription ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), {
            ...modalDescription,
            values: {
                name: objectName,
                b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $k8Adr.Text), {
                        as: "strong"
                    }, chunks),
                br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("br", null)
            }
        }) : undefined;
        modal.open(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($02ba3c597961b3e2$var$AutomationModal, {
            baseAutomationUrl: baseAutomationUrl,
            objectAri: objectAri,
            siteAri: siteAri,
            canManageAutomation: canManageAutomation,
            analyticsSource: analyticsSource,
            modalTitle: automationModalTitle,
            modalDescription: automationModalDescription,
            onClose: ()=>modal.close()
        }));
        onClickCallback === null || onClickCallback === void 0 || onClickCallback();
    }, [
        modal,
        onClickCallback,
        fireEvent
    ]);
    if (!automationActionData) return null;
    const automationActionTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $ewFKq.messages).automation_action_title);
    const automationActionTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $ewFKq.messages).automation_action_tooltip);
    const automationActionIconLabel = formatMessage((0, $ewFKq.messages).automation_action_icon_label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5JwWG.default), {
        content: automationActionTitle,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($knCQo))), {
            spacing: "spacious",
            color: "currentColor",
            label: automationActionIconLabel,
            size: props.iconSize
        }),
        testId: "smart-action-automation-action",
        tooltipMessage: automationActionTooltip,
        ...props,
        onClick: ()=>automationActionOnClick(automationActionData)
    }));
};
var $02ba3c597961b3e2$export$2e2bcd8739ae039 = $02ba3c597961b3e2$var$AutomationAction;

});
parcelRegister("hjl3F", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkModal", () => $92691074d1c617e9$export$1fd7f5f21a6d6cb8);

var $fc4bM = parcelRequire("fc4bM");

var $IobPJ = parcelRequire("IobPJ");
const $92691074d1c617e9$export$1fd7f5f21a6d6cb8 = ()=>(0, $fc4bM.useContext)((0, $IobPJ.SmartLinkModalContext));

});
parcelRegister("IobPJ", function(module, exports) {
$parcel$export(module.exports, "SmartLinkModalContext", () => $e8f60001ebf99deb$export$f4c0a0f23ba57f8c);

var $fc4bM = parcelRequire("fc4bM");
const $e8f60001ebf99deb$var$FALLBACK_API = {
    open: ()=>{},
    close: ()=>{}
};
const $e8f60001ebf99deb$export$f4c0a0f23ba57f8c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createContext($e8f60001ebf99deb$var$FALLBACK_API);

});


parcelRegister("f5FzO", function(module, exports) {
$parcel$export(module.exports, "getModalContent", () => $0e6cad08ded2dd8b$export$93e707b363eaf5c8);

var $ewFKq = parcelRequire("ewFKq");
const $0e6cad08ded2dd8b$export$93e707b363eaf5c8 = (product, resourceType)=>{
    var _modalContentMap$prod;
    const modalContentMap = {
        confluence: {
            page: {
                modalTitle: (0, $ewFKq.messages).automation_action_confluence_page_modal_title,
                modalDescription: (0, $ewFKq.messages).automation_action_confluence_page_modal_description
            }
        }
    };
    return modalContentMap === null || modalContentMap === void 0 || (_modalContentMap$prod = modalContentMap[product]) === null || _modalContentMap$prod === void 0 ? void 0 : _modalContentMap$prod[resourceType];
};

});

parcelRegister("lDVOi", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("aGiea").then(()=>parcelRequire('6KsiE'));

});
parcelRegister("9dnsd", function(module, exports) {
"use strict";

function $6b57856c7829fee2$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("5WWY2")).resolve(id));
}
module.exports = $6b57856c7829fee2$var$load;

});
parcelRegister("5WWY2", function(module, exports) {
$parcel$export(module.exports, "register", () => $45501c3954b19655$export$6503ec6e8aabbaf, (v) => $45501c3954b19655$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $45501c3954b19655$export$f7ad0328861e2f03, (v) => $45501c3954b19655$export$f7ad0328861e2f03 = v);
var $45501c3954b19655$export$6503ec6e8aabbaf;
var $45501c3954b19655$export$f7ad0328861e2f03;
"use strict";
var $45501c3954b19655$var$mapping = new Map();
function $45501c3954b19655$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$45501c3954b19655$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $45501c3954b19655$var$resolve(id) {
    var resolved = $45501c3954b19655$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$45501c3954b19655$export$6503ec6e8aabbaf = $45501c3954b19655$var$register;
$45501c3954b19655$export$f7ad0328861e2f03 = $45501c3954b19655$var$resolve;

});




parcelRegister("5fYbv", function(module, exports) {
$parcel$export(module.exports, "default", () => $b0057c809f8ae468$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");
var $gpjDl = parcelRequire("gpjDl");

var $inMs5 = parcelRequire("inMs5");

var $j9rqA = parcelRequire("j9rqA");

var $ewFKq = parcelRequire("ewFKq");

var $dweer = parcelRequire("dweer");

var $cA6hx = parcelRequire("cA6hx");

var $5JwWG = parcelRequire("5JwWG");
const $b0057c809f8ae468$var$CopyLinkAction = ({ onClick: onClickCallback, ...props })=>{
    var _context$actions;
    const intl = (0, $gpjDl.default)();
    const context = (0, $dweer.useFlexibleUiContext)();
    const invoke = (0, $cA6hx.default)({});
    const data = context === null || context === void 0 || (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[(0, $j9rqA.ActionName).CopyLinkAction];
    const [tooltipMessage, setTooltipMessage] = (0, $fc4bM.useState)((0, $ewFKq.messages).copy_url_to_clipboard);
    const onClick = (0, $fc4bM.useCallback)(()=>{
        if (data !== null && data !== void 0 && data.invokeAction) {
            invoke({
                ...data.invokeAction,
                actionFn: async ()=>{
                    var _data$invokeAction;
                    await ((_data$invokeAction = data.invokeAction) === null || _data$invokeAction === void 0 ? void 0 : _data$invokeAction.actionFn());
                    setTooltipMessage((0, $ewFKq.messages).copied_url_to_clipboard);
                }
            });
            onClickCallback === null || onClickCallback === void 0 || onClickCallback();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5JwWG.default), {
        ariaLabel: intl.formatMessage((0, $ewFKq.messages).copy_url_to_clipboard),
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $ewFKq.messages).copy_url_to_clipboard),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($inMs5))), {
            color: "currentColor",
            label: "",
            spacing: "spacious",
            size: props.iconSize
        }),
        onClick: onClick,
        testId: "smart-action-copy-link-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), tooltipMessage),
        tooltipOnHide: ()=>setTooltipMessage((0, $ewFKq.messages).copy_url_to_clipboard),
        hasNewContentOnTriggerClick: true,
        ...data,
        ...props
    }) : null;
};
var $b0057c809f8ae468$export$2e2bcd8739ae039 = $b0057c809f8ae468$var$CopyLinkAction;

});

parcelRegister("5uGAu", function(module, exports) {
$parcel$export(module.exports, "default", () => $1faf40ee24d64344$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $6UhCB = parcelRequire("6UhCB");
var $1faf40ee24d64344$export$2e2bcd8739ae039 = (0, $6UhCB.CustomUnresolvedAction);

});
parcelRegister("6UhCB", function(module, exports) {
$parcel$export(module.exports, "CustomUnresolvedAction", () => $93d4fcba911d89b0$export$275b43513330d43b);
/* CustomUnresolvedAction.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");

var $dBtOK = parcelRequire("dBtOK");

var $EawnW = parcelRequire("EawnW");

var $j9rqA = parcelRequire("j9rqA");

var $bxLV6 = parcelRequire("bxLV6");
const $93d4fcba911d89b0$var$styles = {
    button: "_1e0c1bgi",
    message: "_1rjcze3t _18zrze3t"
};
const $93d4fcba911d89b0$var$validErrorStatuses = [
    (0, $j9rqA.SmartLinkStatus).Forbidden,
    (0, $j9rqA.SmartLinkStatus).Unauthorized
];
const $93d4fcba911d89b0$var$validateErrorStatus = (status)=>{
    return status !== undefined && $93d4fcba911d89b0$var$validErrorStatuses.includes(status);
};
const $93d4fcba911d89b0$var$getMessageDescriptor = (status, accessType, props)=>{
    var _props$status;
    if (!$93d4fcba911d89b0$var$validateErrorStatus(status)) return undefined;
    const message = props === null || props === void 0 || (_props$status = props[status]) === null || _props$status === void 0 ? void 0 : _props$status[accessType ?? 'FALLBACK'];
    return message;
};
const $93d4fcba911d89b0$export$275b43513330d43b = ({ testId: testId = 'custom-unresolved-action', onlyShowIfAction: onlyShowIfAction = false, Container: Container, ...props })=>{
    var _context$data, _context$data2;
    const context = (0, $bxLV6.useFlexibleCardContext)();
    const data = context === null || context === void 0 || (_context$data = context.data) === null || _context$data === void 0 || (_context$data = _context$data.actions) === null || _context$data === void 0 ? void 0 : _context$data[(0, $j9rqA.InternalActionName).UnresolvedAction];
    if (!data) return null;
    const { descriptor: descriptor, onClick: onClick, values: values } = data;
    const { status: status } = context;
    const accessType = context === null || context === void 0 || (_context$data2 = context.data) === null || _context$data2 === void 0 || (_context$data2 = _context$data2.meta) === null || _context$data2 === void 0 ? void 0 : _context$data2.accessType;
    const hasAction = onClick !== undefined;
    if (onlyShowIfAction && !hasAction) return null;
    const messageDescriptor = $93d4fcba911d89b0$var$getMessageDescriptor(status, accessType, props) ?? descriptor;
    if (!messageDescriptor) return null;
    const message = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        testId: `${testId}-errored-view-message`,
        tabIndex: hasAction ? 0 : undefined,
        xcss: $93d4fcba911d89b0$var$styles.message
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), {
        ...messageDescriptor,
        values: values
    }));
    const component = hasAction ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $EawnW.Pressable), {
        onClick: data.onClick,
        style: {
            color: `inherit`,
            font: `inherit`,
            textAlign: `inherit`
        },
        xcss: $93d4fcba911d89b0$var$styles.button
    }, message) : message;
    return Container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Container, null, component) : component;
};

});


parcelRegister("gjk4e", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd33aa5b669aa6d1$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");

var $gV8E5 = parcelRequire("gV8E5");

var $ewFKq = parcelRequire("ewFKq");

var $5JwWG = parcelRequire("5JwWG");
const $bd33aa5b669aa6d1$var$DeleteAction = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5JwWG.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $ewFKq.messages).delete),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gV8E5))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Delete"
        }),
        testId: "smart-action-delete-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $ewFKq.messages).delete),
        ...props
    });
var $bd33aa5b669aa6d1$export$2e2bcd8739ae039 = $bd33aa5b669aa6d1$var$DeleteAction;

});

parcelRegister("iWoHD", function(module, exports) {
$parcel$export(module.exports, "default", () => $89f7f63355835042$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");

var $3Z7XN = parcelRequire("3Z7XN");

var $j9rqA = parcelRequire("j9rqA");

var $ewFKq = parcelRequire("ewFKq");

var $dweer = parcelRequire("dweer");

var $cA6hx = parcelRequire("cA6hx");

var $5JwWG = parcelRequire("5JwWG");
const $89f7f63355835042$var$DownloadAction = ({ onClick: onClickCallback, ...props })=>{
    var _context$actions;
    const context = (0, $dweer.useFlexibleUiContext)();
    const invoke = (0, $cA6hx.default)({});
    const data = context === null || context === void 0 || (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[(0, $j9rqA.ActionName).DownloadAction];
    const onClick = (0, $fc4bM.useCallback)(()=>{
        if (data !== null && data !== void 0 && data.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback === null || onClickCallback === void 0 || onClickCallback();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const label = isStackItem ? (0, $ewFKq.messages).download_file : (0, $ewFKq.messages).download;
    const tooltipMessage = isStackItem ? (0, $ewFKq.messages).download_description : (0, $ewFKq.messages).download;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5JwWG.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), label),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Z7XN))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Download"
        }),
        onClick: onClick,
        testId: "smart-action-download-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), tooltipMessage),
        ...data,
        ...props
    }) : null;
};
var $89f7f63355835042$export$2e2bcd8739ae039 = $89f7f63355835042$var$DownloadAction;

});

parcelRegister("6MfmW", function(module, exports) {
$parcel$export(module.exports, "default", () => $64a5afa68fae5f83$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");

var $5BrPA = parcelRequire("5BrPA");

var $ewFKq = parcelRequire("ewFKq");

var $5JwWG = parcelRequire("5JwWG");
const $64a5afa68fae5f83$var$EditAction = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5JwWG.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $ewFKq.messages).edit),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5BrPA))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Edit"
        }),
        testId: "smart-action-edit-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $ewFKq.messages).edit),
        ...props
    });
var $64a5afa68fae5f83$export$2e2bcd8739ae039 = $64a5afa68fae5f83$var$EditAction;

});

parcelRegister("8H2BQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $daf6f037dd1463bd$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");
var $gpjDl = parcelRequire("gpjDl");

var $k2M4v = parcelRequire("k2M4v");

var $dRkX9 = parcelRequire("dRkX9");

var $j9rqA = parcelRequire("j9rqA");

var $ewFKq = parcelRequire("ewFKq");

var $dweer = parcelRequire("dweer");

var $fKjQL = parcelRequire("fKjQL");

var $hgUVU = parcelRequire("hgUVU");

var $haahN = parcelRequire("haahN");

var $1gm8B = parcelRequire("1gm8B");


const $daf6f037dd1463bd$var$importIconMapper = {
    goal: ()=>(parcelRequire("9irtk")).then(({ GoalIcon: GoalIcon })=>({
                default: GoalIcon
            })),
    projects: ()=>(parcelRequire("iEnVh")).then(({ ProjectsIcon: ProjectsIcon })=>({
                default: ProjectsIcon
            }))
};


// Inline module-scope lazy() calls so product SSR tooling can preload them before hydration.
const $daf6f037dd1463bd$var$lazyIconMapper = {
    goal: (0, $fKjQL.withSuspense)(/*#__PURE__*/ (0, $fc4bM.lazy)(()=>(parcelRequire("9irtk")).then(({ GoalIcon: GoalIcon })=>({
                default: GoalIcon
            })).catch((0, $fKjQL.renderNothingOnLoadError))), 'lazy(GoalIcon)'),
    projects: (0, $fKjQL.withSuspense)(/*#__PURE__*/ (0, $fc4bM.lazy)(()=>(parcelRequire("iEnVh")).then(({ ProjectsIcon: ProjectsIcon })=>({
                default: ProjectsIcon
            })).catch((0, $fKjQL.renderNothingOnLoadError))), 'lazy(ProjectsIcon)')
};
const $daf6f037dd1463bd$var$getIcon = (stackIconType)=>{
    if ((0, $dRkX9.fg)('platform_sl_replace_react_loadable')) return $daf6f037dd1463bd$var$lazyIconMapper[stackIconType] ?? null;
    const importFn = $daf6f037dd1463bd$var$importIconMapper[stackIconType];
    if (!importFn) return null;
    return (0, $hgUVU.importIcon)(importFn);
};
const $daf6f037dd1463bd$var$FollowAction = (props)=>{
    var _context$actions;
    const context = (0, $dweer.useFlexibleUiContext)();
    const intl = (0, $gpjDl.default)();
    const actionData = context === null || context === void 0 || (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[(0, $j9rqA.ActionName).FollowAction];
    if (!context || !actionData) return null;
    const { value: value, isProject: isProject, ...data } = actionData;
    const isStackItem = props.as === 'stack-item';
    const message = value ? (0, $ewFKq.messages).follow : (0, $ewFKq.messages).unfollow;
    const projectMessage = value ? (0, $ewFKq.messages).follow_project : (0, $ewFKq.messages).unfollow_project;
    const goalMessage = value ? (0, $ewFKq.messages).follow_goal : (0, $ewFKq.messages).unfollow_goal;
    const stackMessage = isProject ? projectMessage : goalMessage;
    const label = isStackItem ? stackMessage : message;
    const projectTooltipMessage = value ? (0, $k2M4v.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $ewFKq.messages).follow_project_descriptionGalaxia : (0, $ewFKq.messages).follow_project_description : (0, $k2M4v.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $ewFKq.messages).unfollow_project_descriptionGalaxia : (0, $ewFKq.messages).unfollow_project_description;
    const goalTooltipMessage = value ? (0, $ewFKq.messages).follow_goal_description : (0, $ewFKq.messages).unfollow_goal_description;
    const stackTooltipMessage = isProject ? projectTooltipMessage : goalTooltipMessage;
    const tooltipMessage = isStackItem ? stackTooltipMessage : message;
    const stackIconType = isProject ? 'projects' : 'goal';
    const ImportedIcon = $daf6f037dd1463bd$var$getIcon(stackIconType);
    const followIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(ImportedIcon, {
        label: "",
        testId: `smart-action-follow-action-${stackIconType}-icon`
    });
    const handleError = ()=>{
        const { onError: onErrorCallback } = props;
        const errorMessage = (0, $1gm8B.getFollowActionErrorMessage)(isProject, value);
        onErrorCallback === null || onErrorCallback === void 0 || onErrorCallback({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), errorMessage),
            appearance: 'error'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $haahN.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), label),
        ariaLabel: intl.formatMessage(label),
        icon: followIcon,
        testId: "smart-action-follow-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), tooltipMessage),
        ...data,
        ...props,
        onError: handleError
    });
};
var $daf6f037dd1463bd$export$2e2bcd8739ae039 = $daf6f037dd1463bd$var$FollowAction;

});
parcelRegister("fKjQL", function(module, exports) {
$parcel$export(module.exports, "renderNothingOnLoadError", () => $c9beb2656caae1e6$export$22053f1a0ee50fef);
$parcel$export(module.exports, "withSuspense", () => $c9beb2656caae1e6$export$a3bce93d4fb4eda6);
$parcel$export(module.exports, "getLazyIconComponent", () => $c9beb2656caae1e6$export$6d3762368dae787c);

var $fc4bM = parcelRequire("fc4bM");
const $c9beb2656caae1e6$var$RenderNothing = ()=>null;
const $c9beb2656caae1e6$export$22053f1a0ee50fef = ()=>({
        // Typed as `never` so the fallback is assignable to whatever component type the loader
        // resolves to, and `lazy()` keeps inferring that component's props.
        default: $c9beb2656caae1e6$var$RenderNothing
    });
const $c9beb2656caae1e6$export$a3bce93d4fb4eda6 = (LazyComponent, displayName)=>{
    // Typed loosely internally: TS cannot spread generic props onto a LazyExoticComponent.
    // The returned component is still strictly typed as ComponentType<P>.
    const Component = LazyComponent;
    const LazyComponentWithSuspense = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fc4bM.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Component, props));
    if (displayName) LazyComponentWithSuspense.displayName = displayName;
    return LazyComponentWithSuspense;
};
const $c9beb2656caae1e6$var$lazyIconCache = new Map();
const $c9beb2656caae1e6$export$6d3762368dae787c = (cacheKey, importFn)=>{
    const cached = $c9beb2656caae1e6$var$lazyIconCache.get(cacheKey);
    if (cached) return cached;
    const LazyIcon = $c9beb2656caae1e6$export$a3bce93d4fb4eda6(/*#__PURE__*/ (0, $fc4bM.lazy)(()=>importFn().catch(()=>{
            $c9beb2656caae1e6$var$lazyIconCache.delete(cacheKey);
            return $c9beb2656caae1e6$export$22053f1a0ee50fef();
        })), `lazy(${cacheKey})`);
    $c9beb2656caae1e6$var$lazyIconCache.set(cacheKey, LazyIcon);
    return LazyIcon;
};

});

parcelRegister("hgUVU", function(module, exports) {
$parcel$export(module.exports, "importIcon", () => $8dfe592a2d0fad98$export$6dc831e1a0a7a851);

var $fCOgx = parcelRequire("fCOgx");
const $8dfe592a2d0fad98$export$6dc831e1a0a7a851 = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};

});

parcelRegister("haahN", function(module, exports) {
$parcel$export(module.exports, "default", () => $e1d77160d7cdcae0$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $fVrlX = parcelRequire("fVrlX");

var $4tlV7 = parcelRequire("4tlV7");

var $3qwGA = parcelRequire("3qwGA");

var $fypiH = parcelRequire("fypiH");

var $eswBw = parcelRequire("eswBw");

var $5JwWG = parcelRequire("5JwWG");
const $e1d77160d7cdcae0$var$ServerAction = ({ action: action, onClick: onClick, onError: onErrorCallback, ...props })=>{
    const [isLoading, setIsLoading] = (0, $fc4bM.useState)(false);
    const invoke = (0, $4tlV7.default)();
    const reload = (0, $fypiH.default)();
    const { fireEvent: fireEvent } = (0, $fVrlX.useAnalyticsEvents)();
    const handleClick = (0, $fc4bM.useCallback)(async ()=>{
        if (action) {
            var _action$action;
            const smartLinkActionType = (_action$action = action.action) === null || _action$action === void 0 ? void 0 : _action$action.actionType;
            try {
                setIsLoading(true);
                if (smartLinkActionType === 'FollowEntityAction' || smartLinkActionType === 'UnfollowEntityAction') fireEvent('ui.button.clicked.smartLinkFollowButton', {});
                else fireEvent(`ui.button.clicked.${smartLinkActionType}`, {});
                fireEvent('track.smartLinkQuickAction.started', {
                    smartLinkActionType: smartLinkActionType
                });
                const request = (0, $eswBw.default)(action);
                await invoke(request);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: smartLinkActionType
                });
                if (action.reload && action.reload.url) await reload({
                    url: action.reload.url,
                    isReloading: true,
                    id: action.reload.id
                });
                setIsLoading(false);
                if (onClick) onClick();
            } catch (err) {
                setIsLoading(false);
                fireEvent('track.smartLinkQuickAction.failed', {
                    smartLinkActionType: smartLinkActionType,
                    reason: (0, $3qwGA.getInvokeFailureReason)(err)
                });
                onErrorCallback === null || onErrorCallback === void 0 || onErrorCallback();
            }
        }
    }, [
        action,
        invoke,
        onClick,
        onErrorCallback,
        reload,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5JwWG.default), {
        ...props,
        isLoading: isLoading,
        onClick: handleClick
    });
};
var $e1d77160d7cdcae0$export$2e2bcd8739ae039 = $e1d77160d7cdcae0$var$ServerAction;

});
parcelRegister("4tlV7", function(module, exports) {
$parcel$export(module.exports, "default", () => $8cede23eb2259da6$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $jcnLN = parcelRequire("jcnLN");

var $fnEFU = parcelRequire("fnEFU");
const $8cede23eb2259da6$var$useInvoke = ()=>{
    const { connections: connections } = (0, $fnEFU.useSmartLinkContext)();
    const clientExt = (0, $jcnLN.useSmartLinkClientExtension)(connections.client);
    return (0, $fc4bM.useCallback)(async (req, cb)=>{
        const response = await clientExt.invoke(req);
        return cb ? cb(response) : response;
    }, [
        clientExt
    ]);
};
var $8cede23eb2259da6$export$2e2bcd8739ae039 = $8cede23eb2259da6$var$useInvoke;

});
parcelRegister("jcnLN", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkClientExtension", () => $41915700d6157708$export$303ede4eed148855);

var $fc4bM = parcelRequire("fc4bM");

var $jBHs2 = parcelRequire("jBHs2");

var $eq2cZ = parcelRequire("eq2cZ");

var $lLy0h = parcelRequire("lLy0h");
const $41915700d6157708$export$303ede4eed148855 = (cardClient)=>{
    const resolverUrl = (0, $lLy0h.useResolverUrl)(cardClient);
    const invoke = (0, $fc4bM.useCallback)(async (data)=>{
        try {
            return await (0, $jBHs2.request)('post', `${resolverUrl}/invoke`, data, undefined, [
                200,
                201,
                202,
                203,
                204
            ]);
        } catch (err) {
            // checking if the error is a Response type
            // since we already had a few HOTs caused by comparing with instanceOf',
            // we're verifying the type by the contents
            if (err && err.json && typeof err.json === 'function') {
                const errorBody = await err.json();
                if (errorBody) throw new (0, $eq2cZ.InvokeError)(errorBody === null || errorBody === void 0 ? void 0 : errorBody.error.message, errorBody === null || errorBody === void 0 ? void 0 : errorBody.error.status);
            }
            throw err;
        }
    }, [
        resolverUrl
    ]);
    return (0, $fc4bM.useMemo)(()=>({
            invoke: invoke
        }), [
        invoke
    ]);
};

});
parcelRegister("eq2cZ", function(module, exports) {
$parcel$export(module.exports, "SmartLinkActionType", () => $f3191c345841c64f$export$6324b7946ad663e9);
$parcel$export(module.exports, "InvokeError", () => $f3191c345841c64f$export$d4d72202bff63658);
/**
 * The enum that describes Smart Link action types
 */ var $f3191c345841c64f$export$6324b7946ad663e9 = /*#__PURE__*/ function(SmartLinkActionType) {
    SmartLinkActionType["FollowEntityAction"] = "FollowEntityAction";
    SmartLinkActionType["GetStatusTransitionsAction"] = "GetStatusTransitionsAction";
    SmartLinkActionType["StatusUpdateAction"] = "StatusUpdateAction";
    SmartLinkActionType["UnfollowEntityAction"] = "UnfollowEntityAction";
    return SmartLinkActionType;
}({});
class $f3191c345841c64f$export$d4d72202bff63658 extends Error {
    constructor(message, errorCode){
        super(message);
        this.errorCode = errorCode;
    }
}

});

parcelRegister("lLy0h", function(module, exports) {
$parcel$export(module.exports, "useResolverUrl", () => $f773afe77c1b59a6$export$d08617a365fbe694);

var $fc4bM = parcelRequire("fc4bM");

var $jW4zs = parcelRequire("jW4zs");
const $f773afe77c1b59a6$export$d08617a365fbe694 = (cardClient)=>(0, $fc4bM.useMemo)(()=>(0, $jW4zs.getResolverUrl)(cardClient === null || cardClient === void 0 ? void 0 : cardClient.envKey, cardClient === null || cardClient === void 0 ? void 0 : cardClient.baseUrlOverride), [
        cardClient === null || cardClient === void 0 ? void 0 : cardClient.baseUrlOverride,
        cardClient === null || cardClient === void 0 ? void 0 : cardClient.envKey
    ]);

});



parcelRegister("3qwGA", function(module, exports) {
$parcel$export(module.exports, "getInvokeFailureReason", () => $1cd6e8e439d618fe$export$65b3f792dff0bd60);

var $9JzR9 = parcelRequire("9JzR9");

var $6Jlpv = parcelRequire("6Jlpv");
const $1cd6e8e439d618fe$export$65b3f792dff0bd60 = (err)=>{
    if (!(0, $6Jlpv.isInvokeCustomError)(err)) return (0, $9JzR9.TrackQuickActionFailureReason).UnknownError;
    switch(err === null || err === void 0 ? void 0 : err.errorCode){
        case 403:
            return (0, $9JzR9.TrackQuickActionFailureReason).PermissionError;
        default:
            return (0, $9JzR9.TrackQuickActionFailureReason).UnknownError;
    }
};

});
parcelRegister("6Jlpv", function(module, exports) {
$parcel$export(module.exports, "isInvokeCustomError", () => $8883daba74a65b3b$export$1694272377fa07d8);
const $8883daba74a65b3b$export$1694272377fa07d8 = (err)=>(err === null || err === void 0 ? void 0 : err.message) !== undefined && (err === null || err === void 0 ? void 0 : err.errorCode) !== undefined;

});


parcelRegister("eswBw", function(module, exports) {
$parcel$export(module.exports, "default", () => $57440e3c17269358$export$2e2bcd8739ae039);
const $57440e3c17269358$var$createInvokeRequest = (request, payload)=>({
        action: {
            ...request.action,
            payload: payload
        },
        providerKey: request.providerKey
    });
var $57440e3c17269358$export$2e2bcd8739ae039 = $57440e3c17269358$var$createInvokeRequest;

});


parcelRegister("1gm8B", function(module, exports) {
$parcel$export(module.exports, "getFollowActionErrorMessage", () => $76ec90f965ad651f$export$49248678d3914625);

var $k2M4v = parcelRequire("k2M4v");

var $ewFKq = parcelRequire("ewFKq");
const $76ec90f965ad651f$export$49248678d3914625 = (isProject = false, isFollow = false)=>{
    if (isProject && isFollow) return (0, $k2M4v.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $ewFKq.messages).follow_project_errorGalaxia : (0, $ewFKq.messages).follow_project_error;
    if (isProject && !isFollow) return (0, $k2M4v.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $ewFKq.messages).unfollow_project_errorGalaxia : (0, $ewFKq.messages).unfollow_project_error;
    if (!isProject && isFollow) return (0, $ewFKq.messages).follow_goal_error;
    if (!isProject && !isFollow) return (0, $ewFKq.messages).unfollow_goal_error;
    return (0, $ewFKq.messages).generic_error_message;
};

});

parcelRegister("9irtk", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("4N0ky"),
    $9dnsd("3epM8")
]).then(()=>parcelRequire('42R6A'));

});

parcelRegister("iEnVh", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("4enTb"),
    $9dnsd("gKwhT")
]).then(()=>parcelRequire('aMsif'));

});


parcelRegister("8gSVN", function(module, exports) {
$parcel$export(module.exports, "default", () => $40c7546d951f3e90$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");
var $gpjDl = parcelRequire("gpjDl");

var $5uAqu = parcelRequire("5uAqu");

var $4seZv = parcelRequire("4seZv");

var $dRkX9 = parcelRequire("dRkX9");

var $aEmSo = parcelRequire("aEmSo");

var $j9rqA = parcelRequire("j9rqA");

var $ewFKq = parcelRequire("ewFKq");

var $dweer = parcelRequire("dweer");

var $cA6hx = parcelRequire("cA6hx");

var $5JwWG = parcelRequire("5JwWG");
const $40c7546d951f3e90$var$PreviewAction = ({ onClick: onClickCallback, ...props })=>{
    var _context$actions, _context$linkTitle;
    const intl = (0, $gpjDl.default)();
    const context = (0, $dweer.useFlexibleUiContext)();
    const invoke = (0, $cA6hx.default)({});
    const data = context === null || context === void 0 || (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[(0, $j9rqA.ActionName).PreviewAction];
    const hasPreviewPanel = data === null || data === void 0 ? void 0 : data.hasPreviewPanel;
    const onClick = (0, $fc4bM.useCallback)(()=>{
        if (data !== null && data !== void 0 && data.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback === null || onClickCallback === void 0 || onClickCallback();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const tooltipMessage = isStackItem ? (0, $ewFKq.messages).preview_description : (0, $ewFKq.messages).preview_improved;
    const actionIcon = (0, $fc4bM.useCallback)(()=>{
        // Only use panel icon if experiment is enabled and hasPreviewPanel is true
        if ((0, $aEmSo.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && hasPreviewPanel) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4seZv))), {
            color: "currentColor",
            spacing: "spacious",
            label: "",
            size: props.iconSize
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uAqu))), {
            color: "currentColor",
            spacing: "spacious",
            label: "",
            size: props.iconSize
        });
    }, [
        hasPreviewPanel,
        props.iconSize
    ]);
    const actionLabel = (0, $fc4bM.useMemo)(()=>{
        // Only use panel message if experiment is enabled and hasPreviewPanel is true
        if ((0, $aEmSo.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && hasPreviewPanel) return (0, $ewFKq.messages).preview_panel;
        // Fall back to modal message if experiment is enabled, otherwise use original preview message
        if ((0, $aEmSo.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test')) return (0, $ewFKq.messages).preview_modal;
        return (0, $ewFKq.messages).preview_improved;
    }, [
        hasPreviewPanel
    ]);
    const actionMessage = intl.formatMessage(actionLabel);
    const title = context === null || context === void 0 || (_context$linkTitle = context.linkTitle) === null || _context$linkTitle === void 0 || (_context$linkTitle = _context$linkTitle.text) === null || _context$linkTitle === void 0 ? void 0 : _context$linkTitle.trim();
    let actionLabelWithTitle = (0, $ewFKq.messages).preview_with_title;
    if (actionLabel === (0, $ewFKq.messages).preview_panel) actionLabelWithTitle = (0, $ewFKq.messages).preview_panel_with_title;
    else if (actionLabel === (0, $ewFKq.messages).preview_modal) actionLabelWithTitle = (0, $ewFKq.messages).preview_modal_with_title;
    const ariaLabel = (0, $dRkX9.fg)('platform_smart_link_preview_a11y_label') && title ? intl.formatMessage(actionLabelWithTitle, {
        title: title
    }) : actionMessage;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5JwWG.default), {
        ariaLabel: ariaLabel,
        content: actionMessage,
        icon: actionIcon(),
        onClick: onClick,
        testId: "smart-action-preview-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), tooltipMessage),
        hideTooltipOnMouseDown: true,
        ...data,
        ...props
    }) : null;
};
var $40c7546d951f3e90$export$2e2bcd8739ae039 = $40c7546d951f3e90$var$PreviewAction;

});

parcelRegister("8Up1A", function(module, exports) {
$parcel$export(module.exports, "default", () => $84dc1f93c8edef2a$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $j9rqA = parcelRequire("j9rqA");

var $dweer = parcelRequire("dweer");

var $cA6hx = parcelRequire("cA6hx");

var $eXUZB = parcelRequire("eXUZB");

var $hcvQy = parcelRequire("hcvQy");

var $5JwWG = parcelRequire("5JwWG");
const $84dc1f93c8edef2a$var$DEFAULT_PROMPTS = [];
const $84dc1f93c8edef2a$var$RovoChatAction = ({ onClick: onClickCallback, prompts: prompts, testId: testId = 'smart-action-rovo-chat-action', ...props })=>{
    var _context$actions;
    const intl = (0, $gpjDl.default)();
    const { isRovoChatEnabled: isRovoChatEnabled, sendPromptMessage: sendPromptMessage } = (0, $eXUZB.default)();
    const context = (0, $dweer.useFlexibleUiContext)();
    const data = context === null || context === void 0 || (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[(0, $j9rqA.ActionName).RovoChatAction];
    const resolvedPrompts = (0, $fc4bM.useMemo)(()=>{
        if (prompts) return prompts;
        return $84dc1f93c8edef2a$var$DEFAULT_PROMPTS;
    }, [
        prompts
    ]);
    const invoke = (0, $cA6hx.default)({});
    const onClick = (0, $fc4bM.useCallback)((promptData, promptKey)=>{
        if (promptData && data !== null && data !== void 0 && data.invokeAction) {
            invoke({
                ...data === null || data === void 0 ? void 0 : data.invokeAction,
                actionFn: async ()=>sendPromptMessage(promptData),
                prompt: promptKey
            });
            onClickCallback === null || onClickCallback === void 0 || onClickCallback();
        }
    }, [
        data === null || data === void 0 ? void 0 : data.invokeAction,
        invoke,
        onClickCallback,
        sendPromptMessage
    ]);
    const promptActions = (0, $fc4bM.useMemo)(()=>{
        return resolvedPrompts.map((promptKey, idx)=>{
            const { icon: icon, content: content, tooltipMessage: tooltipMessage, data: promptData } = (0, $hcvQy.getPromptAction)({
                promptKey: promptKey,
                intl: intl,
                url: data === null || data === void 0 ? void 0 : data.url,
                product: data === null || data === void 0 ? void 0 : data.product,
                iconSize: props.iconSize,
                cardAppearance: props.cardAppearance
            }) || {};
            return promptData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5JwWG.default), {
                content: content,
                icon: icon,
                key: promptKey,
                onClick: ()=>onClick(promptData, promptKey),
                testId: `${testId}-${idx + 1}`,
                tooltipMessage: tooltipMessage,
                ...props
            }) : null;
        });
    }, [
        data,
        intl,
        onClick,
        resolvedPrompts,
        props,
        testId
    ]);
    return isRovoChatEnabled && data && (promptActions === null || promptActions === void 0 ? void 0 : promptActions.length) > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, promptActions) : null;
};
var $84dc1f93c8edef2a$export$2e2bcd8739ae039 = $84dc1f93c8edef2a$var$RovoChatAction;

});
parcelRegister("eXUZB", function(module, exports) {
$parcel$export(module.exports, "default", () => $265555976b957f6d$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $8e3eG = parcelRequire("8e3eG");

var $f4Od9 = parcelRequire("f4Od9");

var $gysdQ = parcelRequire("gysdQ");
const $265555976b957f6d$var$SMART_LINK_TO_ROVO_SOURCE = 'smart-link';
const $265555976b957f6d$var$useRovoChat = ()=>{
    const { rovoOptions: config } = (0, $gysdQ.default)();
    const { publishWithPostMessage: publishWithPostMessage } = (0, $8e3eG.useRovoPostMessageToPubsub)();
    const isRovoChatEnabled = (0, $f4Od9.getIsRovoChatEnabled)(config);
    const sendPromptMessage = (0, $fc4bM.useCallback)((data)=>{
        publishWithPostMessage({
            targetWindow: window.parent ?? window,
            payload: {
                type: 'chat-new',
                source: $265555976b957f6d$var$SMART_LINK_TO_ROVO_SOURCE,
                data: {
                    dialogues: [],
                    ...data,
                    agentId: undefined
                },
                openChat: true,
                openChatMode: 'sidebar'
            },
            onAcknowledgeTimeout: ()=>{
            // NAVX-3599: Add analytics event
            }
        });
    }, [
        publishWithPostMessage
    ]);
    return (0, $fc4bM.useMemo)(()=>({
            isRovoChatEnabled: isRovoChatEnabled,
            sendPromptMessage: sendPromptMessage
        }), [
        isRovoChatEnabled,
        sendPromptMessage
    ]);
};
var $265555976b957f6d$export$2e2bcd8739ae039 = $265555976b957f6d$var$useRovoChat;

});


parcelRegister("aV7nQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1288ddeef72252b$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");

var $fVrlX = parcelRequire("fVrlX");

var $ewFKq = parcelRequire("ewFKq");

var $dweer = parcelRequire("dweer");

var $hjl3F = parcelRequire("hjl3F");

var $5JwWG = parcelRequire("5JwWG");

var $aLg0q = parcelRequire("aLg0q");

const $c1288ddeef72252b$var$RelatedLinksModal = /*#__PURE__*/ (0, $fc4bM.lazy)(()=>(parcelRequire("cnlYf")));
const $c1288ddeef72252b$var$ViewRelatedLinksAction = ({ onClick: onClickCallback, ...props })=>{
    var _context$actions;
    const modal = (0, $hjl3F.useSmartLinkModal)();
    const context = (0, $dweer.useFlexibleUiContext)();
    const actionData = context === null || context === void 0 || (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions.ViewRelatedLinksAction;
    const { fireEvent: fireEvent } = (0, $fVrlX.useAnalyticsEvents)();
    const onClick = (0, $fc4bM.useCallback)(()=>{
        const ari = actionData === null || actionData === void 0 ? void 0 : actionData.ari;
        if (ari) modal.open(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($c1288ddeef72252b$var$RelatedLinksModal, {
            ari: ari,
            showModal: true,
            onClose: ()=>modal.close()
        }));
        fireEvent('ui.button.clicked.relatedLinks', {});
        onClickCallback === null || onClickCallback === void 0 || onClickCallback();
    }, [
        actionData === null || actionData === void 0 ? void 0 : actionData.ari,
        fireEvent,
        modal,
        onClickCallback
    ]);
    return actionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5JwWG.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $ewFKq.messages).related_links_view_related_links),
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $ewFKq.messages).related_links_view_related_links),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $aLg0q.default), {
            iconSize: props.iconSize
        }),
        onClick: onClick,
        testId: "smart-action-view-related-links-action",
        ariaLabel: "View most recent pages or content types coming from or found on this link",
        ...props
    }) : null;
};
var $c1288ddeef72252b$export$2e2bcd8739ae039 = $c1288ddeef72252b$var$ViewRelatedLinksAction;

});
parcelRegister("aLg0q", function(module, exports) {
$parcel$export(module.exports, "default", () => $c5cac8a6498d6ace$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $bcRo2 = parcelRequire("bcRo2");
const $c5cac8a6498d6ace$var$RelatedLinksActionIcon = ({ iconSize: iconSize })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bcRo2))), {
        color: "currentColor",
        spacing: "spacious",
        label: '',
        size: iconSize
    });
var $c5cac8a6498d6ace$export$2e2bcd8739ae039 = $c5cac8a6498d6ace$var$RelatedLinksActionIcon;

});

parcelRegister("cnlYf", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("ev4nP").then(()=>parcelRequire('ji1nY'));

});




parcelRegister("kx9O1", function(module, exports) {
$parcel$export(module.exports, "default", () => $28c2001909039a2e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $dBtOK = parcelRequire("dBtOK");

var $j9rqA = parcelRequire("j9rqA");

var $dweer = parcelRequire("dweer");

var $iy8ED = parcelRequire("iy8ED");

var $4tJOd = parcelRequire("4tJOd");

var $gndj3 = parcelRequire("gndj3");

var $2UGy7 = parcelRequire("2UGy7");
const $28c2001909039a2e$var$styles = {
    titleBoxCard: "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bsb1osq"
};
/**
 * Represents an Errored TitleBlock view.
 * This will render when a Smart Link did not successfully resolve.
 * This may be a result of a Smart Link not having the correct credentials,
 * or the backend response was errored or malformed.
 * @see TitleBlock
 */ const $28c2001909039a2e$var$TitleBlockErroredView = ({ actionGroup: actionGroup, hideRetry: hideRetry, retry: _retry, position: position, testId: testId, title: title, icon: icon, hideIcon: hideIcon, CompetitorPrompt: CompetitorPrompt, ...blockProps })=>{
    var _context$actions;
    const context = (0, $dweer.useFlexibleUiContext)();
    const showRetry = !hideRetry && Boolean(context === null || context === void 0 || (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[(0, $j9rqA.InternalActionName).UnresolvedAction]);
    const competitorPrompt = CompetitorPrompt && context !== null && context !== void 0 && context.url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(CompetitorPrompt, {
        sourceUrl: context === null || context === void 0 ? void 0 : context.url,
        linkType: 'card'
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gndj3.default), {
        ...blockProps,
        testId: `${testId}-errored-view`
    }, !hideIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4tJOd.default), {
        overrideIcon: icon,
        position: position
    }), competitorPrompt ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        xcss: $28c2001909039a2e$var$styles.titleBoxCard
    }, title, competitorPrompt) : title, showRetry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2UGy7.default), {
        align: (0, $j9rqA.SmartLinkAlignment).Right
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $iy8ED.default), {
        testId: testId
    })), actionGroup);
};
var $28c2001909039a2e$export$2e2bcd8739ae039 = $28c2001909039a2e$var$TitleBlockErroredView;

});
parcelRegister("iy8ED", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7c84851f8aaa00b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");

var $4Cnkn = parcelRequire("4Cnkn");

var $dBtOK = parcelRequire("dBtOK");

var $EawnW = parcelRequire("EawnW");

var $j9rqA = parcelRequire("j9rqA");

var $dweer = parcelRequire("dweer");
const $b7c84851f8aaa00b$var$styles = {
    button: "_1e0c1bgi",
    padding: "_18zrutpp",
    message: "_1rjcze3t _18zrze3t"
};
const $b7c84851f8aaa00b$var$UnresolvedAction = ({ testId: testId = 'unresolved-action', hasPadding: hasPadding = false })=>{
    var _context$actions;
    const context = (0, $dweer.useFlexibleUiContext)();
    const data = context === null || context === void 0 || (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[(0, $j9rqA.InternalActionName).UnresolvedAction];
    if (!data) return null;
    const { descriptor: descriptor, onClick: onClick, values: values } = data;
    const hasAction = onClick !== undefined;
    const message = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        testId: `${testId}-errored-view-message`,
        tabIndex: hasAction ? 0 : undefined,
        xcss: (0, $4Cnkn.cx)($b7c84851f8aaa00b$var$styles.message, hasPadding && $b7c84851f8aaa00b$var$styles.padding)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), {
        ...descriptor,
        values: values
    }));
    return hasAction ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $EawnW.Pressable), {
        onClick: data.onClick,
        style: {
            color: `inherit`,
            font: `inherit`,
            textAlign: `inherit`
        },
        xcss: $b7c84851f8aaa00b$var$styles.button
    }, message) : message;
};
var $b7c84851f8aaa00b$export$2e2bcd8739ae039 = $b7c84851f8aaa00b$var$UnresolvedAction;

});

parcelRegister("4tJOd", function(module, exports) {
$parcel$export(module.exports, "default", () => $72218766811f6a9e$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $dweer = parcelRequire("dweer");

var $4IHO5 = parcelRequire("4IHO5");
var $iK3aR = parcelRequire("iK3aR");

var $2Dio3 = parcelRequire("2Dio3");
const $72218766811f6a9e$var$LinkIconElement = (props)=>{
    var _context$meta, _context$type, _linkIconProps$label, _context$meta2, _linkIconProps$label2;
    const context = (0, $dweer.useFlexibleUiContext)();
    if (!context) return null;
    const linkIconProps = (0, $iK3aR.toLinkIconProps)(context === null || context === void 0 ? void 0 : context.linkIcon, context.type);
    if (!linkIconProps) return null;
    const jiraIssueTypeLabel = ((_context$meta = context.meta) === null || _context$meta === void 0 ? void 0 : _context$meta.resourceType) === 'issue' && (_context$type = context.type) !== null && _context$type !== void 0 && _context$type.includes('atlassian:Task') ? (_linkIconProps$label = linkIconProps.label) === null || _linkIconProps$label === void 0 ? void 0 : _linkIconProps$label.trim() : undefined;
    const label = jiraIssueTypeLabel ?? (0, $2Dio3.resourceTypeToLabel)((_context$meta2 = context.meta) === null || _context$meta2 === void 0 ? void 0 : _context$meta2.resourceType) ?? ((_linkIconProps$label2 = linkIconProps.label) === null || _linkIconProps$label2 === void 0 ? void 0 : _linkIconProps$label2.trim()) ?? props.label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4IHO5.default), {
        ...linkIconProps,
        ...props,
        label: label,
        name: (0, $j9rqA.ElementName).LinkIcon
    });
};
var $72218766811f6a9e$export$2e2bcd8739ae039 = $72218766811f6a9e$var$LinkIconElement;

});
parcelRegister("4IHO5", function(module, exports) {
$parcel$export(module.exports, "default", () => $b0e01fcd1f2556c4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $inMs5 = parcelRequire("inMs5");

var $dRkX9 = parcelRequire("dRkX9");

var $dBtOK = parcelRequire("dBtOK");

var $A0kxW = parcelRequire("A0kxW");

var $j9rqA = parcelRequire("j9rqA");

var $4mDZ7 = parcelRequire("4mDZ7");

var $47s0i = parcelRequire("47s0i");

var $89a4S = parcelRequire("89a4S");
const $b0e01fcd1f2556c4$var$styles = {
    container: "_1ul91ns9",
    iconWrapperStyle: "_1e0c1txw _4cvr1h6o _1bah1h6o"
};
const $b0e01fcd1f2556c4$var$positionStyleMap = {
    center: "_1wpz1h6o",
    top: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wpz1y6m"
};
const $b0e01fcd1f2556c4$var$customRenderStyleMap = {
    xlarge: "_1reo15vq _18m915vq _11c810sd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km1q9y _1xjx1osq _e2oo1osq _102kz42d",
    large: "_1reo15vq _18m915vq _11c810sd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km1q9y _1xjx1osq _e2oo1osq _102kz42d",
    medium: "_1reo15vq _18m915vq _11c81e3o _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km1q9y _1xjx1osq _e2oo1osq _102kptym",
    small: "_1reo15vq _18m915vq _11c81e3o _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km1q9y _1xjx1osq _e2oo1osq _102kptym"
};
const $b0e01fcd1f2556c4$var$renderAtlaskitIcon = (icon, testId, size = (0, $j9rqA.SmartLinkSize).Medium, label, isTiledIcon)=>{
    if (icon) return /*#__PURE__*/ $fc4bM.createElement((0, $47s0i.default), {
        icon: icon,
        testId: `${testId}-icon`,
        label: label,
        size: size,
        isTiledIcon: isTiledIcon
    });
};
const $b0e01fcd1f2556c4$var$renderDefaultIcon = (label, testId)=>/*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($inMs5))), {
        label: label,
        testId: `${testId}-default`,
        color: "currentColor"
    });
const $b0e01fcd1f2556c4$var$widthFromSize = (size, isTiledIcon)=>{
    switch(size){
        case (0, $j9rqA.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $j9rqA.SmartLinkSize).Large:
            return "var(--ds-space-300, 24px)";
        case (0, $j9rqA.SmartLinkSize).Medium:
            return isTiledIcon ? "var(--ds-space-250, 20px)" : "var(--ds-space-200, 16px)";
        case (0, $j9rqA.SmartLinkSize).Small:
            return "var(--ds-space-200, 16px)";
        default:
            return "var(--ds-space-200, 16px)";
    }
};
const $b0e01fcd1f2556c4$var$renderImageIcon = (defaultIcon, url, testId, size = (0, $j9rqA.SmartLinkSize).Medium, appearance, hideLoadingSkeleton, label)=>{
    const width = size === (0, $j9rqA.SmartLinkSize).Large ? "var(--ds-space-300, 24px)" : "var(--ds-space-200, 16px)";
    if (url) return /*#__PURE__*/ $fc4bM.createElement((0, $4mDZ7.default), {
        label: label,
        defaultIcon: defaultIcon,
        testId: testId,
        url: url,
        width: width,
        height: width,
        appearance: appearance,
        hideLoadingSkeleton: hideLoadingSkeleton
    });
};
const $b0e01fcd1f2556c4$var$renderImageIconNew = (defaultIcon, url, testId, size = (0, $j9rqA.SmartLinkSize).Medium, appearance, hideLoadingSkeleton, label, isTiledIcon = false)=>{
    const width = $b0e01fcd1f2556c4$var$widthFromSize(size, isTiledIcon);
    if (url) return /*#__PURE__*/ $fc4bM.createElement((0, $4mDZ7.default), {
        label: label,
        defaultIcon: defaultIcon,
        testId: testId,
        url: url,
        width: width,
        height: width,
        appearance: appearance,
        hideLoadingSkeleton: hideLoadingSkeleton
    });
};
/**
 * A base element that displays an Icon or favicon.
 * @internal
 * @param props - The props necessary for the Icon element.
 * @see LinkIcon
 */ const $b0e01fcd1f2556c4$var$IconElement = ({ icon: icon, overrideIcon: overrideIcon, label: labelProp, name: name, position: position = (0, $j9rqA.SmartLinkPosition).Top, className: className, render: render, size: size = (0, $j9rqA.SmartLinkSize).Medium, testId: testId = 'smart-element-icon', url: url, appearance: appearance = 'square', hideLoadingSkeleton: hideLoadingSkeleton, isTiledIcon: isTiledIcon })=>{
    const label = labelProp ?? '';
    const element = (0, $fc4bM.useMemo)(()=>{
        const defaultIcon = $b0e01fcd1f2556c4$var$renderDefaultIcon(label, testId);
        return overrideIcon || (render === null || render === void 0 ? void 0 : render()) || ((0, $dRkX9.fg)('platform_sl_3p_preauth_better_hovercard_killswitch') ? $b0e01fcd1f2556c4$var$renderImageIconNew(defaultIcon, url, testId, size, appearance, hideLoadingSkeleton, label, isTiledIcon) : $b0e01fcd1f2556c4$var$renderImageIcon(defaultIcon, url, testId, size, appearance, hideLoadingSkeleton, label)) || $b0e01fcd1f2556c4$var$renderAtlaskitIcon(icon, testId, size, label, isTiledIcon) || defaultIcon;
    }, [
        label,
        testId,
        overrideIcon,
        render,
        url,
        size,
        appearance,
        hideLoadingSkeleton,
        icon,
        isTiledIcon
    ]);
    const width = (0, $89a4S.getIconWidth)(size);
    return /*#__PURE__*/ $fc4bM.createElement("div", {
        "data-smart-element": name,
        "data-smart-element-icon": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $2R2iS.default)([
            $b0e01fcd1f2556c4$var$styles.container,
            $b0e01fcd1f2556c4$var$positionStyleMap[position],
            render && $b0e01fcd1f2556c4$var$customRenderStyleMap[size],
            className
        ])
    }, isTiledIcon ? // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- the rule does not yet recognise @atlaskit/primitives subpath entry points
    /*#__PURE__*/ $fc4bM.createElement((0, $A0kxW.default), {
        size: size,
        hasBorder: true,
        backgroundColor: "white",
        label: label,
        testId: `${testId}-tile`
    }, element) : /*#__PURE__*/ $fc4bM.createElement((0, $dBtOK.Box), {
        xcss: $b0e01fcd1f2556c4$var$styles.iconWrapperStyle,
        testId: `${testId}-box`,
        style: {
            width: width,
            height: width
        }
    }, element));
};
var $b0e01fcd1f2556c4$export$2e2bcd8739ae039 = $b0e01fcd1f2556c4$var$IconElement;

});
parcelRegister("47s0i", function(module, exports) {
$parcel$export(module.exports, "default", () => $b43d37355b189b62$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $fCOgx = parcelRequire("fCOgx");

var $1AiIz = parcelRequire("1AiIz");

var $eLXbZ = parcelRequire("eLXbZ");

var $6lBxt = parcelRequire("6lBxt");

var $dRkX9 = parcelRequire("dRkX9");

var $j1cIb = parcelRequire("j1cIb");

var $j9rqA = parcelRequire("j9rqA");

var $eYOWo = parcelRequire("eYOWo");

var $1wanW = parcelRequire("1wanW");

var $fKjQL = parcelRequire("fKjQL");
const $b43d37355b189b62$var$getIconImportFn = (icon, size)=>{
    const item = (0, $eYOWo.getLazyIcons)()[icon];
    if ((0, $1wanW.isIconSizeLarge)(size) && item !== null && item !== void 0 && item.large) return item.large;
    return item === null || item === void 0 ? void 0 : item.default;
};
// Only used when platform_sl_replace_react_loadable is on. Kept separate from getIconImportFn so
// the gate-off path is unchanged.
const $b43d37355b189b62$var$getLazyIcon = (icon, size)=>{
    const item = (0, $eYOWo.getLazyIcons)()[icon];
    if ((0, $1wanW.isIconSizeLarge)(size) && item !== null && item !== void 0 && item.large) return (0, $fKjQL.getLazyIconComponent)(`${icon}:large`, item.large);
    return item !== null && item !== void 0 && item.default ? (0, $fKjQL.getLazyIconComponent)(`${icon}:default`, item.default) : undefined;
};
const $b43d37355b189b62$var$importIcon = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};

const $b43d37355b189b62$var$getBlogIcon = ()=>(parcelRequire("c5OI8")).default;

const $b43d37355b189b62$var$getDocumentIcon = ()=>(parcelRequire("egB9d")).default;

const $b43d37355b189b62$var$getLiveDocumentIcon = ()=>(parcelRequire("5q3t2")).default;
const $b43d37355b189b62$var$PRIORITY_ICONS = [
    (0, $j9rqA.IconType).PriorityBlocker,
    (0, $j9rqA.IconType).PriorityCritical,
    (0, $j9rqA.IconType).PriorityHigh,
    (0, $j9rqA.IconType).PriorityHighest,
    (0, $j9rqA.IconType).PriorityLow,
    (0, $j9rqA.IconType).PriorityLowest,
    (0, $j9rqA.IconType).PriorityMajor,
    (0, $j9rqA.IconType).PriorityMedium,
    (0, $j9rqA.IconType).PriorityMinor,
    (0, $j9rqA.IconType).PriorityTrivial
];
const $b43d37355b189b62$var$isCoreIcon = (icon)=>{
    return [
        (0, $j9rqA.IconType).Project,
        (0, $j9rqA.IconType).Template,
        (0, $j9rqA.IconType).Forbidden,
        (0, $j9rqA.IconType).Default,
        (0, $j9rqA.IconType).Error,
        (0, $j9rqA.IconType).Attachment,
        (0, $j9rqA.IconType).CheckItem,
        (0, $j9rqA.IconType).Component,
        (0, $j9rqA.IconType).Comment,
        (0, $j9rqA.IconType).View,
        (0, $j9rqA.IconType).React,
        (0, $j9rqA.IconType).Vote,
        (0, $j9rqA.IconType).PriorityUndefined,
        (0, $j9rqA.IconType).ProgrammingLanguage,
        (0, $j9rqA.IconType).Subscriber,
        (0, $j9rqA.IconType).SubTasksProgress,
        ...$b43d37355b189b62$var$PRIORITY_ICONS
    ].includes(icon);
};
const $b43d37355b189b62$var$AtlaskitIcon = ({ icon: icon, label: label, testId: testId, size: size = (0, $j9rqA.SmartLinkSize).Medium, isTiledIcon: isTiledIcon })=>{
    // Intentionally keep these three icon types synchronous and outside lazy imports.
    // These icons should be present in SSR markup so hydration does not cause a
    // visible empty-state-then-pop-in transition in Smart Link consumers.
    switch(icon){
        case (0, $j9rqA.IconType).Document:
            {
                const DocumentIcon = $b43d37355b189b62$var$getDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(DocumentIcon, {
                    label: label ?? 'document',
                    testId: testId,
                    size: size,
                    isTiledIcon: isTiledIcon
                });
            }
        case (0, $j9rqA.IconType).Blog:
            {
                const BlogIcon = $b43d37355b189b62$var$getBlogIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(BlogIcon, {
                    label: label ?? 'blog',
                    testId: testId,
                    size: size,
                    isTiledIcon: isTiledIcon
                });
            }
        case (0, $j9rqA.IconType).LiveDocument:
            {
                const LiveDocumentIcon = $b43d37355b189b62$var$getLiveDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(LiveDocumentIcon, {
                    label: label ?? 'live-doc',
                    testId: testId,
                    size: size,
                    isTiledIcon: isTiledIcon
                });
            }
    }
    let ImportedIcon;
    if ((0, $dRkX9.fg)('platform_sl_replace_react_loadable')) {
        ImportedIcon = $b43d37355b189b62$var$getLazyIcon(icon, size);
        if (!ImportedIcon) return null;
    } else {
        const importFn = $b43d37355b189b62$var$getIconImportFn(icon, size);
        if (!importFn) return null;
        ImportedIcon = $b43d37355b189b62$var$importIcon(importFn);
    }
    if ($b43d37355b189b62$var$isCoreIcon(icon)) {
        let color;
        if (icon === (0, $j9rqA.IconType).Error || icon === (0, $j9rqA.IconType).Forbidden) color = "var(--ds-icon-danger, #C9372C)";
        switch(size){
            case (0, $j9rqA.SmartLinkSize).Small:
            case (0, $j9rqA.SmartLinkSize).Medium:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(ImportedIcon, {
                    label: label,
                    testId: testId,
                    color: color
                });
            case (0, $j9rqA.SmartLinkSize).Large:
            case (0, $j9rqA.SmartLinkSize).XLarge:
                if ($b43d37355b189b62$var$PRIORITY_ICONS.includes(icon)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(ImportedIcon, {
                    label: label,
                    testId: testId,
                    color: color
                });
                let appearance;
                if (icon === (0, $j9rqA.IconType).Error || icon === (0, $j9rqA.IconType).Forbidden) appearance = 'redBold';
                else if ((0, $dRkX9.fg)('platform_lp_non_bold_large_sl_icon')) appearance = 'gray';
                else appearance = 'grayBold';
                const iconTileSize = (0, $j1cIb.transformSmartLinkSizeToIconTileSize)(size);
                if (iconTileSize) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1AiIz.default), {
                    appearance: appearance,
                    icon: isTiledIcon ? (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(ImportedIcon, {
                            ...iconProps,
                            spacing: "spacious"
                        }) : ImportedIcon,
                    size: iconTileSize,
                    label: label ?? ''
                });
                else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(ImportedIcon, {
                    label: label,
                    testId: testId,
                    color: color
                });
        }
    }
    switch(icon){
        case (0, $j9rqA.IconType).Confluence:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eLXbZ.ConfluenceIcon), {
                appearance: "brand",
                testId: testId,
                label: "",
                size: size === (0, $j9rqA.SmartLinkSize).Large || size === (0, $j9rqA.SmartLinkSize).XLarge ? 'small' : 'xxsmall'
            });
        case (0, $j9rqA.IconType).Jira:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6lBxt.JiraIcon), {
                appearance: "brand",
                testId: testId,
                label: "",
                size: size === (0, $j9rqA.SmartLinkSize).Large || size === (0, $j9rqA.SmartLinkSize).XLarge ? 'small' : 'xxsmall'
            });
        case (0, $j9rqA.IconType).Error:
        case (0, $j9rqA.IconType).Forbidden:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(ImportedIcon, {
                label: label,
                testId: testId,
                size: size,
                isTiledIcon: isTiledIcon
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(ImportedIcon, {
                label: label,
                testId: testId,
                size: size,
                isTiledIcon: isTiledIcon
            });
    }
};
var $b43d37355b189b62$export$2e2bcd8739ae039 = $b43d37355b189b62$var$AtlaskitIcon;

});
parcelRegister("j1cIb", function(module, exports) {
$parcel$export(module.exports, "transformSmartLinkSizeToIconTileSize", () => $4e7ce844f49804df$export$3acc3fb10995f020);

var $j9rqA = parcelRequire("j9rqA");
const $4e7ce844f49804df$export$3acc3fb10995f020 = (size)=>{
    switch(size){
        case (0, $j9rqA.SmartLinkSize).Small:
        case (0, $j9rqA.SmartLinkSize).Medium:
            return undefined;
        case (0, $j9rqA.SmartLinkSize).XLarge:
        case (0, $j9rqA.SmartLinkSize).Large:
            return 'small';
        default:
            return undefined;
    }
};

});

parcelRegister("eYOWo", function(module, exports) {
$parcel$export(module.exports, "getLazyIcons", () => $37bce316f4039a56$export$92d31eb5326761b6);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

const $37bce316f4039a56$var$loadPriorityIcons = ()=>(parcelRequire("gIIaP"));














































































const $37bce316f4039a56$export$92d31eb5326761b6 = ()=>{
    return {
        // IconTile wrappers (@atlaskit/icon/core/* wrapped in <IconTile> with color)
        [(0, $j9rqA.IconType).Document]: {
            default: ()=>Promise.resolve((parcelRequire("egB9d")))
        },
        [(0, $j9rqA.IconType).Audio]: {
            default: ()=>(parcelRequire("f0gNQ"))
        },
        [(0, $j9rqA.IconType).Code]: {
            default: ()=>(parcelRequire("d7MTx"))
        },
        [(0, $j9rqA.IconType).File]: {
            default: ()=>(parcelRequire("9ggnx"))
        },
        [(0, $j9rqA.IconType).Folder]: {
            default: ()=>(parcelRequire("h1Gad"))
        },
        [(0, $j9rqA.IconType).Generic]: {
            default: ()=>(parcelRequire("9ggnx"))
        },
        [(0, $j9rqA.IconType).Image]: {
            default: ()=>(parcelRequire("dZPOI"))
        },
        [(0, $j9rqA.IconType).Presentation]: {
            default: ()=>(parcelRequire("aU1fr"))
        },
        [(0, $j9rqA.IconType).Spreadsheet]: {
            default: ()=>(parcelRequire("lgvZN"))
        },
        [(0, $j9rqA.IconType).Video]: {
            default: ()=>(parcelRequire("jmXx5"))
        },
        // @atlaskit/icon/core/* (plain monochrome icons)
        [(0, $j9rqA.IconType).Project]: {
            default: ()=>(parcelRequire("6dLEG"))
        },
        [(0, $j9rqA.IconType).Template]: {
            default: ()=>(parcelRequire("kXyGS"))
        },
        [(0, $j9rqA.IconType).Forbidden]: {
            default: ()=>(parcelRequire("ij8gp"))
        },
        [(0, $j9rqA.IconType).Default]: {
            default: ()=>Promise.resolve((parcelRequire("inMs5")))
        },
        [(0, $j9rqA.IconType).Error]: {
            default: ()=>Promise.resolve((parcelRequire("gDsF8")))
        },
        // @atlaskit/icon/core/* (badge icons)
        [(0, $j9rqA.IconType).Attachment]: {
            default: ()=>(parcelRequire("4psEG"))
        },
        [(0, $j9rqA.IconType).CheckItem]: {
            default: ()=>(parcelRequire("jBNno"))
        },
        [(0, $j9rqA.IconType).Component]: {
            default: ()=>(parcelRequire("7B3FL"))
        },
        [(0, $j9rqA.IconType).Comment]: {
            default: ()=>Promise.resolve((parcelRequire("3UAb3")))
        },
        [(0, $j9rqA.IconType).View]: {
            default: ()=>Promise.resolve((parcelRequire("bqWPH")))
        },
        [(0, $j9rqA.IconType).React]: {
            default: ()=>(parcelRequire("jVgrR"))
        },
        [(0, $j9rqA.IconType).Vote]: {
            default: ()=>Promise.resolve((parcelRequire("5ctSl")))
        },
        [(0, $j9rqA.IconType).PriorityUndefined]: {
            default: ()=>Promise.resolve((parcelRequire("kaFRI")))
        },
        [(0, $j9rqA.IconType).ProgrammingLanguage]: {
            default: ()=>(parcelRequire("emR73"))
        },
        [(0, $j9rqA.IconType).Subscriber]: {
            default: ()=>(parcelRequire("6dLEG"))
        },
        [(0, $j9rqA.IconType).SubTasksProgress]: {
            default: ()=>(parcelRequire("3gx2e"))
        },
        // @atlaskit/icon-file-type/glyph/* (file type icons with 16/24 size variants)
        [(0, $j9rqA.IconType).Archive]: {
            default: ()=>(parcelRequire("eZKNa")),
            large: ()=>(parcelRequire("anE8N"))
        },
        [(0, $j9rqA.IconType).Executable]: {
            default: ()=>(parcelRequire("asxw6")),
            large: ()=>(parcelRequire("jkTME"))
        },
        [(0, $j9rqA.IconType).GIF]: {
            default: ()=>(parcelRequire("j3rqz")),
            large: ()=>(parcelRequire("kqalc"))
        },
        [(0, $j9rqA.IconType).GoogleDocs]: {
            default: ()=>(parcelRequire("jK91O")),
            large: ()=>(parcelRequire("10Kqk"))
        },
        [(0, $j9rqA.IconType).GoogleForms]: {
            default: ()=>(parcelRequire("8zwRB")),
            large: ()=>(parcelRequire("e9hNC"))
        },
        [(0, $j9rqA.IconType).GoogleSheets]: {
            default: ()=>(parcelRequire("2e19l")),
            large: ()=>(parcelRequire("9llHA"))
        },
        [(0, $j9rqA.IconType).GoogleSlides]: {
            default: ()=>(parcelRequire("grrbo")),
            large: ()=>(parcelRequire("QIdzY"))
        },
        [(0, $j9rqA.IconType).MSExcel]: {
            default: ()=>(parcelRequire("9xR2y")),
            large: ()=>(parcelRequire("cnT5d"))
        },
        [(0, $j9rqA.IconType).MSPowerpoint]: {
            default: ()=>(parcelRequire("kH4hQ")),
            large: ()=>(parcelRequire("5wf67"))
        },
        [(0, $j9rqA.IconType).MSWord]: {
            default: ()=>(parcelRequire("h12jg")),
            large: ()=>(parcelRequire("a7ClH"))
        },
        [(0, $j9rqA.IconType).PDF]: {
            default: ()=>(parcelRequire("1CQqY")),
            large: ()=>(parcelRequire("lGn5T"))
        },
        [(0, $j9rqA.IconType).Sketch]: {
            default: ()=>(parcelRequire("dx0f6")),
            large: ()=>(parcelRequire("k9obD"))
        },
        // Keep blog/live-document out of the lazy map on purpose.
        // These icons should be present in SSR markup so hydration does not cause
        // a visible empty-state-then-pop-in transition in Smart Link consumers.
        [(0, $j9rqA.IconType).Branch]: {
            default: ()=>(parcelRequire("kpbjw")),
            large: ()=>(parcelRequire("9vTiD")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $j9rqA.IconType).Commit]: {
            default: ()=>(parcelRequire("7JIoD")),
            large: ()=>(parcelRequire("dQgEP")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $j9rqA.IconType).PullRequest]: {
            default: ()=>(parcelRequire("4AL3z")),
            large: ()=>(parcelRequire("lECtR")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $j9rqA.IconType).Repo]: {
            default: ()=>(parcelRequire("347NU")),
            large: ()=>(parcelRequire("5dajC")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $j9rqA.IconType).Bug]: {
            default: ()=>(parcelRequire("2CZlh")),
            large: ()=>(parcelRequire("1C6rC")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $j9rqA.IconType).Change]: {
            default: ()=>(parcelRequire("4m2kh")),
            large: ()=>(parcelRequire("1lB5t")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $j9rqA.IconType).Epic]: {
            default: ()=>(parcelRequire("1fvyD")),
            large: ()=>(parcelRequire("hZUgP")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $j9rqA.IconType).Incident]: {
            default: ()=>(parcelRequire("1Z24Q")),
            large: ()=>(parcelRequire("jMIPr")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $j9rqA.IconType).Problem]: {
            default: ()=>(parcelRequire("tJNSt")),
            large: ()=>(parcelRequire("1n4hn")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $j9rqA.IconType).ServiceRequest]: {
            default: ()=>(parcelRequire("3RMEZ")),
            large: ()=>(parcelRequire("e70eO")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $j9rqA.IconType).Story]: {
            default: ()=>(parcelRequire("grId6")),
            large: ()=>(parcelRequire("bs23X")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $j9rqA.IconType).SubTask]: {
            default: ()=>(parcelRequire("5lkbC")),
            large: ()=>(parcelRequire("6jdwC")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $j9rqA.IconType).Task]: {
            default: ()=>(parcelRequire("fnxvD")),
            large: ()=>(parcelRequire("58Mqs")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        // @atlaskit/logo/* (product logos)
        [(0, $j9rqA.IconType).Confluence]: {
            default: ()=>Promise.resolve((parcelRequire("eLXbZ"))).then(({ ConfluenceIcon: ConfluenceIcon })=>({
                        default: ConfluenceIcon
                    }))
        },
        [(0, $j9rqA.IconType).Jira]: {
            default: ()=>Promise.resolve((parcelRequire("6lBxt"))).then(({ JiraIcon: JiraIcon })=>({
                        default: JiraIcon
                    }))
        },
        // Priority icons stay lazy, but share one chunk to avoid a cold-cache request per icon type.
        [(0, $j9rqA.IconType).PriorityBlocker]: {
            default: ()=>$37bce316f4039a56$var$loadPriorityIcons().then(({ PriorityBlockerIcon: defaultIcon })=>({
                        default: defaultIcon
                    }))
        },
        [(0, $j9rqA.IconType).PriorityCritical]: {
            default: ()=>$37bce316f4039a56$var$loadPriorityIcons().then(({ PriorityCriticalIcon: defaultIcon })=>({
                        default: defaultIcon
                    }))
        },
        [(0, $j9rqA.IconType).PriorityHigh]: {
            default: ()=>$37bce316f4039a56$var$loadPriorityIcons().then(({ PriorityHighIcon: defaultIcon })=>({
                        default: defaultIcon
                    }))
        },
        [(0, $j9rqA.IconType).PriorityHighest]: {
            default: ()=>$37bce316f4039a56$var$loadPriorityIcons().then(({ PriorityHighestIcon: defaultIcon })=>({
                        default: defaultIcon
                    }))
        },
        [(0, $j9rqA.IconType).PriorityLow]: {
            default: ()=>$37bce316f4039a56$var$loadPriorityIcons().then(({ PriorityLowIcon: defaultIcon })=>({
                        default: defaultIcon
                    }))
        },
        [(0, $j9rqA.IconType).PriorityLowest]: {
            default: ()=>$37bce316f4039a56$var$loadPriorityIcons().then(({ PriorityLowestIcon: defaultIcon })=>({
                        default: defaultIcon
                    }))
        },
        [(0, $j9rqA.IconType).PriorityMajor]: {
            default: ()=>$37bce316f4039a56$var$loadPriorityIcons().then(({ PriorityMajorIcon: defaultIcon })=>({
                        default: defaultIcon
                    }))
        },
        [(0, $j9rqA.IconType).PriorityMedium]: {
            default: ()=>$37bce316f4039a56$var$loadPriorityIcons().then(({ PriorityMediumIcon: defaultIcon })=>({
                        default: defaultIcon
                    }))
        },
        [(0, $j9rqA.IconType).PriorityMinor]: {
            default: ()=>$37bce316f4039a56$var$loadPriorityIcons().then(({ PriorityMinorIcon: defaultIcon })=>({
                        default: defaultIcon
                    }))
        },
        [(0, $j9rqA.IconType).PriorityTrivial]: {
            default: ()=>$37bce316f4039a56$var$loadPriorityIcons().then(({ PriorityTrivialIcon: defaultIcon })=>({
                        default: defaultIcon
                    }))
        }
    };
};

});
parcelRegister("gIIaP", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("eya3v"),
    $9dnsd("9sTT7"),
    $9dnsd("2PTme"),
    $9dnsd("fgigl"),
    $9dnsd("lduuT"),
    $9dnsd("kGKig"),
    $9dnsd("k31wx"),
    $9dnsd("hIe5e"),
    $9dnsd("1C5eA"),
    $9dnsd("7UhcE"),
    $9dnsd("4JwYp")
]).then(()=>parcelRequire('6Em7C'));

});

parcelRegister("egB9d", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $9a1a4a372ca482d5$export$2e2bcd8739ae039);

var $dS86g = parcelRequire("dS86g");

var $jIzn1 = parcelRequire("jIzn1");
// `blueBold` is used while `platform_lp_non_bold_large_sl_icon` is off.
// Clean up in NAVX-5752: https://hello.jira.atlassian.cloud/browse/NAVX-5752
// When that gate is cleaned up, replace `blueBold` directly with `blue`.
const $9a1a4a372ca482d5$var$PageIconWithColor = (0, $jIzn1.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($dS86g))), 'blueBold');
$9a1a4a372ca482d5$var$PageIconWithColor.displayName = 'PageIconWithColor';
var $9a1a4a372ca482d5$export$2e2bcd8739ae039 = $9a1a4a372ca482d5$var$PageIconWithColor;

});
parcelRegister("jIzn1", function(module, exports) {
$parcel$export(module.exports, "renderIconTile", () => $045263fe3a2719d5$export$87c3646d0e299cfe);

var $fc4bM = parcelRequire("fc4bM");

var $1AiIz = parcelRequire("1AiIz");

var $dRkX9 = parcelRequire("dRkX9");

var $j1cIb = parcelRequire("j1cIb");
/**
 * Maps IconTile appearance to the icon glyph color token to use when rendering
 * a standalone icon (without a tile background).
 * When cleaning up `platform_lp_non_bold_large_sl_icon` in NAVX-5752, remove the `*Bold`
 * entries. Nothing will pass a bold appearance into this map after that.
 */ const $045263fe3a2719d5$var$appearanceToStandaloneIconColor = {
    blue: "var(--ds-icon-accent-blue, #357DE8)",
    blueBold: "var(--ds-icon-accent-blue, #357DE8)",
    gray: "var(--ds-icon-accent-gray, #7D818A)",
    grayBold: "var(--ds-icon-accent-gray, #7D818A)",
    green: "var(--ds-icon-accent-green, #22A06B)",
    greenBold: "var(--ds-icon-accent-green, #22A06B)",
    lime: "var(--ds-icon-accent-lime, #6A9A23)",
    limeBold: "var(--ds-icon-accent-lime, #6A9A23)",
    magenta: "var(--ds-icon-accent-magenta, #CD519D)",
    magentaBold: "var(--ds-icon-accent-magenta, #CD519D)",
    orange: "var(--ds-icon-accent-orange, #E06C00)",
    orangeBold: "var(--ds-icon-accent-orange, #E06C00)",
    purple: "var(--ds-icon-accent-purple, #AF59E1)",
    purpleBold: "var(--ds-icon-accent-purple, #AF59E1)",
    red: "var(--ds-icon-accent-red, #C9372C)",
    redBold: "var(--ds-icon-accent-red, #C9372C)",
    teal: "var(--ds-icon-accent-teal, #2898BD)",
    tealBold: "var(--ds-icon-accent-teal, #2898BD)",
    yellow: "var(--ds-icon-accent-yellow, #B38600)",
    yellowBold: "var(--ds-icon-accent-yellow, #B38600)"
};
/**
 * Bold appearances are the gate-off values. Remove this map when cleaning up
 * `platform_lp_non_bold_large_sl_icon` in NAVX-5752:
 * https://hello.jira.atlassian.cloud/browse/NAVX-5752
 */ const $045263fe3a2719d5$var$boldToNonBoldAppearance = {
    blueBold: 'blue',
    grayBold: 'gray',
    greenBold: 'green',
    limeBold: 'lime',
    magentaBold: 'magenta',
    orangeBold: 'orange',
    purpleBold: 'purple',
    redBold: 'red',
    tealBold: 'teal',
    yellowBold: 'yellow'
};
const $045263fe3a2719d5$export$87c3646d0e299cfe = (Icon, appearance)=>{
    return ({ size: size, isTiledIcon: isTiledIcon, ...props })=>{
        const tileSize = (0, $j1cIb.transformSmartLinkSizeToIconTileSize)(size);
        if (tileSize === undefined) {
            // size="16" has been removed — render the icon directly without a tile,
            // using the appearance-derived color so it still matches the intended style.
            const label = props.label ?? '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("span", {
                role: label ? 'img' : undefined,
                "aria-label": label || undefined,
                "data-testid": props.testId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Icon, {
                color: $045263fe3a2719d5$var$appearanceToStandaloneIconColor[appearance],
                label: ""
            }));
        }
        const { ...tileProps } = props;
        const nonBoldAppearance = $045263fe3a2719d5$var$boldToNonBoldAppearance[appearance];
        const tileAppearance = nonBoldAppearance !== undefined && (0, $dRkX9.fg)('platform_lp_non_bold_large_sl_icon') ? nonBoldAppearance : appearance;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1AiIz.default), {
            appearance: tileAppearance,
            icon: isTiledIcon ? (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Icon, {
                    ...iconProps,
                    spacing: "spacious"
                }) : Icon,
            size: tileSize,
            ...tileProps
        });
    };
};

});


parcelRegister("f0gNQ", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("bneKx").then(()=>parcelRequire('9LoPy'));

});

parcelRegister("d7MTx", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("huUVD"),
    $9dnsd("hqnfu")
]).then(()=>parcelRequire('lQqao'));

});

parcelRegister("9ggnx", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("ctRMG").then(()=>parcelRequire('bNyFZ'));

});

parcelRegister("h1Gad", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("L5d0f").then(()=>parcelRequire('fPF64'));

});

parcelRegister("dZPOI", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("eNU1I").then(()=>parcelRequire('6ZklR'));

});

parcelRegister("aU1fr", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("6VfN9").then(()=>parcelRequire('jR4gQ'));

});

parcelRegister("lgvZN", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("5umLE").then(()=>parcelRequire('3uDvS'));

});

parcelRegister("jmXx5", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("72zJM").then(()=>parcelRequire('96nlR'));

});

parcelRegister("6dLEG", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("4SQTv").then(()=>parcelRequire('lUyjF'));

});

parcelRegister("kXyGS", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("8QEJW").then(()=>parcelRequire('3dgbz'));

});

parcelRegister("ij8gp", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("h05a5").then(()=>parcelRequire('jTWWA'));

});

parcelRegister("4psEG", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("03vi8").then(()=>parcelRequire('ftQsl'));

});

parcelRegister("jBNno", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("b11yl").then(()=>parcelRequire('7y0BG'));

});

parcelRegister("7B3FL", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("60G7N").then(()=>parcelRequire('4aMnD'));

});

parcelRegister("jVgrR", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("5Qtzw").then(()=>parcelRequire('6Mz5R'));

});

parcelRegister("emR73", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("huUVD").then(()=>parcelRequire('9Bg7Y'));

});

parcelRegister("3gx2e", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("ftCwL").then(()=>parcelRequire('4Mzcw'));

});

parcelRegister("eZKNa", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("fBPcn").then(()=>parcelRequire('gaVO5'));

});

parcelRegister("anE8N", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("98elN").then(()=>parcelRequire('kdFVE'));

});

parcelRegister("asxw6", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("i7YTY").then(()=>parcelRequire('aOOV6'));

});

parcelRegister("jkTME", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("dTYFa").then(()=>parcelRequire('kPXLv'));

});

parcelRegister("j3rqz", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("immaA").then(()=>parcelRequire('9aL41'));

});

parcelRegister("kqalc", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("8LMxR").then(()=>parcelRequire('5AOXz'));

});

parcelRegister("jK91O", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("5Tufi").then(()=>parcelRequire('hKJmY'));

});

parcelRegister("10Kqk", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("bRIcI").then(()=>parcelRequire('63iEv'));

});

parcelRegister("8zwRB", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("acETV").then(()=>parcelRequire('4xPeH'));

});

parcelRegister("e9hNC", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("5s3ed").then(()=>parcelRequire('iss4D'));

});

parcelRegister("2e19l", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("kNKw1").then(()=>parcelRequire('9oMqL'));

});

parcelRegister("9llHA", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("WFTrL").then(()=>parcelRequire('alw4H'));

});

parcelRegister("grrbo", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("8CQs9").then(()=>parcelRequire('NET6K'));

});

parcelRegister("QIdzY", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("6C386").then(()=>parcelRequire('7279U'));

});

parcelRegister("9xR2y", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("6uL7F").then(()=>parcelRequire('gDwzp'));

});

parcelRegister("cnT5d", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("5TT1O").then(()=>parcelRequire('2ANul'));

});

parcelRegister("kH4hQ", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("7HfdY").then(()=>parcelRequire('3lrDt'));

});

parcelRegister("5wf67", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("cADPK").then(()=>parcelRequire('d6MEY'));

});

parcelRegister("h12jg", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("4MoPs").then(()=>parcelRequire('k0fs7'));

});

parcelRegister("a7ClH", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("32rp9").then(()=>parcelRequire('63vmH'));

});

parcelRegister("1CQqY", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("5iocz").then(()=>parcelRequire('fzId7'));

});

parcelRegister("lGn5T", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("eamXe").then(()=>parcelRequire('e1aWt'));

});

parcelRegister("dx0f6", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("cxuOf").then(()=>parcelRequire('8R4C9'));

});

parcelRegister("k9obD", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("6YxJZ").then(()=>parcelRequire('6NDks'));

});

parcelRegister("kpbjw", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("iDMqi").then(()=>parcelRequire('62nNx'));

});

parcelRegister("9vTiD", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("17rqg"),
    $9dnsd("fghbe")
]).then(()=>parcelRequire('c8NB3'));

});

parcelRegister("7JIoD", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("ekETX").then(()=>parcelRequire('4gFtZ'));

});

parcelRegister("dQgEP", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("cQtP2"),
    $9dnsd("62xMl")
]).then(()=>parcelRequire('7Nu4T'));

});

parcelRegister("4AL3z", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("6jy1b").then(()=>parcelRequire('9tj5j'));

});

parcelRegister("lECtR", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("82a9R"),
    $9dnsd("jymLf")
]).then(()=>parcelRequire('gVqoz'));

});

parcelRegister("347NU", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("iH74T").then(()=>parcelRequire('7uqom'));

});

parcelRegister("5dajC", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("huUVD"),
    $9dnsd("eURO5")
]).then(()=>parcelRequire('lhGdw'));

});

parcelRegister("2CZlh", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("lAoL0").then(()=>parcelRequire('39BPV'));

});

parcelRegister("1C6rC", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("6ljna"),
    $9dnsd("4FEoh")
]).then(()=>parcelRequire('2ktyZ'));

});

parcelRegister("4m2kh", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("cvO2I").then(()=>parcelRequire('lqopQ'));

});

parcelRegister("1lB5t", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("sRQkh"),
    $9dnsd("ejeIf")
]).then(()=>parcelRequire('7D95c'));

});

parcelRegister("1fvyD", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("9RLh6").then(()=>parcelRequire('d5YHt'));

});

parcelRegister("hZUgP", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("dWlHb"),
    $9dnsd("fISv0")
]).then(()=>parcelRequire('dEBIZ'));

});

parcelRegister("1Z24Q", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("hrLwj").then(()=>parcelRequire('hKYwr'));

});

parcelRegister("jMIPr", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("gQxC0"),
    $9dnsd("95RgV")
]).then(()=>parcelRequire('5zL1c'));

});

parcelRegister("tJNSt", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("hlj0q").then(()=>parcelRequire('1bcrw'));

});

parcelRegister("1n4hn", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("bXiBz"),
    $9dnsd("010lK")
]).then(()=>parcelRequire('c1XIP'));

});

parcelRegister("3RMEZ", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("77JWw").then(()=>parcelRequire('62KtX'));

});

parcelRegister("e70eO", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("e55hi").then(()=>parcelRequire('9GoR1'));

});

parcelRegister("grId6", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("1zkIL").then(()=>parcelRequire('8uzl9'));

});

parcelRegister("bs23X", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("1mvfK"),
    $9dnsd("52CIP")
]).then(()=>parcelRequire('j4irD'));

});

parcelRegister("5lkbC", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("gGeD6").then(()=>parcelRequire('fvAOB'));

});

parcelRegister("6jdwC", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("ftCwL"),
    $9dnsd("6TS2A")
]).then(()=>parcelRequire('iHxkO'));

});

parcelRegister("fnxvD", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("hzmzP").then(()=>parcelRequire('3YSuE'));

});

parcelRegister("58Mqs", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("b11yl"),
    $9dnsd("9JtLo")
]).then(()=>parcelRequire('bXjwr'));

});


parcelRegister("1wanW", function(module, exports) {
$parcel$export(module.exports, "isIconSizeLarge", () => $bc2f007b3cb1f1ab$export$d2b8fb9e780e17e7);

var $j9rqA = parcelRequire("j9rqA");
const $bc2f007b3cb1f1ab$export$d2b8fb9e780e17e7 = (size)=>size && [
        (0, $j9rqA.SmartLinkSize).Large,
        (0, $j9rqA.SmartLinkSize).XLarge
    ].includes(size);

});

parcelRegister("c5OI8", function(module, exports) {
$parcel$export(module.exports, "default", () => $eee131581de4da14$export$2e2bcd8739ae039);

var $i8H3c = parcelRequire("i8H3c");

var $dWK4M = parcelRequire("dWK4M");

var $jp2wt = parcelRequire("jp2wt");
const $eee131581de4da14$var$BlogIconWithColor = (0, $jp2wt.renderIconPerSize)((0, $i8H3c.default), (0, $dWK4M.default));
$eee131581de4da14$var$BlogIconWithColor.displayName = 'BlogIconWithColor';
var $eee131581de4da14$export$2e2bcd8739ae039 = $eee131581de4da14$var$BlogIconWithColor;

});
parcelRegister("jp2wt", function(module, exports) {
$parcel$export(module.exports, "renderIconPerSize", () => $39cfd2ccc89b74ed$export$28dd5ad82647c000);

var $fc4bM = parcelRequire("fc4bM");

var $1wanW = parcelRequire("1wanW");
const $39cfd2ccc89b74ed$export$28dd5ad82647c000 = (ObjectIcon, ObjectTileIcon)=>{
    return ({ size: size, ...props })=>{
        if ((0, $1wanW.isIconSizeLarge)(size)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(ObjectTileIcon, {
            ...props,
            size: "small"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(ObjectIcon, props);
    };
};

});


parcelRegister("5q3t2", function(module, exports) {
$parcel$export(module.exports, "default", () => $2144ecef9e0e7b8d$export$2e2bcd8739ae039);

var $cLmGU = parcelRequire("cLmGU");

var $hQly2 = parcelRequire("hQly2");

var $jp2wt = parcelRequire("jp2wt");
const $2144ecef9e0e7b8d$var$LiveDocumentIconWithColor = (0, $jp2wt.renderIconPerSize)((0, $cLmGU.default), (0, $hQly2.default));
$2144ecef9e0e7b8d$var$LiveDocumentIconWithColor.displayName = 'LiveDocumentIconWithColor';
var $2144ecef9e0e7b8d$export$2e2bcd8739ae039 = $2144ecef9e0e7b8d$var$LiveDocumentIconWithColor;

});


parcelRegister("89a4S", function(module, exports) {
$parcel$export(module.exports, "getIconWidth", () => $9b35719c9468078a$export$fb10bc5609c6347e);

var $j9rqA = parcelRequire("j9rqA");
const $9b35719c9468078a$export$fb10bc5609c6347e = (size)=>{
    switch(size){
        case (0, $j9rqA.SmartLinkSize).XLarge:
        case (0, $j9rqA.SmartLinkSize).Large:
            return "var(--ds-space-300, 24px)";
        case (0, $j9rqA.SmartLinkSize).Medium:
        case (0, $j9rqA.SmartLinkSize).Small:
        default:
            return "var(--ds-space-200, 16px)";
    }
};

});


parcelRegister("iK3aR", function(module, exports) {
$parcel$export(module.exports, "toLinkIconProps", () => $15b35ac211d62bf2$export$6d33abd591a3f700);
/* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4paoX = parcelRequire("4paoX");
const $15b35ac211d62bf2$export$6d33abd591a3f700 = (data, type)=>{
    const isDataLinkIcon = (_data)=>{
        return typeof _data === 'object' && _data !== null && ('icon' in _data || 'url' in _data);
    };
    if (!isDataLinkIcon(data)) return typeof data === 'object' ? data : undefined;
    const isImageRound = (0, $4paoX.isProfileType)(type);
    return {
        ...data,
        appearance: isImageRound ? 'round' : 'square'
    };
};

});
parcelRegister("4paoX", function(module, exports) {
$parcel$export(module.exports, "isProfileType", () => $8bd348fca59abb77$export$6a4545d6b336c401);
const $8bd348fca59abb77$export$6a4545d6b336c401 = (type)=>!!(type && type.includes('Profile'));

});


parcelRegister("2Dio3", function(module, exports) {
$parcel$export(module.exports, "resourceTypeToLabel", () => $e470e94cd92ad63d$export$3422b5d26145468d);
const $e470e94cd92ad63d$var$excludedResourceTypes = [
    '0',
    'unknown',
    'unsupported',
    'REDACTED'
];
const $e470e94cd92ad63d$var$manualMapping = {
    jswBoard: 'Jira Software Board',
    calendarJsw: 'Jira Software Calendar',
    kbArticle: 'Knowledge Base Article',
    pull: 'Pull Request',
    repo: 'Repository'
};
/**
 * Splits a resolver `resourceType` token into human-oriented words.
 * Prefers kebab-case (`-`) when present; otherwise splits camelCase / PascalCase.
 */ function $e470e94cd92ad63d$var$splitIntoWords(resourceType) {
    if (resourceType.includes('-')) return resourceType.split('-').map((w)=>w.trim()).filter(Boolean);
    const spaced = resourceType.replace(/([a-z\d])([A-Z])/g, '$1 $2').replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2');
    return spaced.split(/\s+/).filter(Boolean);
}
function $e470e94cd92ad63d$var$titleCaseWord(word) {
    if (!word) return word;
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}
function $e470e94cd92ad63d$export$3422b5d26145468d(resourceType) {
    const trimmed = resourceType === null || resourceType === void 0 ? void 0 : resourceType.trim();
    if (!trimmed) return undefined;
    if ($e470e94cd92ad63d$var$excludedResourceTypes.includes(trimmed)) return undefined;
    const manual = $e470e94cd92ad63d$var$manualMapping[trimmed];
    if (manual !== undefined) return manual;
    const words = $e470e94cd92ad63d$var$splitIntoWords(trimmed);
    if (words.length === 0) return undefined;
    return words.map($e470e94cd92ad63d$var$titleCaseWord).join(' ');
} // Following are unique resourceType values for the past week (at the the time of writing) for reference:
 // page
 // issue
 // 0
 // (none)
 // unknown
 // file
 // space
 // message
 // jswBoard
 // video
 // card
 // project
 // board
 // repository
 // whiteboard
 // channel
 // pull-request
 // mergeRequest
 // database
 // pullRequest
 // singlePortalPage
 // folder
 // dashboard
 // requestCreateForm
 // commit
 // jql
 // blog
 // version
 // backlog
 // undefinedLink
 // branch
 // report
 // planTimeline
 // sharepointFile
 // comment
 // roadmap
 // idea
 // case
 // opportunity
 // account
 // list
 // issues
 // view
 // workItem
 // link
 // block
 // kbArticle
 // form
 // summary
 // task
 // search
 // visitor
 // public-link
 // user
 // playlist
 // prototype
 // deal
 // screen
 // pipeline
 // contact
 // incident
 // sheet
 // featureFlag
 // release
 // switcheroo-flag
 // single-calendar
 // repo
 // formBuilder
 // proformaForm
 // object
 // tiny
 // document
 // sharedFile
 // campaign
 // table
 // compassComponent
 // timeline
 // boardInvite
 // action
 // embed
 // objectType
 // calendar
 // calendarJsw
 // publishedView
 // template
 // gist
 // recording
 // plan
 // planDependencies
 // epic
 // oneDriveFile
 // chart
 // capability
 // artboard
 // planCalendar
 // planSummary
 // projectTeamTag
 // planProgram
 // compassComponentSearchQuery
 // feature
 // workspace
 // company
 // insight
 // customer
 // Page
 // schema
 // dependency
 // note
 // article
 // snippet
 // tag
 // goal
 // security
 // collaborationGroup
 // envelope
 // code
 // boardView
 // compassScorecard
 // invoice
 // theme
 // customWorkspaceView
 // risk
 // reel
 // deployments
 // objective
 // ask
 // compassMetricDefinition
 // compassComponentAnnouncement
 // portals
 // asks
 // breadcrumbChart
 // Chart
 // slide
 // unsupported
 // remote-link
 // pull
 // REDACTED
 // compassComponentScorecard
 // forms
 // sante
 // zoom

});


parcelRegister("gndj3", function(module, exports) {
$parcel$export(module.exports, "default", () => $09e202f017c84c56$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $71vjd = parcelRequire("71vjd");
var $09e202f017c84c56$export$2e2bcd8739ae039 = (0, $71vjd.Block);

});
parcelRegister("71vjd", function(module, exports) {
$parcel$export(module.exports, "Block", () => $8bce0ffaa8be5bf2$export$d96a8827a60d6b69);
/* Block.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $j9rqA = parcelRequire("j9rqA");

var $iZ66J = parcelRequire("iZ66J");
const $8bce0ffaa8be5bf2$var$baseBlockStyles = null;
const $8bce0ffaa8be5bf2$var$highlightRemoveStyles = null;
const $8bce0ffaa8be5bf2$var$gapStyles = {
    xlarge: "_zulpv47k _1ljqv47k",
    large: "_zulppxbi _1ljqpxbi",
    medium: "_zulpu2gc _1ljqu2gc",
    small: "_zulp1b66 _1ljq1b66"
};
const $8bce0ffaa8be5bf2$var$directionStyles = {
    vertical: "_2lx21bp4 _4cvr1y6m",
    horizontal: "_2lx2vrvc _4cvr1h6o"
};
const $8bce0ffaa8be5bf2$export$d96a8827a60d6b69 = ({ children: children, direction: direction = (0, $j9rqA.SmartLinkDirection).Horizontal, size: size = (0, $j9rqA.SmartLinkSize).Medium, testId: testId = 'smart-block', className: className, blockRef: blockRef, onRender: onRender, onTransitionEnd: onTransitionEnd, style: style, placeholderId: placeholderId })=>{
    (0, $fc4bM.useEffect)(()=>{
        onRender && onRender();
    }, [
        onRender
    ]);
    return /*#__PURE__*/ $fc4bM.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $2R2iS.default)([
            "_1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _1bah1y6m _fiawglyw _1uzp1mp2 _a6bx1l7x _e4i5bjq5 _1gu2dgkc _5b7tuxlv _17aedgkc",
            "_12ji1snc _1qu2agmp _12y310yn _12ji1kw7 _syaz1kw7 _18ql1j28 _1ifmglyw _181uglyw _1rkwglyw _te17glyw _uiztglyw",
            $8bce0ffaa8be5bf2$var$directionStyles[direction],
            $8bce0ffaa8be5bf2$var$gapStyles[size],
            className
        ]),
        "data-smart-block": true,
        "data-testid": testId,
        onTransitionEnd: onTransitionEnd,
        ref: blockRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        "data-ssr-placeholder": placeholderId,
        "data-ssr-placeholder-replace": placeholderId
    }, (0, $iZ66J.renderChildren)(children, size));
};

});
parcelRegister("iZ66J", function(module, exports) {
$parcel$export(module.exports, "renderChildren", () => $71ea2d6d2a9f51be$export$cd762ccf1a583d69);

var $fc4bM = parcelRequire("fc4bM");

var $8eLNg = parcelRequire("8eLNg");

var $kJrsj = parcelRequire("kJrsj");

var $2UGy7 = parcelRequire("2UGy7");
const $71ea2d6d2a9f51be$var$isActionGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).isValidElement(node) && node.type === (0, $kJrsj.default);
const $71ea2d6d2a9f51be$var$isElementOrElementGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).isValidElement(node) && ((0, $8eLNg.isFlexibleUiElement)(node) || node.type === (0, $2UGy7.default));
const $71ea2d6d2a9f51be$export$cd762ccf1a583d69 = (children, size)=>(0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.map(children, (child)=>{
        if ($71ea2d6d2a9f51be$var$isElementOrElementGroup(child) || $71ea2d6d2a9f51be$var$isActionGroup(child)) {
            const node = child;
            const { size: childSize } = node.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).cloneElement(node, {
                size: childSize || size
            });
        }
        return child;
    });

});
parcelRegister("8eLNg", function(module, exports) {
$parcel$export(module.exports, "isFlexibleUiElement", () => $9cfefd60a796e915$export$d7fc505bb0bd5756);

var $fc4bM = parcelRequire("fc4bM");

var $fwuFz = parcelRequire("fwuFz");

var $kMGig = parcelRequire("kMGig");

var $8uHER = parcelRequire("8uHER");

var $bNuWk = parcelRequire("bNuWk");

var $fXNUY = parcelRequire("fXNUY");

var $eTjJU = parcelRequire("eTjJU");

var $9vnjG = parcelRequire("9vnjG");

var $gg4EO = parcelRequire("gg4EO");

var $2X94o = parcelRequire("2X94o");

var $3ojH0 = parcelRequire("3ojH0");

var $7QV7I = parcelRequire("7QV7I");

var $lqR91 = parcelRequire("lqR91");

var $jC3PC = parcelRequire("jC3PC");

var $4tJOd = parcelRequire("4tJOd");

var $2V9rV = parcelRequire("2V9rV");

var $b2nt7 = parcelRequire("b2nt7");

var $fXXMA = parcelRequire("fXXMA");

var $4BVlT = parcelRequire("4BVlT");

var $7E1Fn = parcelRequire("7E1Fn");

var $7L0w2 = parcelRequire("7L0w2");

var $cGe8i = parcelRequire("cGe8i");

var $g0ZNc = parcelRequire("g0ZNc");

var $38Op4 = parcelRequire("38Op4");

var $ani8Z = parcelRequire("ani8Z");

var $3ZCHY = parcelRequire("3ZCHY");

var $77Ihl = parcelRequire("77Ihl");

var $e1ITO = parcelRequire("e1ITO");

var $gCCsi = parcelRequire("gCCsi");

var $7Sp0k = parcelRequire("7Sp0k");

var $iJOnv = parcelRequire("iJOnv");

var $4e8Q0 = parcelRequire("4e8Q0");

var $kzF82 = parcelRequire("kzF82");

var $3tJnw = parcelRequire("3tJnw");

var $klqR7 = parcelRequire("klqR7");

var $1fHg5 = parcelRequire("1fHg5");

var $j1vQV = parcelRequire("j1vQV");

var $9ZFL1 = parcelRequire("9ZFL1");

var $cAR3R = parcelRequire("cAR3R");

var $8AeTQ = parcelRequire("8AeTQ");
const $9cfefd60a796e915$var$Elements = {
    AppliedToComponentsCount: $fwuFz.default,
    AssignedTo: $kMGig.default,
    AssignedToGroup: $8uHER.default,
    AttachmentCount: $bNuWk.default,
    AuthorGroup: $fXNUY.default,
    ChecklistProgress: $eTjJU.default,
    CollaboratorGroup: $9vnjG.default,
    CommentCount: $gg4EO.default,
    CreatedBy: $2X94o.default,
    CreatedOn: $3ojH0.default,
    DueOn: $7QV7I.default,
    HostName: $lqR91.default,
    LatestCommit: $jC3PC.default,
    LinkIcon: $4tJOd.default,
    Location: $2V9rV.default,
    ModifiedBy: $b2nt7.default,
    ModifiedOn: $fXXMA.default,
    OwnedBy: $4BVlT.default,
    OwnedByGroup: $7E1Fn.default,
    Preview: $7L0w2.default,
    Priority: $cGe8i.default,
    ProgrammingLanguage: $g0ZNc.default,
    Provider: $38Op4.default,
    ReactCount: $ani8Z.default,
    ReadTime: $3ZCHY.default,
    SentOn: $77Ihl.default,
    Snippet: $e1ITO.default,
    SourceBranch: $gCCsi.default,
    State: $7Sp0k.default,
    StoryPoints: $iJOnv.default,
    SubTasksProgress: $4e8Q0.default,
    SubscriberCount: $kzF82.default,
    TargetBranch: $3tJnw.default,
    TeamMemberCount: $klqR7.default,
    Title: $1fHg5.default,
    UserAttributes: $j1vQV.default,
    ViewCount: $9ZFL1.default,
    VoteCount: $cAR3R.default
};
const $9cfefd60a796e915$export$d7fc505bb0bd5756 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).isValidElement(node)) return false;
    if (Object.values($9cfefd60a796e915$var$Elements).some((type)=>type === node.type)) return true;
    if ((0, $8AeTQ.isStyleCacheProvider)(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.map(node.props.children, (child)=>{
            var _child$type;
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && ((_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.name) !== 'Style') isChildrenValid = $9cfefd60a796e915$export$d7fc505bb0bd5756(child);
        });
        return isChildrenValid;
    }
    return false;
};

});
parcelRegister("fwuFz", function(module, exports) {
$parcel$export(module.exports, "default", () => $9cfeba2acb1ccf96$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $j9rqA = parcelRequire("j9rqA");

var $ewFKq = parcelRequire("ewFKq");

var $dweer = parcelRequire("dweer");

var $dE7FH = parcelRequire("dE7FH");
const $9cfeba2acb1ccf96$var$AppliedToComponentsCountElement = (props)=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const context = (0, $dweer.useFlexibleUiContext)();
    if (// Check for null and undefined, render if it's 0.
    (context === null || context === void 0 ? void 0 : context.appliedToComponentsCount) === null || (context === null || context === void 0 ? void 0 : context.appliedToComponentsCount) === undefined) return null;
    const label = formatMessage((0, $ewFKq.messages).compass_applied_components_count, {
        numberOfComponents: context.appliedToComponentsCount
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dE7FH.default), {
        icon: (0, $j9rqA.IconType).Component,
        label: label,
        ...props
    });
};
var $9cfeba2acb1ccf96$export$2e2bcd8739ae039 = $9cfeba2acb1ccf96$var$AppliedToComponentsCountElement;

});
parcelRegister("dE7FH", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab4fee9155f0c764$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $dBtOK = parcelRequire("dBtOK");

var $j9rqA = parcelRequire("j9rqA");

var $ewFKq = parcelRequire("ewFKq");

var $5QRjl = parcelRequire("5QRjl");

var $gysdQ = parcelRequire("gysdQ");

var $4mDZ7 = parcelRequire("4mDZ7");

var $47s0i = parcelRequire("47s0i");

var $knLZA = parcelRequire("knLZA");

var $5oUA7 = parcelRequire("5oUA7");
const $ab4fee9155f0c764$var$styles = {
    container: "_zulp1b66 _1e0c116y _4cvr1h6o _1ul91ns9",
    icon: "_1e0c116y _v4pn116y _1b94116y _1ii7116y _4t3i7vkz _bna77vkz _1xjx7vkz _17527vkz _ca0qze3t _14bqze3t _1oh2ze3t _i2i3ze3t _u5f3ze3t _3tceze3t _99ztze3t _uhasze3t _n3tdze3t _1ym6ze3t _1m2uze3t _5jw9ze3t _19bvze3t _1xr1ze3t _9n9oze3t _7wy9ze3t _1bsb7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _s7n4nkob _rtqbnkob _e4kmnkob _z239nkob",
    text: "_11c8wadc"
};
const $ab4fee9155f0c764$var$colorMap = {
    subtle: "_syaz1rpy",
    default: "_syazazsu"
};
const $ab4fee9155f0c764$var$messageMapper = {
    [(0, $j9rqA.IconType).PriorityBlocker]: (0, $ewFKq.messages).priority_blocker,
    [(0, $j9rqA.IconType).PriorityCritical]: (0, $ewFKq.messages).priority_critical,
    [(0, $j9rqA.IconType).PriorityHigh]: (0, $ewFKq.messages).priority_high,
    [(0, $j9rqA.IconType).PriorityHighest]: (0, $ewFKq.messages).priority_highest,
    [(0, $j9rqA.IconType).PriorityLow]: (0, $ewFKq.messages).priority_low,
    [(0, $j9rqA.IconType).PriorityLowest]: (0, $ewFKq.messages).priority_lowest,
    [(0, $j9rqA.IconType).PriorityMajor]: (0, $ewFKq.messages).priority_major,
    [(0, $j9rqA.IconType).PriorityMedium]: (0, $ewFKq.messages).priority_medium,
    [(0, $j9rqA.IconType).PriorityMinor]: (0, $ewFKq.messages).priority_minor,
    [(0, $j9rqA.IconType).PriorityTrivial]: (0, $ewFKq.messages).priority_trivial,
    [(0, $j9rqA.IconType).PriorityUndefined]: (0, $ewFKq.messages).priority_undefined
};
const $ab4fee9155f0c764$var$getFormattedMessageFromIcon = (icon)=>{
    if (icon) {
        const descriptor = $ab4fee9155f0c764$var$messageMapper[icon];
        if (descriptor) return (0, $5oUA7.getFormattedMessage)({
            descriptor: descriptor
        });
    }
};
const $ab4fee9155f0c764$var$renderAtlaskitIcon = (icon, testId)=>{
    if (icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $47s0i.default), {
        icon: icon,
        label: icon,
        testId: `${testId}-icon`
    });
};
const $ab4fee9155f0c764$var$renderImageIcon = (url, testId, hideLoadingSkeleton)=>{
    if (url) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4mDZ7.default), {
        testId: testId,
        url: url,
        hideLoadingSkeleton: hideLoadingSkeleton
    });
};
/**
 * A base element that displays some text with an associated icon.
 * @internal
 * @param {BaseBadgeElementProps} BaseBadgeElementProps - The props necessary for the Badge.
 * @see CommentCount
 * @see ViewCount
 * @see ReactCount
 * @see VoteCount
 * @see SubscriberCount
 * @see Priority
 * @see ProgrammingLanguage
 * @see Provider
 */ const $ab4fee9155f0c764$var$BaseBadgeRefreshNew = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ appearance: appearance = 'default', hideIcon: hideIcon = false, icon: icon, label: label, name: name, testId: testId = 'smart-element-badge', url: url, color: color, hideLabel: hideLabel = false }, ref)=>{
    const ui = (0, $5QRjl.useFlexibleUiOptionContext)();
    const { product: product } = (0, $gysdQ.default)();
    const formattedMessageOrLabel = $ab4fee9155f0c764$var$getFormattedMessageFromIcon(icon) || label;
    const badgeIcon = $ab4fee9155f0c764$var$renderAtlaskitIcon(icon, testId) || $ab4fee9155f0c764$var$renderImageIcon(url, testId, ui === null || ui === void 0 ? void 0 : ui.hideLoadingSkeleton);
    if (!formattedMessageOrLabel || !badgeIcon) return null;
    const shouldHideLabel = hideLabel && !!product && product === 'CONFLUENCE';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("span", {
        "data-smart-element": name,
        "data-smart-element-badge": true,
        "data-testid": testId,
        ref: ref,
        style: {
            color: color
        },
        className: (0, $2R2iS.default)([
            $ab4fee9155f0c764$var$styles.container,
            $ab4fee9155f0c764$var$colorMap[appearance]
        ])
    }, !hideIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        as: "span",
        xcss: $ab4fee9155f0c764$var$styles.icon
    }, badgeIcon), !shouldHideLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        as: "span",
        testId: `${testId}-label`,
        xcss: $ab4fee9155f0c764$var$styles.text
    }, formattedMessageOrLabel));
});
const $ab4fee9155f0c764$var$_default_1 = (0, $knLZA.withOverrideCss)($ab4fee9155f0c764$var$BaseBadgeRefreshNew);
var $ab4fee9155f0c764$export$2e2bcd8739ae039 = $ab4fee9155f0c764$var$_default_1;

});
parcelRegister("5oUA7", function(module, exports) {
$parcel$export(module.exports, "getFormattedMessage", () => $04da4d26d134ca10$export$f1aa79f2218fb713);

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");
const $04da4d26d134ca10$export$f1aa79f2218fb713 = (message)=>{
    if (message) {
        const { descriptor: descriptor, values: values } = message;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), {
            ...descriptor,
            values: values
        });
    }
};

});



parcelRegister("kMGig", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0010f0aa73d6a1f$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $ewFKq = parcelRequire("ewFKq");

var $dweer = parcelRequire("dweer");

var $jBxpI = parcelRequire("jBxpI");
var $i520X = parcelRequire("i520X");
const $e0010f0aa73d6a1f$var$AssignedToElement = (props)=>{
    const context = (0, $dweer.useFlexibleUiContext)();
    const data = context ? (0, $i520X.toFormattedTextProps)((0, $ewFKq.messages).assigned_to, context.assignedTo) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jBxpI.default), {
        ...data,
        ...props,
        name: (0, $j9rqA.ElementName).AssignedTo
    }) : null;
};
var $e0010f0aa73d6a1f$export$2e2bcd8739ae039 = $e0010f0aa73d6a1f$var$AssignedToElement;

});
parcelRegister("jBxpI", function(module, exports) {
$parcel$export(module.exports, "default", () => $a9c6cc981ccba61f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1p4GZ = parcelRequire("1p4GZ");
var $a9c6cc981ccba61f$export$2e2bcd8739ae039 = (0, $1p4GZ.BaseTextElement);

});
parcelRegister("1p4GZ", function(module, exports) {
$parcel$export(module.exports, "BaseTextElement", () => $201f407aeb1cb49e$export$79422073c7118b5b);
/* BaseTextElement.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
var $8xbhL = parcelRequire("8xbhL");

var $5oUA7 = parcelRequire("5oUA7");
const $201f407aeb1cb49e$var$baseStyle = null;
const $201f407aeb1cb49e$var$fontOverrideStyleMap = {
    'font.body': "_11c8fhey",
    'font.body.large': "_11c81d4k",
    'font.body.small': "_11c8wadc"
};
const $201f407aeb1cb49e$export$79422073c7118b5b = ({ content: content, maxLines: maxLines = 1, message: message, name: name, className: className, testId: testId = 'smart-element-text', hideFormat: hideFormat = false, color: color, fontSize: fontSize })=>{
    if (!message && !content) return null;
    const dynamicCss = null;
    const formattedContent = hideFormat && content ? content : (0, $5oUA7.getFormattedMessage)(message) || content;
    return /*#__PURE__*/ $fc4bM.createElement("span", {
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-text": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $2R2iS.default)([
            "_11c8wadc _1reo15vq _18m915vq _syazazsu _o5724jg8 _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _sudp1e54",
            fontSize !== undefined && $201f407aeb1cb49e$var$fontOverrideStyleMap[fontSize],
            "_1yyjr31u _102k1dud",
            className
        ]),
        style: {
            color: color,
            "--_1erfju8": (0, $8xbhL.default)(maxLines)
        }
    }, formattedContent);
};

});


parcelRegister("i520X", function(module, exports) {
$parcel$export(module.exports, "toFormattedTextProps", () => $dc4e10f7dbd9f9fe$export$b9738bf28fb14829);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $dc4e10f7dbd9f9fe$export$b9738bf28fb14829 = (descriptor, context)=>{
    return context ? {
        message: {
            descriptor: descriptor,
            values: {
                context: context
            }
        },
        content: context
    } : undefined;
};

});


parcelRegister("8uHER", function(module, exports) {
$parcel$export(module.exports, "default", () => $9d5e6d51c2d88702$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $dweer = parcelRequire("dweer");

var $9ksQI = parcelRequire("9ksQI");
var $2nEjX = parcelRequire("2nEjX");
const $9d5e6d51c2d88702$var$AssignedToGroupElement = (props)=>{
    const context = (0, $dweer.useFlexibleUiContext)();
    const data = context ? (0, $2nEjX.toAvatarGroupProps)(context.assignedToGroup, true) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9ksQI.default), {
        ...data,
        ...props,
        name: (0, $j9rqA.ElementName).AssignedToGroup
    }) : null;
};
var $9d5e6d51c2d88702$export$2e2bcd8739ae039 = $9d5e6d51c2d88702$var$AssignedToGroupElement;

});
parcelRegister("9ksQI", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5f7d0ca2a03ef3e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $gpjDl = parcelRequire("gpjDl");

var $aEADZ = parcelRequire("aEADZ");

var $j9rqA = parcelRequire("j9rqA");

var $ewFKq = parcelRequire("ewFKq");

var $cAG6t = parcelRequire("cAG6t");
const $a5f7d0ca2a03ef3e$var$styles = null;
const $a5f7d0ca2a03ef3e$var$getPersonNameWithPrefix = (elementName, personName, intl)=>{
    switch(elementName){
        case (0, $j9rqA.ElementName).AssignedToGroup:
            return (0, $cAG6t.getFormattedMessageAsString)(intl, (0, $ewFKq.messages).assigned_to, personName);
        case (0, $j9rqA.ElementName).OwnedByGroup:
            return (0, $cAG6t.getFormattedMessageAsString)(intl, (0, $ewFKq.messages).owned_by, personName);
        case (0, $j9rqA.ElementName).AuthorGroup:
            return (0, $cAG6t.getFormattedMessageAsString)(intl, (0, $ewFKq.messages).created_by, personName);
        default:
            return personName;
    }
};
/**
 * A base element that displays a group of avatars.
 * @internal
 * @param {BaseAvatarGroupElementProps} BaseAvatarGroupElementProps - The props necessary for the AvatarGroup.
 * @see AuthorGroup
 * @see CollaboratorGroup
 */ const $a5f7d0ca2a03ef3e$var$BaseAvatarGroup = ({ items: items = [], maxCount: maxCount = 4, name: name, className: className, testId: testId = 'smart-element-avatar-group', showNamePrefix: showNamePrefix = false, showFallbackAvatar: showFallbackAvatar = true })=>{
    const intl = (0, $gpjDl.default)();
    const data = (0, $fc4bM.useMemo)(()=>{
        if (!items.length && showFallbackAvatar) switch(name){
            case (0, $j9rqA.ElementName).AssignedToGroup:
                return [
                    {
                        name: (0, $cAG6t.getFormattedMessageAsString)(intl, (0, $ewFKq.messages).unassigned)
                    }
                ];
            default:
                return [];
        }
        //show a name prefix if there is one Avatar in a group only
        if (name && items.length === 1 && showNamePrefix) return items.map((person)=>{
            return {
                ...person,
                name: $a5f7d0ca2a03ef3e$var$getPersonNameWithPrefix(name, person.name, intl) || person.name
            };
        });
        return items;
    }, [
        name,
        items,
        showNamePrefix,
        showFallbackAvatar,
        intl
    ]);
    if (!data.length) return null;
    return /*#__PURE__*/ $fc4bM.createElement("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-avatar-group": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $2R2iS.default)([
            "_1ul91ns9 _1e0c116y _1kvxu2gc _102oidpf",
            className
        ])
    }, /*#__PURE__*/ $fc4bM.createElement((0, $aEADZ.default), {
        maxCount: maxCount,
        appearance: "stack",
        size: "small",
        data: data,
        testId: testId
    }));
};
var $a5f7d0ca2a03ef3e$export$2e2bcd8739ae039 = $a5f7d0ca2a03ef3e$var$BaseAvatarGroup;

});
parcelRegister("cAG6t", function(module, exports) {
$parcel$export(module.exports, "getFormattedMessageAsString", () => $89d98562446951d3$export$66ecb50a9dd1768);
const $89d98562446951d3$export$66ecb50a9dd1768 = (intl, message, context)=>{
    const { formatMessage: formatMessage } = intl;
    return message ? formatMessage(message, {
        context: context
    }) : '';
};

});


parcelRegister("2nEjX", function(module, exports) {
$parcel$export(module.exports, "toAvatarGroupProps", () => $96eafaa9d525afa3$export$91ba8651475968bd);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $96eafaa9d525afa3$export$91ba8651475968bd = (items, showFallbackAvatar)=>{
    return items ? {
        items: items
    } : showFallbackAvatar ? {
        items: []
    } : undefined;
};

});


parcelRegister("bNuWk", function(module, exports) {
$parcel$export(module.exports, "default", () => $7280c9ee38b27ab1$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $dweer = parcelRequire("dweer");

var $dE7FH = parcelRequire("dE7FH");
var $cbIJN = parcelRequire("cbIJN");
const $7280c9ee38b27ab1$var$AttachmentCountElement = (props)=>{
    var _context$attachmentCo;
    const context = (0, $dweer.useFlexibleUiContext)();
    const data = context ? (0, $cbIJN.toBadgeProps)((_context$attachmentCo = context.attachmentCount) === null || _context$attachmentCo === void 0 ? void 0 : _context$attachmentCo.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dE7FH.default), {
        icon: (0, $j9rqA.IconType).Attachment,
        ...data,
        ...props,
        name: (0, $j9rqA.ElementName).AttachmentCount
    }) : null;
};
var $7280c9ee38b27ab1$export$2e2bcd8739ae039 = $7280c9ee38b27ab1$var$AttachmentCountElement;

});
parcelRegister("cbIJN", function(module, exports) {
$parcel$export(module.exports, "toBadgeProps", () => $7f466415d482ae1a$export$a2fb457791942ba4);
/* eslint-disable @atlaskit/design-system/use-tokens-typography */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $7f466415d482ae1a$export$a2fb457791942ba4 = (label)=>{
    // Don't render the element if its 0
    return label !== '0' && label ? {
        label: label
    } : undefined;
};

});


parcelRegister("fXNUY", function(module, exports) {
$parcel$export(module.exports, "default", () => $fbf4fe541fb60c61$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $dweer = parcelRequire("dweer");

var $9ksQI = parcelRequire("9ksQI");
var $2nEjX = parcelRequire("2nEjX");
const $fbf4fe541fb60c61$var$AuthorGroupElement = (props)=>{
    const context = (0, $dweer.useFlexibleUiContext)();
    const data = context ? (0, $2nEjX.toAvatarGroupProps)(context.authorGroup, false) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9ksQI.default), {
        ...data,
        ...props,
        name: (0, $j9rqA.ElementName).AuthorGroup
    }) : null;
};
var $fbf4fe541fb60c61$export$2e2bcd8739ae039 = $fbf4fe541fb60c61$var$AuthorGroupElement;

});

parcelRegister("eTjJU", function(module, exports) {
$parcel$export(module.exports, "default", () => $a3e7e42bd1b3c205$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $dweer = parcelRequire("dweer");

var $dE7FH = parcelRequire("dE7FH");
var $cbIJN = parcelRequire("cbIJN");
const $a3e7e42bd1b3c205$var$ChecklistProgressElement = (props)=>{
    var _context$checklistPro;
    const context = (0, $dweer.useFlexibleUiContext)();
    const data = context ? (0, $cbIJN.toBadgeProps)((_context$checklistPro = context.checklistProgress) === null || _context$checklistPro === void 0 ? void 0 : _context$checklistPro.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dE7FH.default), {
        icon: (0, $j9rqA.IconType).CheckItem,
        ...data,
        ...props,
        name: (0, $j9rqA.ElementName).ChecklistProgress
    }) : null;
};
var $a3e7e42bd1b3c205$export$2e2bcd8739ae039 = $a3e7e42bd1b3c205$var$ChecklistProgressElement;

});

parcelRegister("9vnjG", function(module, exports) {
$parcel$export(module.exports, "default", () => $84fe7121a5bc9237$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $dweer = parcelRequire("dweer");

var $9ksQI = parcelRequire("9ksQI");
var $2nEjX = parcelRequire("2nEjX");
const $84fe7121a5bc9237$var$CollaboratorGroupElement = (props)=>{
    const context = (0, $dweer.useFlexibleUiContext)();
    const data = context ? (0, $2nEjX.toAvatarGroupProps)(context.collaboratorGroup, false) : undefined;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9ksQI.default), {
        ...data,
        ...props,
        name: (0, $j9rqA.ElementName).CollaboratorGroup
    }) : null;
};
var $84fe7121a5bc9237$export$2e2bcd8739ae039 = $84fe7121a5bc9237$var$CollaboratorGroupElement;

});

parcelRegister("gg4EO", function(module, exports) {
$parcel$export(module.exports, "default", () => $c78e5732fd493c0d$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $dweer = parcelRequire("dweer");

var $dE7FH = parcelRequire("dE7FH");
var $cbIJN = parcelRequire("cbIJN");
const $c78e5732fd493c0d$var$CommentCountElement = (props)=>{
    var _context$commentCount;
    const context = (0, $dweer.useFlexibleUiContext)();
    const data = context ? (0, $cbIJN.toBadgeProps)((_context$commentCount = context.commentCount) === null || _context$commentCount === void 0 ? void 0 : _context$commentCount.toString()) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $fc4bM.useEffect)(()=>{
        onRender === null || onRender === void 0 || onRender(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dE7FH.default), {
        icon: (0, $j9rqA.IconType).Comment,
        ...data,
        ...restProps,
        name: (0, $j9rqA.ElementName).CommentCount
    }) : null;
};
var $c78e5732fd493c0d$export$2e2bcd8739ae039 = $c78e5732fd493c0d$var$CommentCountElement;

});

parcelRegister("2X94o", function(module, exports) {
$parcel$export(module.exports, "default", () => $0d18b78ec76bff37$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $ewFKq = parcelRequire("ewFKq");

var $dweer = parcelRequire("dweer");

var $jBxpI = parcelRequire("jBxpI");
var $i520X = parcelRequire("i520X");
const $0d18b78ec76bff37$var$CreatedByElement = (props)=>{
    const context = (0, $dweer.useFlexibleUiContext)();
    const data = context ? (0, $i520X.toFormattedTextProps)((0, $ewFKq.messages).created_by, context.createdBy) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jBxpI.default), {
        ...data,
        ...props,
        name: (0, $j9rqA.ElementName).CreatedBy
    }) : null;
};
var $0d18b78ec76bff37$export$2e2bcd8739ae039 = $0d18b78ec76bff37$var$CreatedByElement;

});

parcelRegister("3ojH0", function(module, exports) {
$parcel$export(module.exports, "default", () => $946828558c3944b7$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $dweer = parcelRequire("dweer");

var $66cSi = parcelRequire("66cSi");
var $90A9K = parcelRequire("90A9K");
const $946828558c3944b7$var$CreatedOnElement = (props)=>{
    const context = (0, $dweer.useFlexibleUiContext)();
    const data = context ? (0, $90A9K.toDateTimeProps)('created', context.createdOn) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $66cSi.default), {
        ...data,
        ...props,
        name: (0, $j9rqA.ElementName).CreatedOn
    }) : null;
};
var $946828558c3944b7$export$2e2bcd8739ae039 = $946828558c3944b7$var$CreatedOnElement;

});
parcelRegister("66cSi", function(module, exports) {
$parcel$export(module.exports, "default", () => $e92241f471b0f431$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $1EY6C = parcelRequire("1EY6C");

var $fd880 = parcelRequire("fd880");
var $gpjDl = parcelRequire("gpjDl");

var $dRkX9 = parcelRequire("dRkX9");

var $ewFKq = parcelRequire("ewFKq");

var $2jOTt = parcelRequire("2jOTt");
const $e92241f471b0f431$var$styles = null;
const $e92241f471b0f431$var$ABSOLUTE_DATE_FORMAT = {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
};
const $e92241f471b0f431$var$isValidTimeZone = (timeZone)=>{
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZone
        });
        return true;
    } catch  {
        return false;
    }
};
const $e92241f471b0f431$var$formatAbsoluteDateWithOptionalTimeZone = ({ date: date, formatDate: formatDate, timeZone: timeZone })=>{
    if (!timeZone || !$e92241f471b0f431$var$isValidTimeZone(timeZone)) return formatDate(date, $e92241f471b0f431$var$ABSOLUTE_DATE_FORMAT);
    return formatDate(date, {
        ...$e92241f471b0f431$var$ABSOLUTE_DATE_FORMAT,
        timeZone: timeZone
    });
};
const $e92241f471b0f431$var$typeToDescriptorMap = {
    created: {
        relative: (0, $ewFKq.messages).created_on_relative,
        absolute: (0, $ewFKq.messages).created_on_absolute
    },
    modified: {
        relative: (0, $ewFKq.messages).modified_on_relative,
        absolute: (0, $ewFKq.messages).modified_on_absolute
    },
    sent: {
        relative: (0, $ewFKq.messages).sent_on_relative,
        absolute: (0, $ewFKq.messages).sent_on_absolute
    }
};
const $e92241f471b0f431$var$fontOverrideStyleMap = {
    'font.body': "_11c8fhey",
    'font.body.large': "_11c81d4k",
    'font.body.small': "_11c8wadc"
};
/**
 * A base element that displays an ISO Timestamp in text.
 * @internal
 * @param {BaseDateTimeElementProps} BaseDateTimeElementProps - The props necessary for the DateTime element.
 * @see CreatedOn
 * @see ModifiedOn
 * @see SentOn
 */ const $e92241f471b0f431$var$BaseDateTimeElement = ({ date: date, name: name, className: className, type: type, testId: testId = 'smart-element-date-time', text: text, hideDatePrefix: hideDatePrefix = false, color: color, fontSize: fontSize, timeZone: timeZone })=>{
    const { formatRelativeTime: formatRelativeTime, formatDate: formatDate } = (0, $gpjDl.default)();
    const shouldUseHydrationSafeContent = (0, $2jOTt.default)(Boolean(type && date));
    if (!type || !date) return null;
    const isLongerThenWeek = Math.abs(date.getTime() - Date.now()) > 604800000;
    let context;
    let typeVariant;
    if (shouldUseHydrationSafeContent) {
        // Use the same absolute date on SSR and the first client render. The browser's
        // timezone and clock are only used after hydration (or on client-only mounts).
        typeVariant = 'absolute';
        context = formatDate(date, {
            ...$e92241f471b0f431$var$ABSOLUTE_DATE_FORMAT,
            timeZone: (0, $dRkX9.fg)('dfo_issue_view_remote_data_srr_group') && timeZone && $e92241f471b0f431$var$isValidTimeZone(timeZone) ? timeZone : 'UTC'
        });
    } else if (isLongerThenWeek) {
        typeVariant = 'absolute';
        context = (0, $dRkX9.fg)('dfo_issue_view_remote_data_srr_group') ? $e92241f471b0f431$var$formatAbsoluteDateWithOptionalTimeZone({
            date: date,
            formatDate: formatDate,
            timeZone: timeZone
        }) : formatDate(date, {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    } else {
        const { value: value, unit: unit } = (0, $1EY6C.selectUnit)(date, Date.now());
        typeVariant = 'relative';
        context = formatRelativeTime(value, unit, {
            numeric: 'auto'
        });
    }
    let content;
    if (hideDatePrefix) content = context;
    else if (text) content = `${text} ${context}`;
    else content = /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), {
        ...$e92241f471b0f431$var$typeToDescriptorMap[type][typeVariant],
        values: {
            context: context
        }
    });
    return /*#__PURE__*/ $fc4bM.createElement("span", {
        style: {
            color: color
        },
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-date-time": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $2R2iS.default)([
            "_11c8wadc _1reo15vq _18m915vq _syazazsu _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _102k7vkz",
            fontSize !== undefined && $e92241f471b0f431$var$fontOverrideStyleMap[fontSize],
            className
        ])
    }, content);
};
var $e92241f471b0f431$export$2e2bcd8739ae039 = $e92241f471b0f431$var$BaseDateTimeElement;

});
parcelRegister("2jOTt", function(module, exports) {
$parcel$export(module.exports, "default", () => $486c72661788f739$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $bcN2K = parcelRequire("bcN2K");
const $486c72661788f739$var$subscribe = ()=>()=>{};
const $486c72661788f739$var$getClientSnapshot = ()=>false;
function $486c72661788f739$export$2e2bcd8739ae039(isEligible = true) {
    return (0, $fc4bM.useSyncExternalStore)($486c72661788f739$var$subscribe, $486c72661788f739$var$getClientSnapshot, // React only reads this snapshot during SSR/hydration, so client-only mounts
    // never fire an exposure. Control matches the client snapshot and needs no update.
    ()=>isEligible && (0, $bcN2K.isExperimentEnabled)('platform_sl_hydration_safe_content'));
}

});


parcelRegister("90A9K", function(module, exports) {
$parcel$export(module.exports, "toDateTimeProps", () => $ba469f722b1e1cc2$export$2d4384e6b150cbe3);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $ba469f722b1e1cc2$export$2d4384e6b150cbe3 = (type, dateString)=>{
    return dateString ? {
        date: new Date(dateString),
        type: type
    } : undefined;
};

});


parcelRegister("7QV7I", function(module, exports) {
$parcel$export(module.exports, "default", () => $21fb6f835728df95$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $dweer = parcelRequire("dweer");

var $6sAht = parcelRequire("6sAht");
var $uebzF = parcelRequire("uebzF");
const $21fb6f835728df95$var$DueOnElement = (props)=>{
    const context = (0, $dweer.useFlexibleUiContext)();
    const data = context ? (0, $uebzF.toDateLozengeProps)(context.dueOn) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6sAht.default), {
        ...data,
        ...props,
        name: (0, $j9rqA.ElementName).DueOn,
        isDateTag: true
    }) : null;
};
var $21fb6f835728df95$export$2e2bcd8739ae039 = $21fb6f835728df95$var$DueOnElement;

});
parcelRegister("6sAht", function(module, exports) {
$parcel$export(module.exports, "default", () => $341e3c8d93332a96$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $9wELi = parcelRequire("9wELi");

var $dRkX9 = parcelRequire("dRkX9");

var $1KdVH = parcelRequire("1KdVH");

var $j9rqA = parcelRequire("j9rqA");

var $5QRjl = parcelRequire("5QRjl");

var $eRUAw = parcelRequire("eRUAw");
const $341e3c8d93332a96$var$styles = null;
const $341e3c8d93332a96$var$dueOnStyles = null;
/**
 * A base element that displays a Lozenge.
 * @internal
 * @param {BaseLozengeElementProps} BaseLozengeElementProps - The props necessary for the Lozenge element.
 * @see State
 */ const $341e3c8d93332a96$var$BaseLozengeElement = ({ action: action, appearance: appearance = 'default', className: className, maxWidth: maxWidth, name: name, onAfterChanged: onAfterChanged, style: style, text: text, testId: testId = 'smart-element-lozenge', isDateTag: isDateTag, trailingMetric: trailingMetric })=>{
    const ui = (0, $5QRjl.useFlexibleUiOptionContext)();
    if (!text) return null;
    const lozenge = action ? /*#__PURE__*/ $fc4bM.createElement((0, $eRUAw.default), {
        action: action,
        appearance: appearance,
        maxWidth: maxWidth,
        testId: testId,
        text: text,
        zIndex: ui === null || ui === void 0 ? void 0 : ui.zIndex,
        shouldRenderToParent: (0, $dRkX9.fg)('billplat_jira_list_dropdown_top_layer') && name === (0, $j9rqA.ElementName).State && Boolean(ui === null || ui === void 0 ? void 0 : ui.shouldRenderStatusToParent),
        onAfterChanged: onAfterChanged,
        ...trailingMetric && (0, $dRkX9.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? {
            trailingMetric: trailingMetric
        } : undefined
    }) : isDateTag ? /*#__PURE__*/ $fc4bM.createElement((0, $1KdVH.default), {
        text: text,
        migration_fallback: "lozenge"
    }) : /*#__PURE__*/ $fc4bM.createElement((0, $9wELi.default), {
        appearance: appearance,
        isBold: true,
        maxWidth: maxWidth,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        testId: `${testId}-lozenge`,
        ...trailingMetric && (0, $dRkX9.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? {
            trailingMetric: trailingMetric
        } : undefined
    }, text);
    return /*#__PURE__*/ $fc4bM.createElement("span", {
        "data-smart-element": name,
        "data-smart-element-lozenge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $2R2iS.default)([
            "_1e0c116y _1ul91ns9",
            isDateTag && (0, $dRkX9.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') && "_19pkr5cr _2hwxr5cr _otyrr5cr _18u0r5cr",
            className
        ])
    }, lozenge);
};
var $341e3c8d93332a96$export$2e2bcd8739ae039 = $341e3c8d93332a96$var$BaseLozengeElement;

});
parcelRegister("1KdVH", function(module, exports) {
$parcel$export(module.exports, "default", () => $a970f2157836424b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $lsag9 = parcelRequire("lsag9");

var $gVOWU = parcelRequire("gVOWU");

var $e1Lq5 = parcelRequire("e1Lq5");
const $a970f2157836424b$var$SimpleTagComponent = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ elemBefore: elemBefore = null, color: color = 'standard', href: href, linkComponent: linkComponent, testId: testId, text: text = '', maxWidth: maxWidth, swatchBefore: swatchBefore, swatchBeforeLabel: swatchBeforeLabel, swatchBeforeRole: swatchBeforeRole }, ref)=>{
    const newColor = (0, $lsag9.colorMapping)[color || 'standard'];
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $e1Lq5.default), {
        ref: ref,
        color: newColor,
        text: text,
        elemBefore: elemBefore,
        href: href,
        linkComponent: linkComponent,
        testId: testId,
        isRemovable: false,
        maxWidth: maxWidth,
        swatchBefore: swatchBefore,
        swatchBeforeLabel: swatchBeforeLabel,
        swatchBeforeRole: swatchBeforeRole
    });
});
/**
 * __Simple tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * `SimpleTag` is the default form of a tag, where text is required. Tags with static text can be used as a flag or as a reference to an object or attribute.
 *
 * - [Examples](https://atlassian.design/components/tag/examples)
 * - [Code](https://atlassian.design/components/tag/code)
 * - [Usage](https://atlassian.design/components/tag/usage)
 *
 * @deprecated `SimpleTag` is deprecated. Use the default `Tag` export from
 * `@atlaskit/tag` with `isRemovable={false}` instead, e.g. `<Tag text="…" isRemovable={false} />`.
 */ const $a970f2157836424b$var$SimpleTag = (0, $gVOWU.markAsTagMotionCapable)(/*#__PURE__*/ (0, $fc4bM.memo)($a970f2157836424b$var$SimpleTagComponent));
var $a970f2157836424b$export$2e2bcd8739ae039 = $a970f2157836424b$var$SimpleTag;

});

parcelRegister("eRUAw", function(module, exports) {
$parcel$export(module.exports, "default", () => $3974a57139310a6c$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $2Vha5 = parcelRequire("2Vha5");

var $dRkX9 = parcelRequire("dRkX9");

var $fVrlX = parcelRequire("fVrlX");

var $haNg7 = parcelRequire("haNg7");

var $4tlV7 = parcelRequire("4tlV7");

var $6Jlpv = parcelRequire("6Jlpv");

var $fypiH = parcelRequire("fypiH");

var $bJImI = parcelRequire("bJImI");

var $9JzR9 = parcelRequire("9JzR9");

var $1IiHI = parcelRequire("1IiHI");

var $2TCzp = parcelRequire("2TCzp");

var $cU2Ax = parcelRequire("cU2Ax");

var $f4LEa = parcelRequire("f4LEa");

var $kqU4H = parcelRequire("kqU4H");

var $h73Ps = parcelRequire("h73Ps");
const $3974a57139310a6c$var$validateItems = (items = [], text)=>{
    return items.filter((item)=>item.text !== text);
};
const $3974a57139310a6c$var$LozengeAction = ({ action: action, appearance: appearance, maxWidth: maxWidth, testId: testId = 'smart-element-lozenge-action', text: text, zIndex: zIndex, onAfterChanged: onAfterChanged, trailingMetric: trailingMetric, shouldRenderToParent: shouldRenderToParent = false })=>{
    var _action$update;
    const [selected, setSelected] = (0, $fc4bM.useState)({
        appearance: appearance,
        text: text
    });
    const [isLoaded, setIsLoaded] = (0, $fc4bM.useState)(false);
    const [isLoading, setIsLoading] = (0, $fc4bM.useState)(false);
    const [isOpen, setIsOpen] = (0, $fc4bM.useState)(false);
    const [items, setItems] = (0, $fc4bM.useState)();
    const [errorMessage, setErrorMessage] = (0, $fc4bM.useState)();
    const reload = (0, $fypiH.default)();
    const invoke = (0, $4tlV7.default)();
    const { fireEvent: fireEvent } = (0, $fVrlX.useAnalyticsEvents)();
    (0, $fc4bM.useEffect)(()=>{
        setSelected({
            text: text,
            appearance: appearance
        });
    }, [
        text,
        appearance
    ]);
    const { url: url, id: linkId, invokePreviewAction: invokePreviewAction } = (action === null || action === void 0 || (_action$update = action.update) === null || _action$update === void 0 ? void 0 : _action$update.details) || {};
    const handleOpenChange = (0, $fc4bM.useCallback)(async (args)=>{
        setIsOpen(args.isOpen);
        if (args.isOpen) {
            fireEvent('ui.button.clicked.smartLinkStatusLozenge', {});
            fireEvent('track.smartLinkQuickAction.started', {
                smartLinkActionType: (0, $9JzR9.TrackQuickActionType).StatusUpdate
            });
            if (!isLoaded && action !== null && action !== void 0 && action.read) try {
                setIsLoading(true);
                const responseItems = await invoke(action.read, (0, $haNg7.default));
                const validItems = typeof text === 'string' ? $3974a57139310a6c$var$validateItems(responseItems, text) : responseItems;
                setItems(validItems);
                setIsLoaded(true);
                if ((validItems === null || validItems === void 0 ? void 0 : validItems.length) === 0) {
                    fireEvent('track.smartLinkQuickAction.failed', (0, $2TCzp.permissionLoadErrorAnalyticsPayload));
                    setErrorMessage((0, $dRkX9.fg)('confluence-issue-terminology-refresh') ? (0, $f4LEa.LozengeActionErrorMessages).noDataIssueTermRefresh : (0, $f4LEa.LozengeActionErrorMessages).noData);
                    setIsLoaded(false);
                }
            } catch  {
                setErrorMessage((0, $f4LEa.LozengeActionErrorMessages).unknown);
                setIsLoaded(false);
                fireEvent('track.smartLinkQuickAction.failed', (0, $2TCzp.unknownLoadErrorAnalyticsPayload));
            } finally{
                setIsLoading(false);
            }
        }
        if (!args.isOpen) setErrorMessage(undefined);
    }, [
        action.read,
        invoke,
        isLoaded,
        text,
        fireEvent
    ]);
    const trigger = (0, $fc4bM.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $h73Ps.default), {
            ...props,
            appearance: selected.appearance,
            isOpen: isOpen,
            maxWidth: maxWidth,
            testId: testId,
            text: selected.text,
            trailingMetric: trailingMetric
        }), [
        selected.appearance,
        selected.text,
        isOpen,
        maxWidth,
        testId,
        trailingMetric
    ]);
    const handleItemClick = (0, $fc4bM.useCallback)(async (id, text, appearance)=>{
        try {
            fireEvent('ui.button.clicked.smartLinkStatusListItem', {});
            const updateAction = action === null || action === void 0 ? void 0 : action.update;
            if (updateAction && id) {
                setIsLoading(true);
                const request = (0, $bJImI.default)(updateAction, id);
                await invoke(request);
                onAfterChanged === null || onAfterChanged === void 0 || onAfterChanged();
                setSelected({
                    appearance: appearance,
                    text: text
                });
                setIsLoading(false);
                setIsLoaded(false);
                setIsOpen(false);
                setItems([]);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: (0, $9JzR9.TrackQuickActionType).StatusUpdate
                });
                if (url) await reload({
                    url: url,
                    isReloading: true,
                    id: linkId
                });
            }
        } catch (err) {
            setIsLoading(false);
            if ((0, $6Jlpv.isInvokeCustomError)(err)) {
                setErrorMessage(err.message);
                fireEvent('track.smartLinkQuickAction.failed', (0, $2TCzp.validationUpdateErrorAnalyticsPayload));
            } else {
                setErrorMessage((0, $f4LEa.LozengeActionErrorMessages).updateFailed);
                fireEvent('track.smartLinkQuickAction.failed', (0, $2TCzp.unknownUpdateErrorAnalyticsPayload));
            }
        }
    }, [
        action === null || action === void 0 ? void 0 : action.update,
        invoke,
        linkId,
        reload,
        url,
        fireEvent,
        onAfterChanged
    ]);
    const dropdownItemGroup = (0, $fc4bM.useMemo)(()=>{
        if (errorMessage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cU2Ax.default), {
            errorMessage: errorMessage,
            testId: testId,
            url: url,
            invokePreviewAction: invokePreviewAction
        });
        if (items && items.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kqU4H.default), {
            testId: testId,
            items: items,
            onClick: handleItemClick
        });
    }, [
        errorMessage,
        handleItemClick,
        items,
        invokePreviewAction,
        testId,
        url
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2Vha5.default), {
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: handleOpenChange,
        testId: testId,
        trigger: trigger,
        zIndex: zIndex,
        shouldRenderToParent: shouldRenderToParent
    }, dropdownItemGroup);
};
const $3974a57139310a6c$var$_default_1 = (0, $1IiHI.default)($3974a57139310a6c$var$LozengeAction);
var $3974a57139310a6c$export$2e2bcd8739ae039 = $3974a57139310a6c$var$_default_1;

});
parcelRegister("haNg7", function(module, exports) {
$parcel$export(module.exports, "default", () => $73a6c18f34cffaac$export$2e2bcd8739ae039);
const $73a6c18f34cffaac$var$extractLozengeActionItems = (response)=>{
    var _response$transitions;
    const items = (response === null || response === void 0 || (_response$transitions = response.transitions) === null || _response$transitions === void 0 ? void 0 : _response$transitions.map(({ appearance: appearance, id: id, name: name })=>({
            appearance: appearance ?? 'default',
            id: id,
            text: name
        }))) ?? [];
    return items.sort((a, b)=>a.appearance.localeCompare(b.appearance) || a.text.localeCompare(b.text));
};
var $73a6c18f34cffaac$export$2e2bcd8739ae039 = $73a6c18f34cffaac$var$extractLozengeActionItems;

});

parcelRegister("bJImI", function(module, exports) {
$parcel$export(module.exports, "default", () => $3cd82b01aae43d45$export$2e2bcd8739ae039);
const $3cd82b01aae43d45$var$createStatusUpdateRequest = (request, id)=>({
        providerKey: request.providerKey,
        action: {
            ...request.action,
            payload: {
                newStatusId: id
            }
        }
    });
var $3cd82b01aae43d45$export$2e2bcd8739ae039 = $3cd82b01aae43d45$var$createStatusUpdateRequest;

});

parcelRegister("1IiHI", function(module, exports) {
$parcel$export(module.exports, "default", () => $5aa1b4dc830d42ca$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $1VpRA = parcelRequire("1VpRA");

var $9wELi = parcelRequire("9wELi");
const $5aa1b4dc830d42ca$var$withErrorBoundary = (Component)=>(props)=>{
        const fallback = (0, $fc4bM.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9wELi.default), {
                appearance: props === null || props === void 0 ? void 0 : props.appearance,
                isBold: true,
                testId: `${(props === null || props === void 0 ? void 0 : props.testId) ?? 'smart-element-lozenge-action'}-fallback`,
                trailingMetric: props === null || props === void 0 ? void 0 : props.trailingMetric
            }, props === null || props === void 0 ? void 0 : props.text), [
            props === null || props === void 0 ? void 0 : props.appearance,
            props === null || props === void 0 ? void 0 : props.testId,
            props === null || props === void 0 ? void 0 : props.text,
            props === null || props === void 0 ? void 0 : props.trailingMetric
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1VpRA.ErrorBoundary), {
            fallback: fallback
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Component, props));
    };
var $5aa1b4dc830d42ca$export$2e2bcd8739ae039 = $5aa1b4dc830d42ca$var$withErrorBoundary;

});

parcelRegister("2TCzp", function(module, exports) {
$parcel$export(module.exports, "unknownLoadErrorAnalyticsPayload", () => $9ff1600165beb65c$export$2a568ff99500df53);
$parcel$export(module.exports, "permissionLoadErrorAnalyticsPayload", () => $9ff1600165beb65c$export$2de2d0ccc17b915f);
$parcel$export(module.exports, "unknownUpdateErrorAnalyticsPayload", () => $9ff1600165beb65c$export$c1c05f9d51f7c467);
$parcel$export(module.exports, "validationUpdateErrorAnalyticsPayload", () => $9ff1600165beb65c$export$618660b8f2aa87e2);
const $9ff1600165beb65c$export$2a568ff99500df53 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'load'
};
const $9ff1600165beb65c$export$2de2d0ccc17b915f = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'PermissionError',
    step: 'load'
};
const $9ff1600165beb65c$export$c1c05f9d51f7c467 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'update'
};
const $9ff1600165beb65c$export$618660b8f2aa87e2 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'ValidationError',
    step: 'update'
};

});

parcelRegister("cU2Ax", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba0c5f5b279b491c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
var $8xbhL = parcelRequire("8xbhL");

var $fd880 = parcelRequire("fd880");

var $7A0bt = parcelRequire("7A0bt");

var $bZYjs = parcelRequire("bZYjs");

var $gDsF8 = parcelRequire("gDsF8");

var $dRkX9 = parcelRequire("dRkX9");

var $EawnW = parcelRequire("EawnW");

var $fVrlX = parcelRequire("fVrlX");

var $ewFKq = parcelRequire("ewFKq");

var $cA6hx = parcelRequire("cA6hx");

var $5oUA7 = parcelRequire("5oUA7");
const $ba0c5f5b279b491c$var$MAX_LINE_NUMBER = 8;
const $ba0c5f5b279b491c$var$styles = {
    contentStyles: "_zulpu2gc _11c81d4k _1reo15vq _18m915vq _1e0c1txw _1ul9idpf _2lx2vrvc _19pkv77o _4cvr1y6m _pqmefhey _102efhey _ngc0i7uo _1t4pi7uo",
    linkStyles: "_zulpu2gc _1reo15vq _18m915vq _11c8fhey _1e0c1txw _1ul9idpf _2lx2vrvc _4cvr1h6o _80omtlke _19pku2gc _18u0xy5q _otyrv77o",
    textStylesBase: "_11c81d4k _1reo15vq _18m915vq _o5724jg8 _1e0ccj1k _1bto1l2s _1nmz1hna _sudp1e54",
    dropdownItemGroupStyles: "_14hp1wdt _6pup1kw7 _1eo073ad",
    openIssueInJiraStyles: "_11c8fhey _v564k6bl _bfhk1j28 _1bah1e5h _1e0c1kw7 _syaz13af _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik1r31 _1bnx8stv _jf4cnqa1 _30l312zz"
};
const $ba0c5f5b279b491c$var$LozengeActionError = ({ errorMessage: errorMessage, testId: testId, maxLineNumber: maxLineNumber = $ba0c5f5b279b491c$var$MAX_LINE_NUMBER, invokePreviewAction: invokePreviewAction })=>{
    const { fireEvent: fireEvent } = (0, $fVrlX.useAnalyticsEvents)();
    const invoke = (0, $cA6hx.default)({});
    const isPreviewAvailable = invokePreviewAction !== undefined;
    const handlePreviewOpen = (0, $fc4bM.useCallback)(()=>{
        if (isPreviewAvailable) {
            fireEvent('ui.button.clicked.smartLinkStatusOpenPreview', {});
            if (invokePreviewAction) invoke(invokePreviewAction);
        }
    }, [
        isPreviewAvailable,
        invoke,
        invokePreviewAction,
        fireEvent
    ]);
    const dynamicCss = null;
    const content = (0, $fc4bM.useMemo)(()=>{
        return /*#__PURE__*/ $fc4bM.createElement((0, $fc4bM.Fragment), null, /*#__PURE__*/ $fc4bM.createElement("div", {
            className: (0, $2R2iS.default)([
                $ba0c5f5b279b491c$var$styles.contentStyles
            ])
        }, /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gDsF8))), {
            testId: `${testId}-icon`,
            color: "var(--ds-icon-danger, #C9372C)",
            label: 'error',
            spacing: "spacious"
        }), /*#__PURE__*/ $fc4bM.createElement("span", {
            "data-testid": `${testId}-error-message`,
            className: (0, $2R2iS.default)([
                $ba0c5f5b279b491c$var$styles.textStylesBase,
                "_1yyj1n6p _102k16q4"
            ]),
            style: {
                "--_t4prqe": (0, $8xbhL.default)(maxLineNumber)
            }
        }, typeof errorMessage === 'string' ? errorMessage : (0, $5oUA7.getFormattedMessage)(errorMessage))), isPreviewAvailable ? /*#__PURE__*/ $fc4bM.createElement("div", {
            className: (0, $2R2iS.default)([
                $ba0c5f5b279b491c$var$styles.linkStyles
            ])
        }, /*#__PURE__*/ $fc4bM.createElement((0, $EawnW.Pressable), {
            testId: `${testId}-open-embed`,
            onClick: handlePreviewOpen,
            xcss: $ba0c5f5b279b491c$var$styles.openIssueInJiraStyles
        }, (0, $dRkX9.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $ewFKq.messages).open_issue_in_jiraIssueTermRefresh) : /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $ewFKq.messages).open_issue_in_jira))) : null);
    }, [
        errorMessage,
        handlePreviewOpen,
        isPreviewAvailable,
        testId,
        dynamicCss
    ]);
    return /*#__PURE__*/ $fc4bM.createElement("span", {
        "data-testid": `${testId}-error-item-group`,
        className: (0, $2R2iS.default)([
            $ba0c5f5b279b491c$var$styles.dropdownItemGroupStyles
        ])
    }, /*#__PURE__*/ $fc4bM.createElement((0, $bZYjs.default), null, /*#__PURE__*/ $fc4bM.createElement((0, $7A0bt.default), {
        testId: `${testId}-error`
    }, content)));
};
var $ba0c5f5b279b491c$export$2e2bcd8739ae039 = $ba0c5f5b279b491c$var$LozengeActionError;

});

parcelRegister("f4LEa", function(module, exports) {
$parcel$export(module.exports, "LozengeActionErrorMessages", () => $0b4c99ddb7aab510$export$4f2e371a667ad688);

var $ewFKq = parcelRequire("ewFKq");
const $0b4c99ddb7aab510$export$4f2e371a667ad688 = {
    noData: {
        descriptor: (0, $ewFKq.messages)['status_change_permission_error']
    },
    noDataIssueTermRefresh: {
        descriptor: (0, $ewFKq.messages)['status_change_permission_errorIssueTermRefresh']
    },
    unknown: {
        descriptor: (0, $ewFKq.messages)['status_change_load_error']
    },
    updateFailed: {
        descriptor: (0, $ewFKq.messages)['status_change_update_error']
    }
};

});

parcelRegister("kqU4H", function(module, exports) {
$parcel$export(module.exports, "default", () => $6549d5874f347029$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $bZYjs = parcelRequire("bZYjs");

var $kJSXL = parcelRequire("kJSXL");
const $6549d5874f347029$var$dropdownItemGroupStyles = null;
const $6549d5874f347029$var$LozengeActionItemsGroup = ({ items: items, testId: testId, onClick: onClick })=>/*#__PURE__*/ $fc4bM.createElement("span", {
        "data-testid": `${testId}-item-group`,
        className: (0, $2R2iS.default)([
            "_c71l1mjv _18m91wug _1pv01r31 _1m1b1r31 _qh55glyw _lt2aglyw _ph3k1o36 _1twe1o36 _1ll71dpa _qprf1dpa _n6y8usvi _109gusvi _z29h1x9r _wlxp1x9r _1gfl12x7 _yhjmutpp _1gqn12x7 _11lvutpp _d4lf1f4h _14hp1wdt _6pup1kw7"
        ])
    }, /*#__PURE__*/ $fc4bM.createElement((0, $bZYjs.default), null, items.map((item, idx)=>/*#__PURE__*/ $fc4bM.createElement((0, $kJSXL.default), {
            ...item,
            key: idx,
            onClick: onClick,
            testId: `${testId}-item-${idx}`
        }))));
var $6549d5874f347029$export$2e2bcd8739ae039 = $6549d5874f347029$var$LozengeActionItemsGroup;

});
parcelRegister("kJSXL", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6d1b1ad98f8b3e5$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $7A0bt = parcelRequire("7A0bt");

var $9wELi = parcelRequire("9wELi");
const $b6d1b1ad98f8b3e5$var$LozengeActionItem = ({ appearance: appearance, id: id, onClick: onClick, testId: testId, text: text })=>{
    const handleClick = (0, $fc4bM.useCallback)((e)=>{
        // Prevent dropdown to close on select item.
        // We want to show loading screen.
        e.stopPropagation();
        if (onClick) onClick(id, text, appearance);
    }, [
        appearance,
        id,
        onClick,
        text
    ]);
    const handleMouseEnter = (0, $fc4bM.useCallback)((e)=>{
        var _e$currentTarget;
        (_e$currentTarget = e.currentTarget) === null || _e$currentTarget === void 0 || (_e$currentTarget = _e$currentTarget.firstElementChild) === null || _e$currentTarget === void 0 || _e$currentTarget.focus();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("span", {
        onFocus: handleMouseEnter,
        onMouseEnter: handleMouseEnter,
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7A0bt.default), {
        onClick: handleClick,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9wELi.default), {
        appearance: appearance,
        isBold: true
    }, text)));
};
var $b6d1b1ad98f8b3e5$export$2e2bcd8739ae039 = $b6d1b1ad98f8b3e5$var$LozengeActionItem;

});


parcelRegister("h73Ps", function(module, exports) {
$parcel$export(module.exports, "default", () => $2412fd6c1d711d25$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $jdt4T = parcelRequire("jdt4T");

var $gpjDl = parcelRequire("gpjDl");

var $13zmE = parcelRequire("13zmE");

var $8EZZE = parcelRequire("8EZZE");

var $9wELi = parcelRequire("9wELi");

var $dRkX9 = parcelRequire("dRkX9");

var $dBtOK = parcelRequire("dBtOK");

var $ewFKq = parcelRequire("ewFKq");
const $2412fd6c1d711d25$var$styles = {
    chevronDown: "_18u012x7 _1e0c1txw",
    lozengeContainer: "_kkk2n7od _2rko12b0 _1dqonqa1 _189ee4h9 _1h6d1j28 _bfhk1j28 _1e0c1txw _4cvr1h6o _4t3i7vkz",
    lozengeContainerSelected: "_1reo15vq _18m915vq _1h6d1v1w",
    lozengeDropdownContainer: "_ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
};
const $2412fd6c1d711d25$var$textStyles = null;
const $2412fd6c1d711d25$var$triggerLozengeStyles = null;
const $2412fd6c1d711d25$var$triggerButtonStyles = null;
const $2412fd6c1d711d25$var$LozengeActionTrigger = ({ appearance: appearance, isOpen: isOpen, maxWidth: maxWidth, testId: testId, text: text, triggerRef: triggerRef, trailingMetric: trailingMetric, ...props })=>{
    const intl = (0, $gpjDl.default)();
    const [isPressing, setIsPressing] = (0, $fc4bM.useState)(false);
    const [lozengeBackgroundColor, setLozengeBackgroundColor] = (0, $fc4bM.useState)(undefined);
    const [lozengeForegroundColor, setLozengeForegroundColor] = (0, $fc4bM.useState)(undefined);
    const onMouseOrKeyDown = (0, $fc4bM.useCallback)(()=>setIsPressing(true), []);
    const onMouseOrKeyUp = (0, $fc4bM.useCallback)(()=>setIsPressing(false), []);
    (0, $fc4bM.useEffect)(()=>{
        if (isPressing) {
            setLozengeBackgroundColor("var(--ds-background-selected-pressed, #8FB8F6)");
            setLozengeForegroundColor("var(--ds-text-selected, #1868DB)");
        } else if (isOpen) {
            setLozengeBackgroundColor("var(--ds-background-selected, #E9F2FE)");
            setLozengeForegroundColor("var(--ds-text-selected, #1868DB)");
        } else {
            setLozengeBackgroundColor(undefined);
            setLozengeForegroundColor(undefined);
        }
    }, [
        isPressing,
        isOpen
    ]);
    const lozenge = (0, $fc4bM.useMemo)(()=>{
        return /*#__PURE__*/ $fc4bM.createElement((0, $dBtOK.Box), {
            xcss: (0, $jdt4T.cx)($2412fd6c1d711d25$var$styles.lozengeContainer, (isOpen || isPressing) && $2412fd6c1d711d25$var$styles.lozengeContainerSelected),
            as: "span"
        }, /*#__PURE__*/ $fc4bM.createElement((0, $9wELi.default), {
            appearance: appearance,
            isBold: true,
            maxWidth: maxWidth,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: {
                backgroundColor: lozengeBackgroundColor,
                color: lozengeForegroundColor
            }
        }, /*#__PURE__*/ $fc4bM.createElement("span", {
            className: (0, $2R2iS.default)([
                "_4cvr1h6o _1e0c1txw"
            ])
        }, /*#__PURE__*/ $fc4bM.createElement("span", {
            className: (0, $2R2iS.default)([
                "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
            ])
        }, text), /*#__PURE__*/ $fc4bM.createElement((0, $dBtOK.Box), {
            as: "span",
            xcss: $2412fd6c1d711d25$var$styles.chevronDown
        }, /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($13zmE))), {
            color: "currentColor",
            label: "options",
            size: "small",
            "aria-hidden": true
        })))));
    }, [
        appearance,
        isPressing,
        text,
        isOpen,
        lozengeBackgroundColor,
        lozengeForegroundColor,
        maxWidth
    ]);
    return (0, $dRkX9.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? /*#__PURE__*/ $fc4bM.createElement((0, $dBtOK.Box), {
        xcss: $2412fd6c1d711d25$var$styles.lozengeDropdownContainer
    }, /*#__PURE__*/ $fc4bM.createElement((0, $8EZZE.default), {
        ...props,
        appearance: appearance,
        trailingMetric: trailingMetric,
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        maxWidth: maxWidth,
        testId: testId,
        ref: triggerRef,
        "aria-label": // The `as unknown` type cast is needed for react-intl v7 upgrade
        intl.formatMessage((0, $ewFKq.messages).change_status, {
            status: text
        })
    }, text)) : /*#__PURE__*/ $fc4bM.createElement("button", {
        type: "button",
        ...props,
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        style: {
            maxWidth: maxWidth
        },
        onMouseDown: onMouseOrKeyDown,
        onMouseUp: onMouseOrKeyUp,
        onKeyDown: onMouseOrKeyDown,
        onKeyUp: onMouseOrKeyUp,
        ref: triggerRef,
        "aria-label": // The `as unknown` type cast is needed for react-intl v7 upgrade
        intl.formatMessage((0, $ewFKq.messages).change_status, {
            status: text
        }),
        className: (0, $2R2iS.default)([
            "_kkk2n7od _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _15vhn7od _1dqonqa1 _189e1dm9 _1h6d1j28 _bfhk1j28 _syazn7od _80omtlke _ect4n7od _1wybn7od _zg8ln7od _k48pn7od _vwz4idpf _1p1dn7od _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _mizu1r31 _1guj1r31 _p8tl1r31 _ra3xglyw _pbhaglyw _1q2vglyw _128m1o36 _11ow1o36 _j8b81o36 _1bas1qi0 _19h61qi0 _1d391qi0 _1ejj1y54 _1u6l1y54 _6ssh1y54"
        ])
    }, lozenge);
};
var $2412fd6c1d711d25$export$2e2bcd8739ae039 = $2412fd6c1d711d25$var$LozengeActionTrigger;

});
parcelRegister("8EZZE", function(module, exports) {
$parcel$export(module.exports, "default", () => $745959dcd849d144$export$2e2bcd8739ae039);
/* lozenge-dropdown-trigger.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $9JZL9 = parcelRequire("9JZL9");

var $5O5Ib = parcelRequire("5O5Ib");
/**
 * __Lozenge Dropdown Trigger__
 *
 * An interactive lozenge component that acts as a dropdown trigger.
 * Built on LozengeBase with dropdown interaction patterns.
 *
 * - Supports all color variants from the lozenge
 * - Shows selected state with dedicated color tokens
 * - Includes a chevron icon on the right of the text
 * - Built for dropdown menu interactions
 * - Supports analytics events and UFO press interactions
 */ const $745959dcd849d144$var$LozengeDropdownTrigger = /*#__PURE__*/ (0, $fc4bM.memo)(/*#__PURE__*/ (0, $fc4bM.forwardRef)(({ children: children, testId: testId, appearance: appearance = 'neutral', spacing: spacing = 'default', iconBefore: iconBefore, trailingMetric: trailingMetric, trailingMetricAppearance: trailingMetricAppearance, isSelected: isSelected = false, isLoading: isLoading = false, maxWidth: maxWidth = 200, onClick: onClick = (0, $9JZL9.default), style: style, analyticsContext: analyticsContext, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, 'aria-label': ariaLabel }, ref)=>{
    const baseProps = {
        appearance: appearance,
        spacing: spacing,
        iconBefore: iconBefore,
        trailingMetric: trailingMetric,
        trailingMetricAppearance: trailingMetricAppearance,
        isSelected: isSelected,
        isLoading: isLoading,
        maxWidth: maxWidth,
        style: style,
        testId: testId,
        onClick: onClick,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        children: children,
        'aria-controls': ariaControls,
        'aria-expanded': ariaExpanded,
        'aria-haspopup': ariaHaspopup,
        'aria-label': ariaLabel
    };
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5O5Ib.default), {
        ref: ref,
        ...baseProps,
        children: children
    });
}));
$745959dcd849d144$var$LozengeDropdownTrigger.displayName = 'LozengeDropdownTrigger';
var $745959dcd849d144$export$2e2bcd8739ae039 = $745959dcd849d144$var$LozengeDropdownTrigger;

});




parcelRegister("uebzF", function(module, exports) {
$parcel$export(module.exports, "toDateLozengeProps", () => $e1755d3d3af2b080$export$8f9f58f7bac50fbe);
/* toDateLozengeProps.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $8p5Cv = parcelRequire("8p5Cv");
const $e1755d3d3af2b080$export$8f9f58f7bac50fbe = (dateString)=>{
    if (dateString) {
        const text = Date.parse(dateString) ? /*#__PURE__*/ $fc4bM.createElement((0, $8p5Cv.FormattedDate), {
            value: new Date(dateString),
            year: "numeric",
            month: "short",
            day: "numeric",
            formatMatcher: "best fit"
        }) : dateString;
        return {
            text: text
        };
    }
};

});


parcelRegister("lqR91", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8efe0a621014c7d$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $bxLV6 = parcelRequire("bxLV6");

var $jBxpI = parcelRequire("jBxpI");
const $d8efe0a621014c7d$var$HostNameElement = (props)=>{
    var _context$data;
    const context = (0, $bxLV6.useFlexibleCardContext)();
    const hostName = context === null || context === void 0 || (_context$data = context.data) === null || _context$data === void 0 ? void 0 : _context$data.hostName;
    return hostName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jBxpI.default), {
        content: hostName,
        ...props,
        name: (0, $j9rqA.ElementName).HostName
    }) : null;
};
var $d8efe0a621014c7d$export$2e2bcd8739ae039 = $d8efe0a621014c7d$var$HostNameElement;

});

parcelRegister("jC3PC", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a7954edd63117e2$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $dweer = parcelRequire("dweer");

var $dE7FH = parcelRequire("dE7FH");
var $cbIJN = parcelRequire("cbIJN");
const $2a7954edd63117e2$var$LatestCommitElement = (props)=>{
    var _context$latestCommit;
    const context = (0, $dweer.useFlexibleUiContext)();
    const data = context ? (0, $cbIJN.toBadgeProps)((_context$latestCommit = context.latestCommit) === null || _context$latestCommit === void 0 ? void 0 : _context$latestCommit.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dE7FH.default), {
        icon: (0, $j9rqA.IconType).Commit,
        ...data,
        ...props,
        name: (0, $j9rqA.ElementName).LatestCommit
    }) : null;
};
var $2a7954edd63117e2$export$2e2bcd8739ae039 = $2a7954edd63117e2$var$LatestCommitElement;

});

parcelRegister("2V9rV", function(module, exports) {
$parcel$export(module.exports, "default", () => $00b2bfb5f4215a68$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $dweer = parcelRequire("dweer");

var $eEPJn = parcelRequire("eEPJn");
const $00b2bfb5f4215a68$var$LocationElement = (props)=>{
    const context = (0, $dweer.useFlexibleUiContext)();
    const data = (context === null || context === void 0 ? void 0 : context.location) ?? null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eEPJn.default), {
        theme: (0, $j9rqA.SmartLinkInternalTheme).Grey,
        ...data,
        ...props,
        name: (0, $j9rqA.ElementName).Location
    }) : null;
};
var $00b2bfb5f4215a68$export$2e2bcd8739ae039 = $00b2bfb5f4215a68$var$LocationElement;

});

parcelRegister("b2nt7", function(module, exports) {
$parcel$export(module.exports, "default", () => $61d18eca91f36be1$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $ewFKq = parcelRequire("ewFKq");

var $dweer = parcelRequire("dweer");

var $jBxpI = parcelRequire("jBxpI");
var $i520X = parcelRequire("i520X");
const $61d18eca91f36be1$var$ModifiedByElement = (props)=>{
    const context = (0, $dweer.useFlexibleUiContext)();
    const data = context ? (0, $i520X.toFormattedTextProps)((0, $ewFKq.messages).modified_by, context.modifiedBy) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jBxpI.default), {
        ...data,
        ...props,
        name: (0, $j9rqA.ElementName).ModifiedBy
    }) : null;
};
var $61d18eca91f36be1$export$2e2bcd8739ae039 = $61d18eca91f36be1$var$ModifiedByElement;

});

parcelRegister("fXXMA", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4aa23e94150d299$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $dweer = parcelRequire("dweer");

var $66cSi = parcelRequire("66cSi");
var $90A9K = parcelRequire("90A9K");
const $e4aa23e94150d299$var$ModifiedOnElement = (props)=>{
    const context = (0, $dweer.useFlexibleUiContext)();
    const data = context ? (0, $90A9K.toDateTimeProps)('modified', context.modifiedOn) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $fc4bM.useEffect)(()=>{
        onRender === null || onRender === void 0 || onRender(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $66cSi.default), {
        ...data,
        ...restProps,
        name: (0, $j9rqA.ElementName).ModifiedOn
    }) : null;
};
var $e4aa23e94150d299$export$2e2bcd8739ae039 = $e4aa23e94150d299$var$ModifiedOnElement;

});

parcelRegister("4BVlT", function(module, exports) {
$parcel$export(module.exports, "default", () => $03dba3ec8c4a229f$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $ewFKq = parcelRequire("ewFKq");

var $dweer = parcelRequire("dweer");

var $jBxpI = parcelRequire("jBxpI");
var $i520X = parcelRequire("i520X");
const $03dba3ec8c4a229f$var$OwnedByElement = (props)=>{
    const context = (0, $dweer.useFlexibleUiContext)();
    const { onRender: onRender, textPrefix: textPrefix = 'owned_by', ...restProps } = props || {};
    const data = context ? (0, $i520X.toFormattedTextProps)((0, $ewFKq.messages)[textPrefix], context === null || context === void 0 ? void 0 : context.ownedBy) : null;
    (0, $fc4bM.useEffect)(()=>{
        onRender === null || onRender === void 0 || onRender(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jBxpI.default), {
        ...data,
        ...restProps,
        name: (0, $j9rqA.ElementName).OwnedBy
    }) : null;
};
var $03dba3ec8c4a229f$export$2e2bcd8739ae039 = $03dba3ec8c4a229f$var$OwnedByElement;

});

parcelRegister("7E1Fn", function(module, exports) {
$parcel$export(module.exports, "default", () => $17c244cdb32c5fd0$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $dweer = parcelRequire("dweer");

var $9ksQI = parcelRequire("9ksQI");
var $2nEjX = parcelRequire("2nEjX");
const $17c244cdb32c5fd0$var$OwnedByGroupElement = (props)=>{
    const context = (0, $dweer.useFlexibleUiContext)();
    const data = context ? (0, $2nEjX.toAvatarGroupProps)(context.ownedByGroup, false) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $fc4bM.useEffect)(()=>{
        onRender === null || onRender === void 0 || onRender(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9ksQI.default), {
        ...data,
        ...restProps,
        name: (0, $j9rqA.ElementName).OwnedByGroup
    }) : null;
};
var $17c244cdb32c5fd0$export$2e2bcd8739ae039 = $17c244cdb32c5fd0$var$OwnedByGroupElement;

});

parcelRegister("7L0w2", function(module, exports) {
$parcel$export(module.exports, "default", () => $807ddedbe34dfad7$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $dweer = parcelRequire("dweer");

var $3VPFl = parcelRequire("3VPFl");
const $807ddedbe34dfad7$var$PreviewElement = (props)=>{
    const { overrideUrl: overrideUrl, ...rest } = props ?? {};
    const context = (0, $dweer.useFlexibleUiContext)();
    const data = overrideUrl ? {
        url: overrideUrl,
        type: (0, $j9rqA.MediaType).Image
    } : context === null || context === void 0 ? void 0 : context.preview;
    if (!data) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3VPFl.default), {
        ...rest,
        ...data
    });
};
var $807ddedbe34dfad7$export$2e2bcd8739ae039 = $807ddedbe34dfad7$var$PreviewElement;

});
parcelRegister("3VPFl", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f0d4c9ffd6a9524$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $5QRjl = parcelRequire("5QRjl");

var $4mDZ7 = parcelRequire("4mDZ7");
/**
 * Media: Image
 * [aspect-ratio: 16 / 9] The context box is fixed to aspect ratio of 16:9.
 * [object-fit: cover] The replaced content is sized to maintain
 * its aspect ratio while filling the element's entire content box.
 * If the object's aspect ratio does not match the aspect ratio of its box,
 * then the object will be clipped to fit.
 * [object-position] Center alignment of the selected replaced element's
 * contents within the element's box.
 */ const $8f0d4c9ffd6a9524$var$styles = null;
/**
 * A base element that displays a Media.
 * @internal
 * @param props - The props necessary for the Media element.
 */ const $8f0d4c9ffd6a9524$var$MediaElement = ({ name: name, className: className, testId: testId = 'smart-element-media', type: type, url: url, onLoad: onLoad, onError: onError })=>{
    const ui = (0, $5QRjl.useFlexibleUiOptionContext)();
    if (!type || !url) return null;
    return /*#__PURE__*/ $fc4bM.createElement("div", {
        "data-smart-element": name,
        "data-smart-element-media": type,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $2R2iS.default)([
            "_1h1tcq2i _1e0c1txw _1bsb1osq _4t3i1ns9 _jqez1osq _1lg71osq _6slq1osq _x1m21osq _1chb1osq _1usb1osq _5c331osq _l9z01osq _6o691dfr _vr2g1dfr _173baqso _1niwaqso _t0h9stnw _1ulbstnw _byj21ooe _3hvr1ooe _1c0s1ssb _15j31ssb _1npy1ssb _19he1ssb _n3vc1wug _1qj91wug _4fdy1wug _18cv1wug _1aoq15vq _1iqz15vq _6fioj63w _l0jmidpf _12zuh2mm",
            className
        ])
    }, /*#__PURE__*/ $fc4bM.createElement((0, $4mDZ7.default), {
        hideLoadingSkeleton: ui === null || ui === void 0 ? void 0 : ui.hideLoadingSkeleton,
        testId: `${testId}-image`,
        url: url,
        onError: onError,
        onLoad: onLoad,
        defaultIcon: null
    }));
};
var $8f0d4c9ffd6a9524$export$2e2bcd8739ae039 = $8f0d4c9ffd6a9524$var$MediaElement;

});


parcelRegister("cGe8i", function(module, exports) {
$parcel$export(module.exports, "default", () => $fbabdc9465f91961$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $dweer = parcelRequire("dweer");

var $dE7FH = parcelRequire("dE7FH");
const $fbabdc9465f91961$var$PriorityElement = (props)=>{
    const context = (0, $dweer.useFlexibleUiContext)();
    const data = (context === null || context === void 0 ? void 0 : context.priority) ?? null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dE7FH.default), {
        ...data,
        ...props,
        name: (0, $j9rqA.ElementName).Priority
    }) : null;
};
var $fbabdc9465f91961$export$2e2bcd8739ae039 = $fbabdc9465f91961$var$PriorityElement;

});

parcelRegister("g0ZNc", function(module, exports) {
$parcel$export(module.exports, "default", () => $b656fc40cb765e1e$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $dweer = parcelRequire("dweer");

var $dE7FH = parcelRequire("dE7FH");
var $cbIJN = parcelRequire("cbIJN");
const $b656fc40cb765e1e$var$ProgrammingLanguageElement = (props)=>{
    const context = (0, $dweer.useFlexibleUiContext)();
    const data = context ? (0, $cbIJN.toBadgeProps)(context.programmingLanguage) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dE7FH.default), {
        icon: (0, $j9rqA.IconType).ProgrammingLanguage,
        ...data,
        ...props,
        name: (0, $j9rqA.ElementName).ProgrammingLanguage
    }) : null;
};
var $b656fc40cb765e1e$export$2e2bcd8739ae039 = $b656fc40cb765e1e$var$ProgrammingLanguageElement;

});

parcelRegister("38Op4", function(module, exports) {
$parcel$export(module.exports, "default", () => $5014fed053f178bf$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $dweer = parcelRequire("dweer");

var $dE7FH = parcelRequire("dE7FH");
const $5014fed053f178bf$var$ProviderElement = (props)=>{
    const context = (0, $dweer.useFlexibleUiContext)();
    const data = (context === null || context === void 0 ? void 0 : context.provider) ?? null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dE7FH.default), {
        ...data,
        ...props,
        name: (0, $j9rqA.ElementName).Provider
    }) : null;
};
var $5014fed053f178bf$export$2e2bcd8739ae039 = $5014fed053f178bf$var$ProviderElement;

});

parcelRegister("ani8Z", function(module, exports) {
$parcel$export(module.exports, "default", () => $146f46f593bd0d80$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $dweer = parcelRequire("dweer");

var $dE7FH = parcelRequire("dE7FH");
var $cbIJN = parcelRequire("cbIJN");
const $146f46f593bd0d80$var$ReactCountElement = (props)=>{
    var _context$reactCount;
    const context = (0, $dweer.useFlexibleUiContext)();
    const data = context ? (0, $cbIJN.toBadgeProps)((_context$reactCount = context.reactCount) === null || _context$reactCount === void 0 ? void 0 : _context$reactCount.toString()) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $fc4bM.useEffect)(()=>{
        onRender === null || onRender === void 0 || onRender(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dE7FH.default), {
        icon: (0, $j9rqA.IconType).React,
        ...data,
        ...restProps,
        name: (0, $j9rqA.ElementName).ReactCount
    }) : null;
};
var $146f46f593bd0d80$export$2e2bcd8739ae039 = $146f46f593bd0d80$var$ReactCountElement;

});

parcelRegister("3ZCHY", function(module, exports) {
$parcel$export(module.exports, "default", () => $9aea22039babdaa7$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $ewFKq = parcelRequire("ewFKq");

var $dweer = parcelRequire("dweer");

var $jBxpI = parcelRequire("jBxpI");
var $i520X = parcelRequire("i520X");
const $9aea22039babdaa7$var$ReadTimeElement = (props)=>{
    const context = (0, $dweer.useFlexibleUiContext)();
    const data = context ? (0, $i520X.toFormattedTextProps)((0, $ewFKq.messages).read_time, context.readTime) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jBxpI.default), {
        ...data,
        ...props,
        name: (0, $j9rqA.ElementName).ReadTime
    }) : null;
};
var $9aea22039babdaa7$export$2e2bcd8739ae039 = $9aea22039babdaa7$var$ReadTimeElement;

});

parcelRegister("77Ihl", function(module, exports) {
$parcel$export(module.exports, "default", () => $742e12440a843a02$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $dweer = parcelRequire("dweer");

var $66cSi = parcelRequire("66cSi");
var $90A9K = parcelRequire("90A9K");
const $742e12440a843a02$var$SentOnElement = (props)=>{
    const context = (0, $dweer.useFlexibleUiContext)();
    const data = context ? (0, $90A9K.toDateTimeProps)('sent', context.sentOn) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $66cSi.default), {
        ...data,
        ...props,
        name: (0, $j9rqA.ElementName).SentOn
    }) : null;
};
var $742e12440a843a02$export$2e2bcd8739ae039 = $742e12440a843a02$var$SentOnElement;

});

parcelRegister("e1ITO", function(module, exports) {
$parcel$export(module.exports, "default", () => $654b420c7aef66c8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $dweer = parcelRequire("dweer");

var $jBxpI = parcelRequire("jBxpI");
const $654b420c7aef66c8$var$SNIPPET_DEFAULT_MAX_LINES = 3;
const $654b420c7aef66c8$var$snippetBaseStyle = null;
const $654b420c7aef66c8$var$SnippetElement = (props)=>{
    const { content: overrideContent, maxLines: maxLines = $654b420c7aef66c8$var$SNIPPET_DEFAULT_MAX_LINES, className: className, ...restOfProps } = props ?? {};
    const context = (0, $dweer.useFlexibleUiContext)();
    return /*#__PURE__*/ $fc4bM.createElement((0, $jBxpI.default), {
        content: overrideContent ?? (context === null || context === void 0 ? void 0 : context.snippet),
        maxLines: maxLines,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $2R2iS.default)([
            "_syazi7uo _1ul9idpf _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            className
        ]),
        ...restOfProps
    });
};
var $654b420c7aef66c8$export$2e2bcd8739ae039 = $654b420c7aef66c8$var$SnippetElement;

});

parcelRegister("gCCsi", function(module, exports) {
$parcel$export(module.exports, "default", () => $e6cca0ef914a2338$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $dweer = parcelRequire("dweer");

var $jBxpI = parcelRequire("jBxpI");
var $5mJEu = parcelRequire("5mJEu");
const $e6cca0ef914a2338$var$SourceBranchElement = (props)=>{
    const context = (0, $dweer.useFlexibleUiContext)();
    const data = context ? (0, $5mJEu.toTextProps)(context.sourceBranch) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jBxpI.default), {
        ...data,
        ...props,
        name: (0, $j9rqA.ElementName).SourceBranch
    }) : null;
};
var $e6cca0ef914a2338$export$2e2bcd8739ae039 = $e6cca0ef914a2338$var$SourceBranchElement;

});
parcelRegister("5mJEu", function(module, exports) {
$parcel$export(module.exports, "toTextProps", () => $e3d794f62b32ba2b$export$f12aecc78be3c7bb);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $e3d794f62b32ba2b$export$f12aecc78be3c7bb = (content)=>{
    return content ? {
        content: content
    } : undefined;
};

});


parcelRegister("7Sp0k", function(module, exports) {
$parcel$export(module.exports, "default", () => $33dcc941fb4bfcf3$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $dRkX9 = parcelRequire("dRkX9");

var $j9rqA = parcelRequire("j9rqA");

var $dweer = parcelRequire("dweer");

var $6sAht = parcelRequire("6sAht");
const $33dcc941fb4bfcf3$var$STATE_METRIC_REGEX = /^(.+?)\s+-\s+(\d+(?:\.\d+)?)$/;
const $33dcc941fb4bfcf3$var$StateElement = (props)=>{
    const context = (0, $dweer.useFlexibleUiContext)();
    const data = (context === null || context === void 0 ? void 0 : context.state) ?? null;
    const metricProps = (0, $dRkX9.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $fc4bM.useMemo)(()=>{
        if (data && typeof data.text === 'string') {
            const match = data.text.match($33dcc941fb4bfcf3$var$STATE_METRIC_REGEX);
            if (match) return {
                text: match[1],
                trailingMetric: match[2]
            };
        }
        return null;
    }, [
        data
    ]) : undefined;
    if (!data) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6sAht.default), {
        ...data,
        ...props,
        ...metricProps,
        name: (0, $j9rqA.ElementName).State
    });
};
var $33dcc941fb4bfcf3$export$2e2bcd8739ae039 = $33dcc941fb4bfcf3$var$StateElement;

});

parcelRegister("iJOnv", function(module, exports) {
$parcel$export(module.exports, "default", () => $be1fa70ca694936a$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $dweer = parcelRequire("dweer");

var $fTqZv = parcelRequire("fTqZv");
var $la2pQ = parcelRequire("la2pQ");
const $be1fa70ca694936a$var$StoryPointsElement = (props)=>{
    const context = (0, $dweer.useFlexibleUiContext)();
    const data = context ? (0, $la2pQ.toAtlaskitBadgeProps)(context.storyPoints) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fTqZv.default), {
        ...data,
        ...props,
        name: (0, $j9rqA.ElementName).StoryPoints
    }) : null;
};
var $be1fa70ca694936a$export$2e2bcd8739ae039 = $be1fa70ca694936a$var$StoryPointsElement;

});
parcelRegister("fTqZv", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ce4e454b82ed214$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $lpWRK = parcelRequire("lpWRK");
const $1ce4e454b82ed214$var$badgeStyles = null;
/**
 * A base element that displays a visual indicator for a numeric value
 * @internal
 * @see StoryPoints
 * */ const $1ce4e454b82ed214$var$BaseAtlaskitElementBadge = ({ value: value, name: name, className: className, testId: testId = 'smart-element-atlaskit-badge' })=>{
    if (!value) return null;
    return /*#__PURE__*/ $fc4bM.createElement("span", {
        "data-smart-element": name,
        "data-smart-element-atlaskit-badge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $2R2iS.default)([
            "_4cvr1h6o _1e0c116y _1ul91ns9",
            className
        ])
    }, /*#__PURE__*/ $fc4bM.createElement((0, $lpWRK.default), null, value));
};
var $1ce4e454b82ed214$export$2e2bcd8739ae039 = $1ce4e454b82ed214$var$BaseAtlaskitElementBadge;

});

parcelRegister("la2pQ", function(module, exports) {
$parcel$export(module.exports, "toAtlaskitBadgeProps", () => $a4ae2bfde565a0f1$export$731812b93bd90554);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $a4ae2bfde565a0f1$export$731812b93bd90554 = (value)=>{
    return value ? {
        value: value
    } : undefined;
};

});


parcelRegister("4e8Q0", function(module, exports) {
$parcel$export(module.exports, "default", () => $06d1b2d7216a3067$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $dweer = parcelRequire("dweer");

var $dE7FH = parcelRequire("dE7FH");
var $cbIJN = parcelRequire("cbIJN");
const $06d1b2d7216a3067$var$SubTasksProgressElement = (props)=>{
    var _context$subTasksProg;
    const context = (0, $dweer.useFlexibleUiContext)();
    const data = context ? (0, $cbIJN.toBadgeProps)((_context$subTasksProg = context.subTasksProgress) === null || _context$subTasksProg === void 0 ? void 0 : _context$subTasksProg.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dE7FH.default), {
        icon: (0, $j9rqA.IconType).SubTasksProgress,
        ...data,
        ...props,
        name: (0, $j9rqA.ElementName).SubTasksProgress
    }) : null;
};
var $06d1b2d7216a3067$export$2e2bcd8739ae039 = $06d1b2d7216a3067$var$SubTasksProgressElement;

});

parcelRegister("kzF82", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7c2ec5788f74187$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $dweer = parcelRequire("dweer");

var $dE7FH = parcelRequire("dE7FH");
var $cbIJN = parcelRequire("cbIJN");
const $d7c2ec5788f74187$var$SubscriberCountElement = (props)=>{
    var _context$subscriberCo;
    const context = (0, $dweer.useFlexibleUiContext)();
    const data = context ? (0, $cbIJN.toBadgeProps)((_context$subscriberCo = context.subscriberCount) === null || _context$subscriberCo === void 0 ? void 0 : _context$subscriberCo.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dE7FH.default), {
        icon: (0, $j9rqA.IconType).Subscriber,
        ...data,
        ...props,
        name: (0, $j9rqA.ElementName).SubscriberCount
    }) : null;
};
var $d7c2ec5788f74187$export$2e2bcd8739ae039 = $d7c2ec5788f74187$var$SubscriberCountElement;

});

parcelRegister("3tJnw", function(module, exports) {
$parcel$export(module.exports, "default", () => $64d6fb89644d9628$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $dweer = parcelRequire("dweer");

var $jBxpI = parcelRequire("jBxpI");
var $5mJEu = parcelRequire("5mJEu");
const $64d6fb89644d9628$var$TargetBranchElement = (props)=>{
    const context = (0, $dweer.useFlexibleUiContext)();
    const data = context ? (0, $5mJEu.toTextProps)(context.targetBranch) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jBxpI.default), {
        ...data,
        ...props,
        name: (0, $j9rqA.ElementName).TargetBranch
    }) : null;
};
var $64d6fb89644d9628$export$2e2bcd8739ae039 = $64d6fb89644d9628$var$TargetBranchElement;

});

parcelRegister("klqR7", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c20e31751df612a$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $ewFKq = parcelRequire("ewFKq");

var $dweer = parcelRequire("dweer");

var $jBxpI = parcelRequire("jBxpI");
var $i520X = parcelRequire("i520X");
const $0c20e31751df612a$var$MAX_TEAM_MEMBER_LIMIT = 50;
const $0c20e31751df612a$var$TeamMemberCountElement = (props)=>{
    var _context$teamMemberCo;
    const context = (0, $dweer.useFlexibleUiContext)();
    if (!(context !== null && context !== void 0 && context.teamMemberCount)) return null;
    const count = context !== null && context !== void 0 && context.teamMemberCount && (context === null || context === void 0 ? void 0 : context.teamMemberCount) > $0c20e31751df612a$var$MAX_TEAM_MEMBER_LIMIT ? `${$0c20e31751df612a$var$MAX_TEAM_MEMBER_LIMIT}+` : context === null || context === void 0 || (_context$teamMemberCo = context.teamMemberCount) === null || _context$teamMemberCo === void 0 ? void 0 : _context$teamMemberCo.toString();
    const data = count ? (0, $i520X.toFormattedTextProps)((0, $ewFKq.messages).team_members_count, count) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jBxpI.default), {
        ...data,
        ...props,
        name: (0, $j9rqA.ElementName).TeamMemberCount
    }) : null;
};
var $0c20e31751df612a$export$2e2bcd8739ae039 = $0c20e31751df612a$var$TeamMemberCountElement;

});

parcelRegister("j1vQV", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b5bc8a95f3f921d$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $ewFKq = parcelRequire("ewFKq");

var $dweer = parcelRequire("dweer");

var $jBxpI = parcelRequire("jBxpI");
var $i520X = parcelRequire("i520X");
const $7b5bc8a95f3f921d$var$UserAttributesElement = (props)=>{
    const context = (0, $dweer.useFlexibleUiContext)();
    const renderUserAttributes = (userAttributes)=>{
        if (!userAttributes) return null;
        const attributeKeys = [
            'pronouns',
            'role',
            'department',
            'location'
        ];
        const attributes = [];
        attributeKeys.forEach((key)=>{
            if (userAttributes[key]) {
                const data = (0, $i520X.toFormattedTextProps)((0, $ewFKq.messages).user_attributes, userAttributes[key]);
                if (data) attributes.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jBxpI.default), {
                    key: key,
                    ...data,
                    testId: `smart-element-text-${key}`,
                    ...props,
                    name: (0, $j9rqA.ElementName).UserAttributes
                }));
            }
        });
        return attributes.length > 0 ? attributes : null;
    };
    const elements = context ? renderUserAttributes(context.userAttributes) : null;
    return elements ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, elements) : null;
};
var $7b5bc8a95f3f921d$export$2e2bcd8739ae039 = $7b5bc8a95f3f921d$var$UserAttributesElement;

});

parcelRegister("9ZFL1", function(module, exports) {
$parcel$export(module.exports, "default", () => $38a5ec15a486a228$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $dweer = parcelRequire("dweer");

var $dE7FH = parcelRequire("dE7FH");
var $cbIJN = parcelRequire("cbIJN");
const $38a5ec15a486a228$var$ViewCountElement = (props)=>{
    var _context$viewCount;
    const context = (0, $dweer.useFlexibleUiContext)();
    const data = context ? (0, $cbIJN.toBadgeProps)((_context$viewCount = context.viewCount) === null || _context$viewCount === void 0 ? void 0 : _context$viewCount.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dE7FH.default), {
        icon: (0, $j9rqA.IconType).View,
        ...data,
        ...props,
        name: (0, $j9rqA.ElementName).ViewCount
    }) : null;
};
var $38a5ec15a486a228$export$2e2bcd8739ae039 = $38a5ec15a486a228$var$ViewCountElement;

});

parcelRegister("cAR3R", function(module, exports) {
$parcel$export(module.exports, "default", () => $85effd8a1a5c7efb$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $dweer = parcelRequire("dweer");

var $dE7FH = parcelRequire("dE7FH");
var $cbIJN = parcelRequire("cbIJN");
const $85effd8a1a5c7efb$var$VoteCountElement = (props)=>{
    var _context$voteCount;
    const context = (0, $dweer.useFlexibleUiContext)();
    const data = context ? (0, $cbIJN.toBadgeProps)((_context$voteCount = context.voteCount) === null || _context$voteCount === void 0 ? void 0 : _context$voteCount.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dE7FH.default), {
        icon: (0, $j9rqA.IconType).Vote,
        ...data,
        ...props,
        name: (0, $j9rqA.ElementName).VoteCount
    }) : null;
};
var $85effd8a1a5c7efb$export$2e2bcd8739ae039 = $85effd8a1a5c7efb$var$VoteCountElement;

});

parcelRegister("8AeTQ", function(module, exports) {
$parcel$export(module.exports, "isStyleCacheProvider", () => $018b7d5f3325ba79$export$14ff825bfe645006);
parcelRequire("fc4bM");
const $018b7d5f3325ba79$export$14ff825bfe645006 = (node)=>{
    var _node$type, _node$type2;
    if (typeof node.type !== 'string' && ((_node$type = node.type) === null || _node$type === void 0 ? void 0 : _node$type.name) === 'StyleCacheProvider' && node.props.children) return true;
    else if (typeof node.type !== 'string' && ((_node$type2 = node.type) === null || _node$type2 === void 0 ? void 0 : _node$type2.name) === 'CC' && node.props.children) return true;
    return false;
};

});


parcelRegister("2UGy7", function(module, exports) {
$parcel$export(module.exports, "default", () => $f74c9c6e5ce2c869$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $j9rqA = parcelRequire("j9rqA");

var $iZ66J = parcelRequire("iZ66J");
const $f74c9c6e5ce2c869$var$alignmentStyleMap = {
    right: "_1dthh9n0 _r291h9n0 _1bahesu3 _y3gnusic",
    left: "_1dthv2br _r291v2br _1bah1y6m _y3gn1e5h"
};
const $f74c9c6e5ce2c869$var$baseStyleBySize = {
    xlarge: "_zulpv47k _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    large: "_zulppxbi _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    medium: "_zulpu2gc _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    small: "_zulp1b66 _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf"
};
const $f74c9c6e5ce2c869$var$baseStyleByDirection = {
    horizontal: "_2lx2vrvc _4cvr1h6o",
    vertical: "_2lx21bp4 _4cvr1y6m"
};
const $f74c9c6e5ce2c869$var$baseStyles = null;
const $f74c9c6e5ce2c869$var$widthStyle = {
    flexible: "_16jlkb7n _1o9z11wp _i0dlf1ug",
    'fit-to-content': ""
};
const $f74c9c6e5ce2c869$var$positionStyle = {
    top: "_1wpz1y6m",
    center: ""
};
const $f74c9c6e5ce2c869$var$horizontalStyleBase = null;
const $f74c9c6e5ce2c869$var$horizontalStyleByHeight = {
    xlarge: "_1e0ccj1k _102k125z",
    large: "_1e0ccj1k _102k125z",
    medium: "_1e0ccj1k _102kz42d",
    small: "_1e0ccj1k _102kz42d"
};
const $f74c9c6e5ce2c869$var$gapStylesLeft = {
    xlarge: "_7yhbv47k _m6ukidpf",
    large: "_7yhbpxbi _m6ukidpf",
    medium: "_7yhbu2gc _m6ukidpf",
    small: "_7yhb1b66 _m6ukidpf"
};
const $f74c9c6e5ce2c869$var$gapStylesRight = {
    xlarge: "_24rcv47k _3dveidpf",
    large: "_24rcpxbi _3dveidpf",
    medium: "_24rcu2gc _3dveidpf",
    small: "_24rc1b66 _3dveidpf"
};
const $f74c9c6e5ce2c869$var$minWidthStyle = null;
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $f74c9c6e5ce2c869$var$ElementGroup = ({ align: align = (0, $j9rqA.SmartLinkAlignment).Left, children: children, direction: direction = (0, $j9rqA.SmartLinkDirection).Horizontal, size: size = (0, $j9rqA.SmartLinkSize).Medium, testId: testId = 'smart-element-group', width: width = (0, $j9rqA.SmartLinkWidth).FitToContent, position: position = (0, $j9rqA.SmartLinkPosition).Center, className: className })=>{
    const isHorizontal = direction === (0, $j9rqA.SmartLinkDirection).Horizontal;
    return /*#__PURE__*/ $fc4bM.createElement("div", {
        "data-smart-element-group": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $2R2iS.default)([
            $f74c9c6e5ce2c869$var$baseStyleBySize[size],
            $f74c9c6e5ce2c869$var$baseStyleByDirection[direction],
            "_fiawglyw",
            $f74c9c6e5ce2c869$var$alignmentStyleMap[align],
            "_1ul99by0",
            $f74c9c6e5ce2c869$var$widthStyle[width],
            isHorizontal && "_1reo15vq _18m915vq _1e0c1ule _s7n4nkob _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _1aaynkob _15tynkob _1iu61nu9 _166k1nu9 _1div1nu9 _bmfb1nu9",
            isHorizontal && $f74c9c6e5ce2c869$var$horizontalStyleByHeight[size],
            isHorizontal && align === (0, $j9rqA.SmartLinkAlignment).Left && $f74c9c6e5ce2c869$var$gapStylesLeft[size],
            isHorizontal && align === (0, $j9rqA.SmartLinkAlignment).Right && $f74c9c6e5ce2c869$var$gapStylesRight[size],
            $f74c9c6e5ce2c869$var$positionStyle[position],
            className
        ])
    }, (0, $iZ66J.renderChildren)(children, size));
};
var $f74c9c6e5ce2c869$export$2e2bcd8739ae039 = $f74c9c6e5ce2c869$var$ElementGroup;

});





parcelRegister("c3SUr", function(module, exports) {
$parcel$export(module.exports, "default", () => $352cf320742284a3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $dBtOK = parcelRequire("dBtOK");

var $j9rqA = parcelRequire("j9rqA");

var $4tJOd = parcelRequire("4tJOd");

var $gndj3 = parcelRequire("gndj3");

var $2UGy7 = parcelRequire("2UGy7");

var $ddON5 = parcelRequire("ddON5");
const $352cf320742284a3$var$style = null;
const $352cf320742284a3$var$styles = {
    titleBox: "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bsb1osq"
};
/**
 * This renders a fully resolved TitleBlock.
 * This should render when a Smart Link returns a valid response.
 * @see TitleBlock
 */ const $352cf320742284a3$var$TitleBlockResolvedView = ({ actionGroup: actionGroup, metadata: metadata = [], position: position, subtitle: subtitle = [], testId: testId, text: _text, icon: icon, title: title, metadataPosition: metadataPosition, hideIcon: hideIcon, CompetitorPrompt: CompetitorPrompt, url: url, hideIconLoadingSkeleton: hideIconLoadingSkeleton, ...blockProps })=>{
    const { size: size } = blockProps;
    const metadataElements = (0, $ddON5.renderElementItems)(metadata);
    const subtitleElements = (0, $ddON5.renderElementItems)(subtitle);
    return /*#__PURE__*/ $fc4bM.createElement((0, $gndj3.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`
    }, !hideIcon && /*#__PURE__*/ $fc4bM.createElement((0, $4tJOd.default), {
        overrideIcon: icon,
        position: position,
        size: size,
        hideLoadingSkeleton: hideIconLoadingSkeleton
    }), /*#__PURE__*/ $fc4bM.createElement((0, $2UGy7.default), {
        direction: (0, $j9rqA.SmartLinkDirection).Vertical,
        width: (0, $j9rqA.SmartLinkWidth).Flexible,
        size: blockProps.size,
        className: (0, $2R2iS.default)([
            "_zulp1b66"
        ])
    }, CompetitorPrompt && url ? /*#__PURE__*/ $fc4bM.createElement((0, $dBtOK.Box), {
        xcss: $352cf320742284a3$var$styles.titleBox
    }, title, /*#__PURE__*/ $fc4bM.createElement(CompetitorPrompt, {
        sourceUrl: url,
        linkType: 'card'
    })) : title, subtitleElements && /*#__PURE__*/ $fc4bM.createElement((0, $2UGy7.default), {
        direction: (0, $j9rqA.SmartLinkDirection).Horizontal
    }, subtitleElements)), metadataElements && /*#__PURE__*/ $fc4bM.createElement((0, $2UGy7.default), {
        direction: (0, $j9rqA.SmartLinkDirection).Horizontal,
        align: (0, $j9rqA.SmartLinkAlignment).Right,
        position: metadataPosition ?? (0, $j9rqA.SmartLinkPosition).Center,
        size: blockProps.size
    }, metadataElements), actionGroup);
};
var $352cf320742284a3$export$2e2bcd8739ae039 = $352cf320742284a3$var$TitleBlockResolvedView;

});
parcelRegister("ddON5", function(module, exports) {
$parcel$export(module.exports, "renderElementItems", () => $2ccd56dc56328d50$export$9678d3ca18bd7526);

var $fc4bM = parcelRequire("fc4bM");

var $fwuFz = parcelRequire("fwuFz");

var $kMGig = parcelRequire("kMGig");

var $8uHER = parcelRequire("8uHER");

var $bNuWk = parcelRequire("bNuWk");

var $fXNUY = parcelRequire("fXNUY");

var $eTjJU = parcelRequire("eTjJU");

var $9vnjG = parcelRequire("9vnjG");

var $gg4EO = parcelRequire("gg4EO");

var $2X94o = parcelRequire("2X94o");

var $3ojH0 = parcelRequire("3ojH0");

var $7QV7I = parcelRequire("7QV7I");

var $lqR91 = parcelRequire("lqR91");

var $jC3PC = parcelRequire("jC3PC");

var $4tJOd = parcelRequire("4tJOd");

var $2V9rV = parcelRequire("2V9rV");

var $b2nt7 = parcelRequire("b2nt7");

var $fXXMA = parcelRequire("fXXMA");

var $4BVlT = parcelRequire("4BVlT");

var $7E1Fn = parcelRequire("7E1Fn");

var $7L0w2 = parcelRequire("7L0w2");

var $cGe8i = parcelRequire("cGe8i");

var $g0ZNc = parcelRequire("g0ZNc");

var $38Op4 = parcelRequire("38Op4");

var $ani8Z = parcelRequire("ani8Z");

var $3ZCHY = parcelRequire("3ZCHY");

var $77Ihl = parcelRequire("77Ihl");

var $e1ITO = parcelRequire("e1ITO");

var $gCCsi = parcelRequire("gCCsi");

var $7Sp0k = parcelRequire("7Sp0k");

var $iJOnv = parcelRequire("iJOnv");

var $4e8Q0 = parcelRequire("4e8Q0");

var $kzF82 = parcelRequire("kzF82");

var $3tJnw = parcelRequire("3tJnw");

var $klqR7 = parcelRequire("klqR7");

var $1fHg5 = parcelRequire("1fHg5");

var $j1vQV = parcelRequire("j1vQV");

var $9ZFL1 = parcelRequire("9ZFL1");

var $cAR3R = parcelRequire("cAR3R");

var $ekMHB = parcelRequire("ekMHB");

var $fpSPX = parcelRequire("fpSPX");
const $2ccd56dc56328d50$var$Elements = {
    AppliedToComponentsCount: $fwuFz.default,
    AssignedTo: $kMGig.default,
    AssignedToGroup: $8uHER.default,
    AttachmentCount: $bNuWk.default,
    AuthorGroup: $fXNUY.default,
    ChecklistProgress: $eTjJU.default,
    CollaboratorGroup: $9vnjG.default,
    CommentCount: $gg4EO.default,
    CreatedBy: $2X94o.default,
    CreatedOn: $3ojH0.default,
    DueOn: $7QV7I.default,
    HostName: $lqR91.default,
    LatestCommit: $jC3PC.default,
    LinkIcon: $4tJOd.default,
    Location: $2V9rV.default,
    ModifiedBy: $b2nt7.default,
    ModifiedOn: $fXXMA.default,
    OwnedBy: $4BVlT.default,
    OwnedByGroup: $7E1Fn.default,
    Preview: $7L0w2.default,
    Priority: $cGe8i.default,
    ProgrammingLanguage: $g0ZNc.default,
    Provider: $38Op4.default,
    ReactCount: $ani8Z.default,
    ReadTime: $3ZCHY.default,
    SentOn: $77Ihl.default,
    Snippet: $e1ITO.default,
    SourceBranch: $gCCsi.default,
    State: $7Sp0k.default,
    StoryPoints: $iJOnv.default,
    SubTasksProgress: $4e8Q0.default,
    SubscriberCount: $kzF82.default,
    TargetBranch: $3tJnw.default,
    TeamMemberCount: $klqR7.default,
    Title: $1fHg5.default,
    UserAttributes: $j1vQV.default,
    ViewCount: $9ZFL1.default,
    VoteCount: $cAR3R.default
};
const $2ccd56dc56328d50$var$isElementDisplayValid = (name, display)=>{
    var _ElementDisplaySchema;
    return ((_ElementDisplaySchema = (0, $fpSPX.ElementDisplaySchema)[name]) === null || _ElementDisplaySchema === void 0 ? void 0 : _ElementDisplaySchema.includes(display)) ?? false;
};
const $2ccd56dc56328d50$export$9678d3ca18bd7526 = (items = [], display = 'inline')=>{
    const elements = items.reduce((acc, curr, idx)=>{
        const { name: name, ...props } = curr;
        const Element = $2ccd56dc56328d50$var$Elements[name];
        const typedProps = props;
        if (Element && $2ccd56dc56328d50$var$isElementDisplayValid(name, display)) {
            const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Element, {
                key: idx,
                ...typedProps
            });
            if (!(0, $ekMHB.isJSXElementNull)(element)) return [
                ...acc,
                element
            ];
        }
        return acc;
    }, []);
    if (elements.length) return elements;
};

});
parcelRegister("ekMHB", function(module, exports) {
$parcel$export(module.exports, "isJSXElementNull", () => $947e09cbdc52cfa6$export$f2c7ad0961800b16);
const $947e09cbdc52cfa6$export$f2c7ad0961800b16 = (children)=>{
    return Boolean(children.type() === null);
};

});

parcelRegister("fpSPX", function(module, exports) {
$parcel$export(module.exports, "ElementDisplaySchema", () => $d4d3b60cb48d283c$export$f942619ce67b1a41);

var $j9rqA = parcelRequire("j9rqA");
const $d4d3b60cb48d283c$export$f942619ce67b1a41 = {
    [(0, $j9rqA.ElementName).AssignedTo]: [
        'inline'
    ],
    [(0, $j9rqA.ElementName).AssignedToGroup]: [
        'inline'
    ],
    [(0, $j9rqA.ElementName).AttachmentCount]: [
        'inline'
    ],
    [(0, $j9rqA.ElementName).AuthorGroup]: [
        'inline'
    ],
    [(0, $j9rqA.ElementName).AppliedToComponentsCount]: [
        'inline'
    ],
    [(0, $j9rqA.ElementName).ChecklistProgress]: [
        'inline'
    ],
    [(0, $j9rqA.ElementName).CollaboratorGroup]: [
        'inline'
    ],
    [(0, $j9rqA.ElementName).CommentCount]: [
        'inline'
    ],
    [(0, $j9rqA.ElementName).CreatedBy]: [
        'inline'
    ],
    [(0, $j9rqA.ElementName).CreatedOn]: [
        'inline'
    ],
    [(0, $j9rqA.ElementName).DueOn]: [
        'inline'
    ],
    [(0, $j9rqA.ElementName).LatestCommit]: [
        'inline'
    ],
    [(0, $j9rqA.ElementName).LinkIcon]: [
        'inline'
    ],
    [(0, $j9rqA.ElementName).Location]: [
        'inline'
    ],
    [(0, $j9rqA.ElementName).ModifiedBy]: [
        'inline'
    ],
    [(0, $j9rqA.ElementName).ModifiedOn]: [
        'inline'
    ],
    [(0, $j9rqA.ElementName).OwnedBy]: [
        'inline'
    ],
    [(0, $j9rqA.ElementName).OwnedByGroup]: [
        'inline'
    ],
    [(0, $j9rqA.ElementName).Preview]: [
        'block'
    ],
    [(0, $j9rqA.ElementName).Priority]: [
        'inline'
    ],
    [(0, $j9rqA.ElementName).ProgrammingLanguage]: [
        'inline'
    ],
    [(0, $j9rqA.ElementName).Provider]: [
        'inline'
    ],
    [(0, $j9rqA.ElementName).ReactCount]: [
        'inline'
    ],
    [(0, $j9rqA.ElementName).ReadTime]: [
        'inline'
    ],
    [(0, $j9rqA.ElementName).Snippet]: [
        'block'
    ],
    [(0, $j9rqA.ElementName).SourceBranch]: [
        'inline'
    ],
    [(0, $j9rqA.ElementName).SentOn]: [
        'inline'
    ],
    [(0, $j9rqA.ElementName).State]: [
        'inline'
    ],
    [(0, $j9rqA.ElementName).SubscriberCount]: [
        'inline'
    ],
    [(0, $j9rqA.ElementName).TeamMemberCount]: [
        'inline'
    ],
    [(0, $j9rqA.ElementName).SubTasksProgress]: [
        'inline'
    ],
    [(0, $j9rqA.ElementName).StoryPoints]: [
        'inline'
    ],
    [(0, $j9rqA.ElementName).TargetBranch]: [
        'inline'
    ],
    [(0, $j9rqA.ElementName).Title]: [
        'inline'
    ],
    [(0, $j9rqA.ElementName).UserAttributes]: [
        'inline'
    ],
    [(0, $j9rqA.ElementName).ViewCount]: [
        'inline'
    ],
    [(0, $j9rqA.ElementName).VoteCount]: [
        'inline'
    ],
    [(0, $j9rqA.ElementName).HostName]: [
        'inline'
    ]
};

});



parcelRegister("h1UmO", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e80f96fba67b850$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $nLHJY = parcelRequire("nLHJY");

var $4tJOd = parcelRequire("4tJOd");

var $89a4S = parcelRequire("89a4S");

var $gndj3 = parcelRequire("gndj3");
/**
 * This represents a TitleBlock for a Smart Link that is currently waiting
 * for a request to finish.
 * This should render when a Smart Link has sent a request.
 * @see TitleBlock
 */ const $2e80f96fba67b850$var$TitleBlockResolvingView = ({ actionGroup: actionGroup, icon: icon, position: position, testId: testId, title: title, hideIcon: hideIcon, ...blockProps })=>{
    const { size: size = (0, $j9rqA.SmartLinkSize).Medium } = blockProps;
    const iconWidth = (0, $89a4S.getIconWidth)(size);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gndj3.default), {
        ...blockProps,
        testId: `${testId}-resolving-view`
    }, !hideIcon && icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4tJOd.default), {
        overrideIcon: icon,
        position: position,
        size: size,
        hideLoadingSkeleton: true
    }), !hideIcon && !icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("span", {
        style: {
            width: iconWidth,
            height: iconWidth
        },
        "data-testid": `${testId}-icon`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $nLHJY.LoadingSkeleton), {
        width: iconWidth,
        height: iconWidth,
        testId: `${testId}-icon-loading`
    })), title, actionGroup);
};
var $2e80f96fba67b850$export$2e2bcd8739ae039 = $2e80f96fba67b850$var$TitleBlockResolvingView;

});





parcelRegister("792wf", function(module, exports) {
$parcel$export(module.exports, "LoadingCardLink", () => $9b84abeeb96426b8$export$1ca0544321134ad6);

var $fc4bM = parcelRequire("fc4bM");

var $b8T5G = parcelRequire("b8T5G");

var $azBNw = parcelRequire("azBNw");
const $9b84abeeb96426b8$export$1ca0544321134ad6 = ({ isSelected: isSelected, url: url, placeholder: placeholder })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $azBNw.CardLinkView), {
        key: 'lazy-render-key',
        testId: 'lazy-render-placeholder',
        "data-trello-do-not-use-override": "lazy-render-placeholder-trello",
        isSelected: isSelected,
        link: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $b8T5G.loadingPlaceholderClassName),
        placeholder: placeholder
    });
};

});
parcelRegister("b8T5G", function(module, exports) {
$parcel$export(module.exports, "loadingPlaceholderClassName", () => $b906385a4330997c$export$4b2b7d155f69aed4);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $dyhNB = parcelRequire("dyhNB");
const $b906385a4330997c$export$889f1c7c5c7ba2f = 'smart-link-content-footer';
const $b906385a4330997c$export$9747a645aa1216c7 = 'smart-link-metadata-list';
const $b906385a4330997c$export$d4b64e3ae38899a3 = 'block-card-resolving-view';
const $b906385a4330997c$export$7b62853ead5e547c = 'block-card-resolved-view';
const $b906385a4330997c$export$3f9f9653bc75f33d = 'block-card-resolved-view-by';
const $b906385a4330997c$export$a21bb776ab2c28b5 = 'block-card-forbidden-view';
const $b906385a4330997c$export$e9fa69ca91e22a09 = 'block-card-forbidden-view-link';
const $b906385a4330997c$export$d17e5383afeb158c = 'block-card-content';
const $b906385a4330997c$export$8c59795ed52e92b3 = 'block-card-content-header';
const $b906385a4330997c$export$a76ed4d75b5db5f = 'block-card-content-header-name';
const $b906385a4330997c$export$7fbeca230aee4e1a = 'block-card-not-found-view';
const $b906385a4330997c$export$38dcd9bf8c681d21 = 'block-card-errored-view';
const $b906385a4330997c$export$4b2b7d155f69aed4 = 'smart-link-loading-placeholder';

});
parcelRegister("dyhNB", function(module, exports) {
$parcel$export(module.exports, "blockCardIconImageClassName", () => $f61eda7e7eb83477$export$f3ef6db93b5dfd7a);
$parcel$export(module.exports, "Icon", () => $f61eda7e7eb83477$export$f04a61298a47a40f);
/* Icon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $lig3b = parcelRequire("lig3b");

var $inMs5 = parcelRequire("inMs5");
const $f61eda7e7eb83477$export$f3ef6db93b5dfd7a = 'block-card-icon-image';
const $f61eda7e7eb83477$var$imageStyles = null;
const $f61eda7e7eb83477$var$spanStyles = null;
const $f61eda7e7eb83477$export$f04a61298a47a40f = ({ url: url, icon: icon, defaultIcon: defaultIcon, testId: testId = 'block-card-icon', isFlexibleUi: isFlexibleUi = false })=>{
    const placeholder = defaultIcon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($inMs5))), {
        label: "link",
        testId: `${testId}-default`,
        color: "currentColor"
    });
    const image = url && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lig3b))), {
        src: url,
        loaded: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("img", {
            src: url,
            alt: "",
            "data-testid": `${testId}-image`,
            className: (0, $2R2iS.default)([
                isFlexibleUi && "_4t3i7vkz _1bsb7vkz"
            ])
        }),
        errored: placeholder
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("span", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $2R2iS.default)([
            isFlexibleUi && "_4t3igktf _1bsb7vkz _1e0c1txw _4cvr1h6o _1bah1h6o",
            $f61eda7e7eb83477$export$f3ef6db93b5dfd7a
        ])
    }, icon || image || placeholder);
};

});


parcelRegister("azBNw", function(module, exports) {
$parcel$export(module.exports, "CardLinkView", () => $b8c7189226618393$export$ce508304ed2dd145);

var $fc4bM = parcelRequire("fc4bM");

var $5RUL3 = parcelRequire("5RUL3");
class $b8c7189226618393$export$ce508304ed2dd145 extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5RUL3.Frame), {
            withoutBackground: true,
            ...this.props
        }, this.props.placeholder || this.props.link);
    }
}

});
parcelRegister("5RUL3", function(module, exports) {
$parcel$export(module.exports, "Frame", () => $76fb94d35422b782$export$b89a827e9254211a);

var $fc4bM = parcelRequire("fc4bM");

var $f1474 = parcelRequire("f1474");

var $8UOG2 = parcelRequire("8UOG2");
const $76fb94d35422b782$export$b89a827e9254211a = /*#__PURE__*/ (0, $fc4bM.forwardRef)((props, ref)=>{
    const { isSelected: isSelected, children: children, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, link: link, viewType: viewType, withoutBackground: withoutBackground, testId: testId, className: className, isHovered: isHovered, truncateInline: truncateInline } = props;
    const handleClick = (0, $fc4bM.useCallback)((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, $fc4bM.useCallback)((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleMouseDown = (0, $f1474.useMouseDownEvent)();
    const isInteractive = Boolean(onClick);
    const isAnchor = Boolean(link || onClick);
    // Depending on whenever Frame was given onClick or link itself we display span or anchor elements
    const Wrapper = isAnchor ? (0, $8UOG2.WrapperAnchor) : (0, $8UOG2.WrapperSpan);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Wrapper, {
        href: link,
        withoutBackground: withoutBackground,
        isSelected: isSelected,
        isInteractive: isInteractive,
        tabIndex: isInteractive && !link ? 0 : undefined,
        role: isInteractive && !link ? 'button' : undefined,
        onClick: handleClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        onMouseDown: handleMouseDown,
        onKeyPress: handleKeyPress,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ref: ref,
        isHovered: isHovered,
        truncateInline: truncateInline,
        viewType: viewType
    }, children);
});

});
parcelRegister("8UOG2", function(module, exports) {
$parcel$export(module.exports, "WrapperSpan", () => $b139eee606f27fb2$export$8b5c95e985c4ec9a);
$parcel$export(module.exports, "WrapperAnchor", () => $b139eee606f27fb2$export$6e4bde711df5c2ab);
/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");
const $b139eee606f27fb2$export$8b5c95e985c4ec9a = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: _isInteractive, isSelected: isSelected, viewType: viewType, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("span", {
        ref: ref,
        ...props,
        className: (0, $2R2iS.default)([
            "_1yt4x7n9 _2rko1ssi _v56415x0 _1e0c1nu9 _16d9qvcn _syaz13af _1rkwglyw _4cvx1w55",
            truncateInline && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf",
            truncateInline && viewType === 'unauthorised' && "_syaz15cr",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19itia51 _bfhkhp5a _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
            isHovered && "_1h6d1w55",
            isHovered && !withoutBackground && "_4bfu1r31 _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qsw5lj _uiztglyw _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _bfw7ia51 _1nrm1r31 _c2waglyw _1iohnqa1" : "_uizt1kdv"
        ])
    }, props.children);
});
const $b139eee606f27fb2$export$6e4bde711df5c2ab = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: isInteractive, isSelected: isSelected, href: href, viewType: viewType, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("a", {
        href: href,
        ref: ref,
        ...props,
        className: (0, $2R2iS.default)([
            "_1yt4x7n9 _2rko1ssi _v56415x0 _1e0c1nu9 _16d9qvcn _syaz13af _1rkwglyw _4cvx1w55",
            truncateInline && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf",
            truncateInline && viewType === 'unauthorised' && "_syaz15cr",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19itia51 _bfhkhp5a _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
            isHovered && "_1h6d1w55",
            isHovered && !withoutBackground && "_4bfu1r31 _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qsw5lj _uiztglyw _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _bfw7ia51 _1nrm1r31 _c2waglyw _1iohnqa1" : "_uizt1kdv",
            isInteractive && "_nt751r31 _49pcglyw _1hvw1o36 _1372tlke _7ehiw5lj _1j5pglyw _1di615s3",
            viewType === 'errored' && "_4bfu1r31 _1hms8stv _ajmmnqa1 _9oik1r31 _1bnxglyw _jf4cnqa1"
        ])
    }, props.children);
});
const $b139eee606f27fb2$var$baseWrapperStyles = null;
// if the parent instruct the wrapper to be interactive, and the wrapper is in focus, apply selectedStyles
const $b139eee606f27fb2$var$interactiveStyles = null;
const $b139eee606f27fb2$var$hoveredStyles = null;
const $b139eee606f27fb2$var$hoveredWithBackgroundStyles = null;
const $b139eee606f27fb2$var$errorViewTypeStyles = null;
const $b139eee606f27fb2$var$withoutBackgroundStyles = null;
const $b139eee606f27fb2$var$withBackgroundStyles = null;
const $b139eee606f27fb2$var$truncateStyles = null;
const $b139eee606f27fb2$var$unauthorisedTruncateStyles = null;
const $b139eee606f27fb2$var$notSelectedStyle = null;
const $b139eee606f27fb2$var$selectedStyles = null;

});





//# sourceMappingURL=shared.72cf4195.js.map
